import { register } from '@onpace/onspace-core/components/translations'

register({
  "en": {
    "onspace": {
      "controller": {
        "batch": {
          "button": {
            "title": {
              "none": "Select...",
              "one": "1 selected",
              "many": "%{count} selected"
            }
          },
          "selections": {
            "select": "Select All",
            "deselect": "Clear Selection"
          }
        }
      },
      "field": {
        "base": {
          "value_placeholder": "Blank",
          "input_placeholder": "",
          "filter_placeholder": "Choose",
          "validation": {
            "required": "%{field_title} is required",
            "unique": {
              "one": "%{field_title} must be unique",
              "many": "The combination of %{field_titles} must be unique"
            },
            "array_length": {
              "exact": "%{field_title} must have %{length} items",
              "short": "%{field_title} must have %{length} or more items",
              "long": "%{field_title} must have %{length} or less items"
            },
            "rating": {
              "out_of_range": "%{field_title} must be between %{min} and %{max}"
            }
          },
          "array": {
            "add_button": "Add",
            "new_button": "Create"
          }
        },
        "association": {
          "select_placeholder": "Select",
          "array": {
            "add_button": "Choose"
          }
        },
        "boolean": {
          "true_title": "Yes",
          "false_title": "No"
        },
        "checkbox": {
          "true_title": "Yes",
          "false_title": "No"
        },
        "color": {
          "input_placeholder": "#000000",
          "validation": {
            "hexadecimal": "%{field_title} must be a 6-character hexadecimal value"
          }
        },
        "composite": {},
        "date_and_time": {
          "validation": {
            "value": {
              "short": "%{field_title} must be after %{value}",
              "long": "%{field_title} must be before %{value}"
            }
          },
          "date": {
            "input_placeholder": "YYYY-MM-DD",
            "validation": {
              "date": "%{field_title} must be a valid date"
            }
          },
          "date_time": {
            "input_placeholder": "YYYY-MM-DDTHH:MM",
            "validation": {
              "date_time": "%{field_title} must be a valid date and time"
            }
          },
          "time": {
            "input_placeholder": "HH:MM",
            "validation": {
              "time": "%{field_title} must be a valid time"
            }
          }
        },
        "enum": {
          "select_placeholder": "Select",
          "validation": {
            "choice": {
              "missing": "%{field_title} must be a valid choice"
            }
          }
        },
        "enum_conditional": {
          "select_placeholder": "Select",
          "validation": {
            "choice": {
              "missing": "%{field_title} must be a valid choice"
            }
          }
        },
        "full_name": {
          "validation": {
            "required": "Given Name or Family Name is required"
          },
          "subfield": {
            "prefix": {
              "title": "Prefix",
              "input_placeholder": "Prefix"
            },
            "given": {
              "title": "Given Name(s)",
              "input_placeholder": "Given Name(s)"
            },
            "family": {
              "title": "Family Name(s)",
              "input_placeholder": "Family Name(s)"
            },
            "suffix": {
              "title": "Suffix",
              "input_placeholder": "Suffix"
            }
          }
        },
        "geographic_coordinate": {
          "subfield": {
            "latitude": {
              "title": "Latitude",
              "input_placeholder": "Latitude"
            },
            "longitude": {
              "title": "Longitude",
              "input_placeholder": "Longitude"
            },
            "accuracy": {
              "title": "Accuracy",
              "input_placeholder": "Accuracy",
              "formatted": "accuracy"
            }
          }
        },
        "money": {
          "subfield": {
            "currency": {
              "title": "Currency",
              "select_placeholder": "Currency"
            },
            "amount": {
              "title": "Amount",
              "input_placeholder": "Amount"
            }
          }
        },
        "number": {
          "validation": {
            "value": {
              "exact": "%{field_title} must be %{value}",
              "between": "%{field_title} must be between %{min_value} and %{max_value} inclusive",
              "short": "%{field_title} must be %{value} or more",
              "long": "%{field_title} must be %{value} or less"
            },
            "digits": {
              "exact": "%{field_title} must have %{digits} digits",
              "between": "%{field_title} must have between %{min_digits} and %{max_digits} digits inclusive",
              "short": "%{field_title} must have %{digits} or more digits",
              "long": "%{field_title} must have %{digits} or less digits"
            }
          },
          "betting_odds": {
            "validation": {
              "odds": "%{field_title} must be valid decimal, fractional or moneyline odds"
            }
          },
          "decimal": {
            "validation": {
              "decimal": "%{field_title} must be a decimal number"
            }
          },
          "fraction": {
            "subfield": {
              "numerator": {
                "title": "Numerator"
              },
              "denominator": {
                "title": "Denominator",
                "validation": {
                  "value": {
                    "short": "%{field_title} must be greater than 0"
                  }
                }
              }
            }
          },
          "integer": {
            "validation": {
              "integer": "%{field_title} must be a whole number"
            }
          }
        },
        "priority": {
          "filter": {
            "with": "With Priority",
            "without": "Without Priority"
          }
        },
        "range": {
          "subfield": {
            "start": {
              "title": "Start"
            },
            "end": {
              "title": "End"
            }
          },
          "validation": {
            "range": {
              "bounds": "%{start_field_title} must be less than or equal to %{end_field_title}"
            }
          },
          "date": {
            "validation": {
              "range": {
                "bounds": "%{start_field_title} must be before or equal to %{end_field_title}"
              }
            }
          },
          "date_time": {
            "validation": {
              "range": {
                "bounds": "%{start_field_title} must be before or equal to %{end_field_title}"
              }
            }
          },
          "time": {
            "validation": {
              "range": {
                "bounds": "%{start_field_title} must be before or equal to %{end_field_title}"
              }
            }
          }
        },
        "rich_text": {
          "toolbar": {
            "heading": "Heading %{level}",
            "link_add": "Add",
            "link_remove": "Remove"
          }
        },
        "schedule": {
          "subfield": {
            "frequency": {
              "title": "Frequency",
              "choice": {
                "once": "Once",
                "hourly": "Hourly",
                "daily": "Daily",
                "weekly": "Weekly",
                "monthly": "Monthly"
              }
            },
            "weekdays": {
              "title": "Weekdays",
              "choice": {
                "0": "Sundays",
                "1": "Mondays",
                "2": "Tuesdays",
                "3": "Wednesdays",
                "4": "Thursdays",
                "5": "Fridays",
                "6": "Saturdays"
              }
            },
            "monthdays": {
              "title": "Days",
              "choice": {
                "1": "1st",
                "2": "2nd",
                "3": "3rd",
                "4": "4th",
                "5": "5th",
                "6": "6th",
                "7": "7th",
                "8": "8th",
                "9": "9th",
                "10": "10th",
                "11": "11th",
                "12": "12th",
                "13": "13th",
                "14": "14th",
                "15": "15th",
                "16": "16th",
                "17": "17th",
                "18": "18th",
                "19": "19th",
                "20": "20th",
                "21": "21st",
                "22": "22nd",
                "23": "23rd",
                "24": "24th",
                "25": "25th",
                "26": "26th",
                "27": "27th",
                "28": "28th",
                "29": "29th",
                "30": "30th",
                "31": "31st"
              }
            },
            "at_minute": {
              "title": "At Minute"
            },
            "at_time": {
              "title": "At Time"
            },
            "once": {
              "title": "At Time"
            },
            "start": {
              "title": "Start Time"
            },
            "end": {
              "title": "End Time"
            },
            "duration": {
              "title": "Duration"
            },
            "duration_unit": {
              "title": "Duration Unit",
              "choice": {
                "seconds": "Seconds",
                "minutes": "Minutes",
                "hours": "Hours"
              }
            }
          },
          "validation": {
            "start_end": {
              "bounds": "%{start_field_title} must be less than or equal to %{end_field_title}"
            },
            "duration": {
              "long_one_hour": "%{field_title} must be less than 1 hour",
              "long_one_day": "%{field_title} must be less than 24 hours"
            }
          },
          "addon": {
            "at": "At",
            "on": "On",
            "for": "For",
            "from": "From"
          },
          "formatted": {
            "once": "Once at %{datetime}",
            "hourly": "Hourly at %{minute} minutes past the hour",
            "daily": "Daily at %{time}",
            "weekly": "Weekly on %{weekdays} at %{time}",
            "monthly": "Monthly on the %{monthdays} at %{time}",
            "range": {
              "from": "From %{start}",
              "until": "Until %{end}",
              "between": "From %{start} to %{end}"
            },
            "duration": "for %{duration}"
          }
        },
        "status": {
          "state": {
            "default": {
              "draft": "Draft",
              "off": "Off",
              "off_until": "Off Until %{datetime}",
              "off_since": "Off Since %{datetime}",
              "on": "On",
              "on_until": "On Until %{datetime}",
              "on_since": "On Since %{datetime}"
            },
            "active": {
              "draft": "Draft",
              "off": "Inactive",
              "off_until": "Inactive Until %{datetime}",
              "off_since": "Inactive Since %{datetime}",
              "on": "Active",
              "on_until": "Active Until %{datetime}",
              "on_since": "Active Since %{datetime}"
            },
            "enable": {
              "draft": "Draft",
              "off": "Disabled",
              "off_until": "Disabled Until %{datetime}",
              "off_since": "Disabled Since %{datetime}",
              "on": "Enabled",
              "on_until": "Enabled Until %{datetime}",
              "on_since": "Enabled Since %{datetime}"
            },
            "publish": {
              "draft": "Draft",
              "off": "Unpublished",
              "off_until": "Unpublished Until %{datetime}",
              "off_since": "Unpublished Since %{datetime}",
              "on": "Published",
              "on_until": "Published Until %{datetime}",
              "on_since": "Published Since %{datetime}"
            }
          },
          "compact_state": {
            "default": {
              "draft": "Draft",
              "off": "Off",
              "off_until": "On Later",
              "off_since": "Off",
              "on": "On",
              "on_until": "Off Later",
              "on_since": "On"
            },
            "active": {
              "draft": "Draft",
              "off": "Inactive",
              "off_until": "Activating",
              "off_since": "Inactive",
              "on": "Active",
              "on_until": "Active",
              "on_since": "Active"
            },
            "enable": {
              "draft": "Draft",
              "off": "Disabled",
              "off_until": "Enabling",
              "off_since": "Disabled",
              "on": "Enabled",
              "on_until": "Disabling",
              "on_since": "Enabled"
            },
            "publish": {
              "draft": "Draft",
              "off": "Unpublished",
              "off_until": "Publishing",
              "off_since": "Unpublished",
              "on": "Published",
              "on_until": "Expiring",
              "on_since": "Published"
            }
          },
          "schedule": {
            "state": {
              "default": {
                "off_until": "Scheduled At %{datetime}",
                "off_until_next": "Next Scheduled At %{datetime}",
                "off_since_next": "Last Scheduled At %{datetime}"
              },
              "active": {
                "off_until": "Scheduled At %{datetime}",
                "off_until_next": "Next Scheduled At %{datetime}",
                "off_since_next": "Last Scheduled At %{datetime}"
              },
              "enable": {
                "off_until": "Scheduled At %{datetime}",
                "off_until_next": "Next Scheduled At %{datetime}",
                "off_since_next": "Last Scheduled At %{datetime}"
              },
              "publish": {
                "off_until": "Scheduled At %{datetime}",
                "off_until_next": "Next Scheduled At %{datetime}",
                "off_since_next": "Last Scheduled At %{datetime}"
              }
            },
            "compact_state": {
              "default": {
                "off_until": "Scheduled Later",
                "off_until_next": "Scheduled Later",
                "off_since_next": "Scheduled Later"
              },
              "active": {
                "off_until": "Scheduled Later",
                "off_until_next": "Scheduled Later",
                "off_since_next": "Scheduled Later"
              },
              "enable": {
                "off_until": "Scheduled Later",
                "off_until_next": "Scheduled Later",
                "off_since_next": "Scheduled Later"
              },
              "publish": {
                "off_until": "Scheduled Later",
                "off_until_next": "Scheduled Later",
                "off_since_next": "Scheduled Later"
              }
            }
          },
          "backing": {
            "default": {
              "false_title": "Off",
              "true_title": "On"
            },
            "active": {
              "false_title": "Inactive",
              "true_title": "Active"
            },
            "enable": {
              "false_title": "Disabled",
              "true_title": "Enabled"
            },
            "publish": {
              "false_title": "Unpublished",
              "true_title": "Published"
            }
          }
        },
        "street_address": {
          "subfield": {
            "autocomplete": {
              "title": "Address",
              "input_placeholder": "Search for an address",
              "error": "An unknown error occurred",
              "placeholder": "Type to search for an address",
              "empty": "No Results"
            },
            "country": {
              "title": "Country",
              "select_placeholder": "Country"
            },
            "region": {
              "title": "State/Province/Region",
              "select_placeholder": "State/Province/Region"
            },
            "postal_code": {
              "title": "Postal/Zip Code",
              "input_placeholder": "Postal/Zip Code",
              "validation": {
                "country": "%{field_title} must be valid for %{country}"
              }
            },
            "locality": {
              "title": "City/Suburb/Locality",
              "input_placeholder": "City/Suburb/Locality"
            },
            "line_one": {
              "title": "Street Line 1",
              "input_placeholder": "Street Line 1"
            },
            "line_two": {
              "title": "Street Line 2",
              "input_placeholder": "Street Line 2"
            }
          }
        },
        "telephone": {
          "subfield": {
            "country": {
              "title": "Country",
              "select_placeholder": "Country"
            },
            "number": {
              "title": "Number",
              "input_placeholder": "Number"
            }
          },
          "validation": {
            "number": {
              "invalid": "%{field_title} must be a valid telephone number"
            }
          }
        },
        "text": {
          "validation": {
            "length": {
              "exact": "%{field_title} must be %{length} characters",
              "short": "%{field_title} must be %{length} or more characters",
              "long": "%{field_title} must be %{length} or less characters"
            }
          },
          "email": {
            "input_placeholder": "email@example.com",
            "validation": {
              "email": "%{field_title} must be a valid email address"
            }
          },
          "multiline": {
            "validation": {
              "word_count": {
                "exact": "%{field_title} must be %{word_count} words",
                "short": "%{field_title} must be %{word_count} or more words",
                "long": "%{field_title} must be %{word_count} or less words"
              },
              "paragraph_count": {
                "exact": "%{field_title} must be %{paragraph_count} paragraphs",
                "short": "%{field_title} must be %{paragraph_count} or more paragraphs",
                "long": "%{field_title} must be %{paragraph_count} or less paragraphs"
              }
            }
          },
          "password": {
            "validation": {
              "characters": {
                "invalid": "%{field_title} can only contain uppercase and lowercase letters, numbers and symbols"
              },
              "lower_cases": {
                "short": "%{field_title} must have %{count} or more lowercase letters"
              },
              "upper_cases": {
                "short": "%{field_title} must have %{count} or more uppercase letters"
              },
              "digits": {
                "short": "%{field_title} must have %{count} or more digits"
              },
              "symbols": {
                "short": "%{field_title} must have %{count} or more symbols"
              }
            }
          },
          "string": {
            "validation": {
              "multiline": "%{field_title} must be a single line of text"
            }
          },
          "url": {
            "input_placeholder": "https://www.example.com",
            "validation": {
              "url": "%{field_title} must be a valid url"
            }
          },
          "url_domain": {
            "input_placeholder": "www.example.com",
            "validation": {
              "url_domain": "%{field_title} must be a valid domain name"
            }
          },
          "url_path": {
            "validation": {
              "url_path": "%{field_title} must be a valid url path"
            }
          }
        },
        "rating": {
          "icon_type": {
            "star": "⭐",
            "heart": "❤️"
          },
          "validation": {
            "rating": {
              "out_of_range": "%{field_title} must be between %{min} and %{max}"
            }
          }
        }
      },
      "navigation": {
        "form": {
          "submit_failed": "The request failed."
        },
        "form_autosave": {
          "failed": "Failed to save",
          "local_restore": "An offline draft has been found in your browser. Would you like to restore it?"
        },
        "form_unsaved": {
          "link": "Are you sure you wish to leave the page?\n\nYour unsaved changes will be lost.",
          "dialog": "Are you sure you wish to close the dialog?\n\nYour unsaved changes will be lost."
        }
      }
    },
    "country": {
      "ad": {
        "name": "Andorra",
        "calling_code": "+376",
        "region": {
          "02": {
            "name": "Canillo"
          },
          "03": {
            "name": "Encamp"
          },
          "04": {
            "name": "La Massana"
          },
          "05": {
            "name": "Ordino"
          },
          "06": {
            "name": "Sant Julià de Lòria"
          },
          "07": {
            "name": "Andorra la Vella"
          },
          "08": {
            "name": "Escaldes-Engordany"
          }
        }
      },
      "ae": {
        "name": "United Arab Emirates",
        "calling_code": "+971",
        "region": {
          "aj": {
            "name": "Ajman"
          },
          "az": {
            "name": "Abu Dhabi"
          },
          "du": {
            "name": "Dubai"
          },
          "fu": {
            "name": "Fujairah"
          },
          "rk": {
            "name": "Ras al-Khaimah"
          },
          "sh": {
            "name": "Sharjah"
          },
          "uq": {
            "name": "Umm al-Quwain"
          }
        }
      },
      "af": {
        "name": "Afghanistan",
        "calling_code": "+93",
        "region": {
          "bal": {
            "name": "Balkh"
          },
          "bam": {
            "name": "Bamyan"
          },
          "bdg": {
            "name": "Badghis"
          },
          "bds": {
            "name": "Badakhshan"
          },
          "bgl": {
            "name": "Baghlan"
          },
          "day": {
            "name": "Daykundi"
          },
          "fra": {
            "name": "Farah"
          },
          "fyb": {
            "name": "Faryab"
          },
          "gha": {
            "name": "Ghazni"
          },
          "gho": {
            "name": "Ghōr"
          },
          "hel": {
            "name": "Helmand"
          },
          "her": {
            "name": "Herat"
          },
          "jow": {
            "name": "Jowzjan"
          },
          "kab": {
            "name": "Kabul"
          },
          "kan": {
            "name": "Kandahar"
          },
          "kap": {
            "name": "Kapisa"
          },
          "kdz": {
            "name": "Kunduz"
          },
          "kho": {
            "name": "Khost"
          },
          "knr": {
            "name": "Kunar"
          },
          "lag": {
            "name": "Laghman"
          },
          "log": {
            "name": "Logar"
          },
          "nan": {
            "name": "Nangarhar"
          },
          "nim": {
            "name": "Nimruz"
          },
          "nur": {
            "name": "Nuristan"
          },
          "pan": {
            "name": "Panjshir"
          },
          "par": {
            "name": "Parwan"
          },
          "pia": {
            "name": "Paktia"
          },
          "pka": {
            "name": "Paktika"
          },
          "sam": {
            "name": "Samangan"
          },
          "sar": {
            "name": "Sar-e Pol"
          },
          "tak": {
            "name": "Takhar"
          },
          "uru": {
            "name": "Urozgan"
          },
          "war": {
            "name": "Maidan Wardak"
          },
          "zab": {
            "name": "Zabul"
          }
        }
      },
      "ag": {
        "name": "Antigua and Barbuda",
        "calling_code": "+1",
        "region": {
          "03": {
            "name": "Saint George"
          },
          "04": {
            "name": "Saint John"
          },
          "05": {
            "name": "Saint Mary"
          },
          "06": {
            "name": "Saint Paul"
          },
          "07": {
            "name": "Saint Peter"
          },
          "08": {
            "name": "Saint Philip"
          },
          "10": {
            "name": "Barbuda"
          },
          "11": {
            "name": "Redonda"
          }
        }
      },
      "ai": {
        "name": "Anguilla",
        "calling_code": "+1",
        "region": {}
      },
      "al": {
        "name": "Albania",
        "calling_code": "+355",
        "region": {
          "01": {
            "name": "Berat County"
          },
          "02": {
            "name": "Durrës County"
          },
          "03": {
            "name": "Elbasan County"
          },
          "04": {
            "name": "Fier County"
          },
          "05": {
            "name": "Gjirokastër County"
          },
          "06": {
            "name": "Korçë County"
          },
          "07": {
            "name": "Kukës County"
          },
          "08": {
            "name": "Lezhë County"
          },
          "09": {
            "name": "Dibër County"
          },
          "10": {
            "name": "Shkodër County"
          },
          "11": {
            "name": "Tirana County"
          },
          "12": {
            "name": "Vlorë County"
          }
        }
      },
      "am": {
        "name": "Armenia",
        "calling_code": "+374",
        "region": {
          "ag": {
            "name": "Aragatsotn"
          },
          "ar": {
            "name": "Ararat"
          },
          "av": {
            "name": "Armavir"
          },
          "er": {
            "name": "Yerevan"
          },
          "gr": {
            "name": "Gegharkunik"
          },
          "kt": {
            "name": "Kotayk"
          },
          "lo": {
            "name": "Lori"
          },
          "sh": {
            "name": "Shirak"
          },
          "su": {
            "name": "Syunik"
          },
          "tv": {
            "name": "Tavush"
          },
          "vd": {
            "name": "Vayots Dzor"
          }
        }
      },
      "ao": {
        "name": "Angola",
        "calling_code": "+244",
        "region": {
          "bgo": {
            "name": "Bengo"
          },
          "bgu": {
            "name": "Benguela"
          },
          "bie": {
            "name": "Bié"
          },
          "cab": {
            "name": "Cabinda"
          },
          "ccu": {
            "name": "Cuando Cubango"
          },
          "cnn": {
            "name": "Cunene"
          },
          "cno": {
            "name": "Cuanza Norte"
          },
          "cus": {
            "name": "Cuanza Sul"
          },
          "hua": {
            "name": "Huambo"
          },
          "hui": {
            "name": "Huíla"
          },
          "lno": {
            "name": "Lunda Norte"
          },
          "lsu": {
            "name": "Lunda Sul"
          },
          "lua": {
            "name": "Luanda"
          },
          "mal": {
            "name": "Malanje"
          },
          "mox": {
            "name": "Moxico"
          },
          "nam": {
            "name": "Namibe"
          },
          "uig": {
            "name": "Uíge"
          },
          "zai": {
            "name": "Zaire"
          }
        }
      },
      "aq": {
        "name": "Antarctica",
        "calling_code": "+672",
        "region": {}
      },
      "ar": {
        "name": "Argentina",
        "calling_code": "+54",
        "region": {
          "a": {
            "name": "Salta"
          },
          "b": {
            "name": "Buenos Aires Province"
          },
          "c": {
            "name": "Buenos Aires"
          },
          "d": {
            "name": "San Luis"
          },
          "e": {
            "name": "Entre Ríos"
          },
          "f": {
            "name": "La Rioja"
          },
          "g": {
            "name": "Santiago del Estero"
          },
          "h": {
            "name": "Chaco"
          },
          "j": {
            "name": "San Juan"
          },
          "k": {
            "name": "Catamarca"
          },
          "l": {
            "name": "La Pampa"
          },
          "m": {
            "name": "Mendoza"
          },
          "n": {
            "name": "Misiones"
          },
          "p": {
            "name": "Formosa"
          },
          "q": {
            "name": "Neuquén"
          },
          "r": {
            "name": "Río Negro"
          },
          "s": {
            "name": "Santa Fe"
          },
          "t": {
            "name": "Tucumán"
          },
          "u": {
            "name": "Chubut"
          },
          "v": {
            "name": "Tierra del Fuego"
          },
          "w": {
            "name": "Corrientes"
          },
          "x": {
            "name": "Córdoba"
          },
          "y": {
            "name": "Jujuy"
          },
          "z": {
            "name": "Santa Cruz"
          }
        }
      },
      "as": {
        "name": "American Samoa",
        "calling_code": "+1",
        "region": {}
      },
      "at": {
        "name": "Austria",
        "calling_code": "+43",
        "region": {
          "1": {
            "name": "Burgenland"
          },
          "2": {
            "name": "Carinthia"
          },
          "3": {
            "name": "Lower Austria"
          },
          "4": {
            "name": "Upper Austria"
          },
          "5": {
            "name": "Salzburg"
          },
          "6": {
            "name": "Styria"
          },
          "7": {
            "name": "Tyrol"
          },
          "8": {
            "name": "Vorarlberg"
          },
          "9": {
            "name": "Vienna"
          }
        }
      },
      "au": {
        "name": "Australia",
        "calling_code": "+61",
        "region": {
          "act": {
            "name": "Australian Capital Territory"
          },
          "nsw": {
            "name": "New South Wales"
          },
          "nt": {
            "name": "Northern Territory"
          },
          "qld": {
            "name": "Queensland"
          },
          "sa": {
            "name": "South Australia"
          },
          "tas": {
            "name": "Tasmania"
          },
          "vic": {
            "name": "Victoria"
          },
          "wa": {
            "name": "Western Australia"
          }
        }
      },
      "aw": {
        "name": "Aruba",
        "calling_code": "+297",
        "region": {}
      },
      "ax": {
        "name": "Åland Islands",
        "calling_code": "+358",
        "region": {}
      },
      "az": {
        "name": "Azerbaijan",
        "calling_code": "+994",
        "region": {
          "abs": {
            "name": "Absheron"
          },
          "aga": {
            "name": "Agstafa"
          },
          "agc": {
            "name": "Aghjabadi"
          },
          "agm": {
            "name": "Agdam"
          },
          "ags": {
            "name": "Agdash"
          },
          "agu": {
            "name": "Agsu"
          },
          "ast": {
            "name": "Astara"
          },
          "ba": {
            "name": "Baku"
          },
          "bab": {
            "name": "Babek"
          },
          "bal": {
            "name": "Balakan"
          },
          "bar": {
            "name": "Barda"
          },
          "bey": {
            "name": "Beylagan"
          },
          "bil": {
            "name": "Bilasuvar"
          },
          "cab": {
            "name": "Jabrayil"
          },
          "cal": {
            "name": "Jalilabad"
          },
          "cul": {
            "name": "Julfa"
          },
          "das": {
            "name": "Dashkasan"
          },
          "fuz": {
            "name": "Fizuli"
          },
          "ga": {
            "name": "Ganja"
          },
          "gad": {
            "name": "Gadabay"
          },
          "gor": {
            "name": "Goranboy"
          },
          "goy": {
            "name": "Goychay"
          },
          "gyg": {
            "name": "Goygol"
          },
          "hac": {
            "name": "Hajigabul"
          },
          "imi": {
            "name": "Imishli"
          },
          "ism": {
            "name": "Ismailli"
          },
          "kal": {
            "name": "Kalbajar"
          },
          "kan": {
            "name": "Kangarli"
          },
          "kur": {
            "name": "Kurdamir"
          },
          "la": {
            "name": "Lankaran"
          },
          "lac": {
            "name": "Lachin"
          },
          "lan": {
            "name": "Lankaran District"
          },
          "ler": {
            "name": "Lerik"
          },
          "mas": {
            "name": "Masally"
          },
          "mi": {
            "name": "Mingachevir"
          },
          "na": {
            "name": "Naftalan"
          },
          "nef": {
            "name": "Neftchala"
          },
          "nv": {
            "name": "Nakhchivan"
          },
          "nx": {
            "name": "Nakhchivan AR"
          },
          "ogu": {
            "name": "Oghuz"
          },
          "ord": {
            "name": "Ordubad"
          },
          "qab": {
            "name": "Qabala"
          },
          "qax": {
            "name": "Qakh"
          },
          "qaz": {
            "name": "Qazakh"
          },
          "qba": {
            "name": "Quba"
          },
          "qbi": {
            "name": "Qubadli"
          },
          "qob": {
            "name": "Gobustan"
          },
          "qus": {
            "name": "Qusar"
          },
          "sa": {
            "name": "Shaki"
          },
          "sab": {
            "name": "Sabirabad"
          },
          "sad": {
            "name": "Sadarak"
          },
          "sah": {
            "name": "Shahbuz"
          },
          "sak": {
            "name": "Shaki District"
          },
          "sal": {
            "name": "Salyan"
          },
          "sar": {
            "name": "Sharur"
          },
          "sat": {
            "name": "Saatly"
          },
          "sbn": {
            "name": "Shabran"
          },
          "siy": {
            "name": "Siazan"
          },
          "skr": {
            "name": "Shamkir"
          },
          "sm": {
            "name": "Sumqayit"
          },
          "smi": {
            "name": "Shamakhi"
          },
          "smx": {
            "name": "Samukh"
          },
          "sr": {
            "name": "Shirvan"
          },
          "sus": {
            "name": "Shusha"
          },
          "tar": {
            "name": "Tartar"
          },
          "tov": {
            "name": "Tovuz"
          },
          "uca": {
            "name": "Ujar"
          },
          "xa": {
            "name": "Stepanakert"
          },
          "xac": {
            "name": "Khachmaz"
          },
          "xci": {
            "name": "Khojali"
          },
          "xiz": {
            "name": "Khizi"
          },
          "xvd": {
            "name": "Khojavend"
          },
          "yar": {
            "name": "Yardymli"
          },
          "ye": {
            "name": "Yevlakh"
          },
          "yev": {
            "name": "Yevlakh District"
          },
          "zan": {
            "name": "Zangilan"
          },
          "zaq": {
            "name": "Zaqatala"
          },
          "zar": {
            "name": "Zardab"
          }
        }
      },
      "ba": {
        "name": "Bosnia and Herzegovina",
        "calling_code": "+387",
        "region": {
          "bih": {
            "name": "Federation of Bosnia and Herzegovina"
          },
          "brc": {
            "name": "Brčko District"
          },
          "srp": {
            "name": "Republika Srpska"
          }
        }
      },
      "bb": {
        "name": "Barbados",
        "calling_code": "+1",
        "region": {
          "01": {
            "name": "Christ Church"
          },
          "02": {
            "name": "Saint Andrew"
          },
          "03": {
            "name": "Saint George"
          },
          "04": {
            "name": "Saint James"
          },
          "05": {
            "name": "Saint John"
          },
          "06": {
            "name": "Saint Joseph"
          },
          "07": {
            "name": "Saint Lucy"
          },
          "08": {
            "name": "Saint Michael"
          },
          "09": {
            "name": "Saint Peter"
          },
          "10": {
            "name": "Saint Philip"
          },
          "11": {
            "name": "Saint Thomas"
          }
        }
      },
      "bd": {
        "name": "Bangladesh",
        "calling_code": "+880",
        "region": {
          "01": {
            "name": "Bandarban"
          },
          "02": {
            "name": "Barguna"
          },
          "03": {
            "name": "Bogra"
          },
          "04": {
            "name": "Brahmanbaria"
          },
          "05": {
            "name": "Bagerhat"
          },
          "06": {
            "name": "Barisal Division"
          },
          "07": {
            "name": "Bhola"
          },
          "08": {
            "name": "Comilla"
          },
          "09": {
            "name": "Chandpur"
          },
          "10": {
            "name": "Chittagong"
          },
          "11": {
            "name": "Cox’s Bazar"
          },
          "12": {
            "name": "Chuadanga"
          },
          "13": {
            "name": "Dhaka"
          },
          "14": {
            "name": "Dinajpur"
          },
          "15": {
            "name": "Faridpur"
          },
          "16": {
            "name": "Feni"
          },
          "17": {
            "name": "Gopalganj"
          },
          "18": {
            "name": "Gazipur"
          },
          "19": {
            "name": "Gaibandha"
          },
          "20": {
            "name": "Habiganj"
          },
          "21": {
            "name": "Jamalpur"
          },
          "22": {
            "name": "Jessore"
          },
          "23": {
            "name": "Jhenaidah"
          },
          "24": {
            "name": "Joypurhat"
          },
          "25": {
            "name": "Jhalokati"
          },
          "26": {
            "name": "Kishoreganj"
          },
          "27": {
            "name": "Khulna"
          },
          "28": {
            "name": "Kurigram"
          },
          "29": {
            "name": "Khagrachari"
          },
          "30": {
            "name": "Kushtia"
          },
          "31": {
            "name": "Lakshmipur"
          },
          "32": {
            "name": "Lalmonirhat"
          },
          "33": {
            "name": "Manikganj"
          },
          "34": {
            "name": "Mymensingh"
          },
          "35": {
            "name": "Munshiganj"
          },
          "36": {
            "name": "Madaripur"
          },
          "37": {
            "name": "Magura"
          },
          "38": {
            "name": "Maulvi Bazar"
          },
          "39": {
            "name": "Meherpur"
          },
          "40": {
            "name": "Narayanganj"
          },
          "41": {
            "name": "Netrokona"
          },
          "42": {
            "name": "Narsingdi"
          },
          "43": {
            "name": "Narail"
          },
          "44": {
            "name": "Natore"
          },
          "45": {
            "name": "Nawabganj"
          },
          "46": {
            "name": "Nilphamari"
          },
          "47": {
            "name": "Noakhali"
          },
          "48": {
            "name": "Naogaon"
          },
          "49": {
            "name": "Pabna"
          },
          "50": {
            "name": "Pirojpur"
          },
          "51": {
            "name": "Patuakhali"
          },
          "52": {
            "name": "Panchagarh"
          },
          "53": {
            "name": "Rajbari"
          },
          "54": {
            "name": "Rajshahi"
          },
          "55": {
            "name": "Rangpur"
          },
          "56": {
            "name": "Rangamati Hill"
          },
          "57": {
            "name": "Sherpur"
          },
          "58": {
            "name": "Satkhira"
          },
          "59": {
            "name": "Sirajganj"
          },
          "60": {
            "name": "Sylhet"
          },
          "61": {
            "name": "Sunamganj"
          },
          "62": {
            "name": "Shariatpur"
          },
          "63": {
            "name": "Tangail"
          },
          "64": {
            "name": "Thakurgaon"
          },
          "a": {
            "name": "Barisal"
          },
          "b": {
            "name": "Chittagong Division"
          },
          "c": {
            "name": "Dhaka Division"
          },
          "d": {
            "name": "Khulna Division"
          },
          "e": {
            "name": "Rajshahi Division"
          },
          "f": {
            "name": "Rangpur Division"
          },
          "g": {
            "name": "Sylhet Division"
          },
          "h": {
            "name": "Mymensingh Division"
          }
        }
      },
      "be": {
        "name": "Belgium",
        "calling_code": "+32",
        "region": {
          "bru": {
            "name": "Brussels"
          },
          "van": {
            "name": "Antwerp"
          },
          "vbr": {
            "name": "Flemish Brabant"
          },
          "vlg": {
            "name": "Flanders"
          },
          "vli": {
            "name": "Limburg"
          },
          "vov": {
            "name": "East Flanders"
          },
          "vwv": {
            "name": "West Flanders"
          },
          "wal": {
            "name": "Wallonia"
          },
          "wbr": {
            "name": "Walloon Brabant"
          },
          "wht": {
            "name": "Hainaut"
          },
          "wlg": {
            "name": "Liège"
          },
          "wlx": {
            "name": "Luxembourg"
          },
          "wna": {
            "name": "Namur"
          }
        }
      },
      "bf": {
        "name": "Burkina Faso",
        "calling_code": "+226",
        "region": {
          "01": {
            "name": "Boucle du Mouhoun"
          },
          "02": {
            "name": "Cascades"
          },
          "03": {
            "name": "Centre"
          },
          "04": {
            "name": "Centre-Est"
          },
          "05": {
            "name": "Centre-Nord"
          },
          "06": {
            "name": "Centre-Ouest"
          },
          "07": {
            "name": "Centre-Sud"
          },
          "08": {
            "name": "Est"
          },
          "09": {
            "name": "Hauts-Bassins"
          },
          "10": {
            "name": "Nord"
          },
          "11": {
            "name": "Plateau-Central"
          },
          "12": {
            "name": "Sahel"
          },
          "13": {
            "name": "Sud-Ouest"
          },
          "bal": {
            "name": "Balé"
          },
          "bam": {
            "name": "Bam"
          },
          "ban": {
            "name": "Banwa"
          },
          "baz": {
            "name": "Bazèga"
          },
          "bgr": {
            "name": "Bougouriba"
          },
          "blg": {
            "name": "Boulgou"
          },
          "blk": {
            "name": "Boulkiemdé"
          },
          "com": {
            "name": "Comoé"
          },
          "gan": {
            "name": "Ganzourgou"
          },
          "gna": {
            "name": "Gnagna"
          },
          "gou": {
            "name": "Gourma"
          },
          "hou": {
            "name": "Houet"
          },
          "iob": {
            "name": "Ioba"
          },
          "kad": {
            "name": "Kadiogo"
          },
          "ken": {
            "name": "Kénédougou"
          },
          "kmd": {
            "name": "Komondjari"
          },
          "kmp": {
            "name": "Kompienga"
          },
          "kop": {
            "name": "Koulpélogo"
          },
          "kos": {
            "name": "Kossi"
          },
          "kot": {
            "name": "Kouritenga"
          },
          "kow": {
            "name": "Kourwéogo"
          },
          "ler": {
            "name": "Léraba"
          },
          "lor": {
            "name": "Loroum"
          },
          "mou": {
            "name": "Mouhoun"
          },
          "nam": {
            "name": "Namentenga"
          },
          "nao": {
            "name": "Nahouri"
          },
          "nay": {
            "name": "Nayala"
          },
          "nou": {
            "name": "Noumbiel"
          },
          "oub": {
            "name": "Oubritenga"
          },
          "oud": {
            "name": "Oudalan"
          },
          "pas": {
            "name": "Passoré"
          },
          "pon": {
            "name": "Poni"
          },
          "sen": {
            "name": "Séno"
          },
          "sis": {
            "name": "Sissili"
          },
          "smt": {
            "name": "Sanmatenga"
          },
          "sng": {
            "name": "Sanguié"
          },
          "som": {
            "name": "Soum"
          },
          "sor": {
            "name": "Sourou"
          },
          "tap": {
            "name": "Tapoa"
          },
          "tui": {
            "name": "Tuy"
          },
          "yag": {
            "name": "Yagha"
          },
          "yat": {
            "name": "Yatenga"
          },
          "zir": {
            "name": "Ziro"
          },
          "zon": {
            "name": "Zondoma"
          },
          "zou": {
            "name": "Zoundwéogo"
          }
        }
      },
      "bg": {
        "name": "Bulgaria",
        "calling_code": "+359",
        "region": {
          "01": {
            "name": "Blagoevgrad"
          },
          "02": {
            "name": "Burgas"
          },
          "03": {
            "name": "Varna"
          },
          "04": {
            "name": "Veliko Tarnovo"
          },
          "05": {
            "name": "Vidin"
          },
          "06": {
            "name": "Vratsa"
          },
          "07": {
            "name": "Gabrovo"
          },
          "08": {
            "name": "Dobrich"
          },
          "09": {
            "name": "Kardzhali"
          },
          "10": {
            "name": "Kyustendil"
          },
          "11": {
            "name": "Lovech"
          },
          "12": {
            "name": "Montana"
          },
          "13": {
            "name": "Pazardzhik"
          },
          "14": {
            "name": "Pernik"
          },
          "15": {
            "name": "Pleven"
          },
          "16": {
            "name": "Plovdiv"
          },
          "17": {
            "name": "Razgrad"
          },
          "18": {
            "name": "Ruse"
          },
          "19": {
            "name": "Silistra"
          },
          "20": {
            "name": "Sliven"
          },
          "21": {
            "name": "Smolyan"
          },
          "22": {
            "name": "Sofia"
          },
          "23": {
            "name": "Sofia District"
          },
          "24": {
            "name": "Stara Zagora"
          },
          "25": {
            "name": "Targovishte"
          },
          "26": {
            "name": "Haskovo"
          },
          "27": {
            "name": "Shumen"
          },
          "28": {
            "name": "Yambol"
          }
        }
      },
      "bh": {
        "name": "Bahrain",
        "calling_code": "+973",
        "region": {
          "13": {
            "name": "Capital"
          },
          "14": {
            "name": "Southern"
          },
          "15": {
            "name": "Muharraq"
          },
          "17": {
            "name": "Northern"
          }
        }
      },
      "bi": {
        "name": "Burundi",
        "calling_code": "+257",
        "region": {
          "bb": {
            "name": "Bubanza"
          },
          "bj": {
            "name": "Bujumbura"
          },
          "bl": {
            "name": "Bujumbura Rural"
          },
          "bm": {
            "name": "Bujumbura"
          },
          "br": {
            "name": "Bururi"
          },
          "ca": {
            "name": "Cankuzo"
          },
          "ci": {
            "name": "Cibitoke"
          },
          "gi": {
            "name": "Gitega"
          },
          "ki": {
            "name": "Kirundo"
          },
          "kr": {
            "name": "Karuzi"
          },
          "ky": {
            "name": "Kayanza"
          },
          "ma": {
            "name": "Makamba"
          },
          "mu": {
            "name": "Muramvya"
          },
          "mw": {
            "name": "Mwaro"
          },
          "my": {
            "name": "Muyinga"
          },
          "ng": {
            "name": "Ngozi"
          },
          "rm": {
            "name": "Rumonge"
          },
          "rt": {
            "name": "Rutana"
          },
          "ry": {
            "name": "Ruyigi"
          }
        }
      },
      "bj": {
        "name": "Benin",
        "calling_code": "+229",
        "region": {
          "ak": {
            "name": "Atakora"
          },
          "al": {
            "name": "Alibori"
          },
          "aq": {
            "name": "Atlantique"
          },
          "bo": {
            "name": "Borgou"
          },
          "co": {
            "name": "Collines"
          },
          "do": {
            "name": "Donga"
          },
          "ko": {
            "name": "Kouffo"
          },
          "li": {
            "name": "Littoral"
          },
          "mo": {
            "name": "Mono"
          },
          "ou": {
            "name": "Ouémé"
          },
          "pl": {
            "name": "Plateau"
          },
          "zo": {
            "name": "Zou"
          }
        }
      },
      "bl": {
        "name": "Saint Barthélemy",
        "calling_code": "+590",
        "region": {}
      },
      "bm": {
        "name": "Bermuda",
        "calling_code": "+1",
        "region": {}
      },
      "bn": {
        "name": "Brunei Darussalam",
        "calling_code": "+673",
        "region": {
          "be": {
            "name": "Belait"
          },
          "bm": {
            "name": "Brunei-Muara"
          },
          "te": {
            "name": "Temburong"
          },
          "tu": {
            "name": "Tutong"
          }
        }
      },
      "bo": {
        "name": "Bolivia",
        "calling_code": "+591",
        "region": {
          "b": {
            "name": "Beni"
          },
          "c": {
            "name": "Cochabamba"
          },
          "h": {
            "name": "Chuquisaca"
          },
          "l": {
            "name": "La Paz"
          },
          "n": {
            "name": "Pando"
          },
          "o": {
            "name": "Oruro"
          },
          "p": {
            "name": "Potosí"
          },
          "s": {
            "name": "Santa Cruz"
          },
          "t": {
            "name": "Tarija"
          }
        }
      },
      "bq": {
        "name": "Bonaire, Sint Eustatius and Saba",
        "calling_code": "+599",
        "region": {
          "bo": {
            "name": "Bonaire"
          },
          "sa": {
            "name": "Saba"
          },
          "se": {
            "name": "Sint Eustatius"
          }
        }
      },
      "br": {
        "name": "Brazil",
        "calling_code": "+55",
        "region": {
          "ac": {
            "name": "Acre"
          },
          "al": {
            "name": "Alagoas"
          },
          "am": {
            "name": "Amazonas"
          },
          "ap": {
            "name": "Amapá"
          },
          "ba": {
            "name": "Bahia"
          },
          "ce": {
            "name": "Ceará"
          },
          "df": {
            "name": "Federal District"
          },
          "es": {
            "name": "Espírito Santo"
          },
          "go": {
            "name": "Goiás"
          },
          "ma": {
            "name": "Maranhão"
          },
          "mg": {
            "name": "Minas Gerais"
          },
          "ms": {
            "name": "Mato Grosso do Sul"
          },
          "mt": {
            "name": "Mato Grosso"
          },
          "pa": {
            "name": "Pará"
          },
          "pb": {
            "name": "Paraíba"
          },
          "pe": {
            "name": "Pernambuco"
          },
          "pi": {
            "name": "Piauí"
          },
          "pr": {
            "name": "Paraná"
          },
          "rj": {
            "name": "Rio de Janeiro"
          },
          "rn": {
            "name": "Rio Grande do Norte"
          },
          "ro": {
            "name": "Rondônia"
          },
          "rr": {
            "name": "Roraima"
          },
          "rs": {
            "name": "Rio Grande do Sul"
          },
          "sc": {
            "name": "Santa Catarina"
          },
          "se": {
            "name": "Sergipe"
          },
          "sp": {
            "name": "São Paulo"
          },
          "to": {
            "name": "Tocantins"
          }
        }
      },
      "bs": {
        "name": "Bahamas",
        "calling_code": "+1",
        "region": {
          "ak": {
            "name": "Acklins"
          },
          "bi": {
            "name": "Bimini"
          },
          "bp": {
            "name": "Black Point"
          },
          "by": {
            "name": "Berry Islands"
          },
          "ce": {
            "name": "Central Eleuthera"
          },
          "ci": {
            "name": "Cat Island"
          },
          "ck": {
            "name": "Crooked Island"
          },
          "co": {
            "name": "Central Abaco"
          },
          "cs": {
            "name": "Central Andros"
          },
          "eg": {
            "name": "East Grand Bahama"
          },
          "ex": {
            "name": "Exuma"
          },
          "fp": {
            "name": "Freeport"
          },
          "gc": {
            "name": "Grand Cay"
          },
          "hi": {
            "name": "Harbour Island"
          },
          "ht": {
            "name": "Hope Town"
          },
          "in": {
            "name": "Inagua"
          },
          "li": {
            "name": "Long Island"
          },
          "mc": {
            "name": "Mangrove Cay"
          },
          "mg": {
            "name": "Mayaguana"
          },
          "mi": {
            "name": "Moore’s Island"
          },
          "ne": {
            "name": "North Eleuthera"
          },
          "no": {
            "name": "North Abaco"
          },
          "np": {
            "name": "New Providence"
          },
          "ns": {
            "name": "North Andros"
          },
          "rc": {
            "name": "Rum Cay"
          },
          "ri": {
            "name": "Ragged Island"
          },
          "sa": {
            "name": "South Andros"
          },
          "se": {
            "name": "South Eleuthera"
          },
          "so": {
            "name": "South Abaco"
          },
          "ss": {
            "name": "San Salvador"
          },
          "sw": {
            "name": "Spanish Wells"
          },
          "wg": {
            "name": "West Grand Bahama"
          }
        }
      },
      "bt": {
        "name": "Bhutan",
        "calling_code": "+975",
        "region": {
          "11": {
            "name": "Paro"
          },
          "12": {
            "name": "Chukha"
          },
          "13": {
            "name": "Haa"
          },
          "14": {
            "name": "Samtse"
          },
          "15": {
            "name": "Thimphu"
          },
          "21": {
            "name": "Tsirang"
          },
          "22": {
            "name": "Dagana"
          },
          "23": {
            "name": "Punakha"
          },
          "24": {
            "name": "Wangdue Phodrang"
          },
          "31": {
            "name": "Sarpang"
          },
          "32": {
            "name": "Trongsa"
          },
          "33": {
            "name": "Bumthang"
          },
          "34": {
            "name": "Zhemgang"
          },
          "41": {
            "name": "Trashigang"
          },
          "42": {
            "name": "Mongar"
          },
          "43": {
            "name": "Pemagatshel"
          },
          "44": {
            "name": "Lhuntse"
          },
          "45": {
            "name": "Samdrup Jongkhar"
          },
          "ga": {
            "name": "Gasa"
          },
          "ty": {
            "name": "Trashiyangtse"
          }
        }
      },
      "bv": {
        "name": "Bouvet Island",
        "calling_code": "+47",
        "region": {}
      },
      "bw": {
        "name": "Botswana",
        "calling_code": "+267",
        "region": {
          "ce": {
            "name": "Central"
          },
          "ch": {
            "name": "Chobe"
          },
          "fr": {
            "name": "Francistown"
          },
          "ga": {
            "name": "Gaborone"
          },
          "gh": {
            "name": "Ghanzi"
          },
          "jw": {
            "name": "Jwaneng"
          },
          "kg": {
            "name": "Kgalagadi"
          },
          "kl": {
            "name": "Kgatleng"
          },
          "kw": {
            "name": "Kweneng"
          },
          "lo": {
            "name": "Lobatse"
          },
          "ne": {
            "name": "North East"
          },
          "nw": {
            "name": "North West"
          },
          "se": {
            "name": "South East"
          },
          "so": {
            "name": "Southern"
          },
          "sp": {
            "name": "Selibe Phikwe"
          },
          "st": {
            "name": "Sowa Town"
          }
        }
      },
      "by": {
        "name": "Belarus",
        "calling_code": "+375",
        "region": {
          "br": {
            "name": "Brest"
          },
          "hm": {
            "name": "Minsk"
          },
          "ho": {
            "name": "Homel"
          },
          "hr": {
            "name": "Hrodna"
          },
          "ma": {
            "name": "Magileu"
          },
          "mi": {
            "name": "Minsk Region"
          },
          "vi": {
            "name": "Vitebsk"
          }
        }
      },
      "bz": {
        "name": "Belize",
        "calling_code": "+501",
        "region": {
          "bz": {
            "name": "Belize"
          },
          "cy": {
            "name": "Cayo"
          },
          "czl": {
            "name": "Corozal"
          },
          "ow": {
            "name": "Orange Walk"
          },
          "sc": {
            "name": "Stann Creek"
          },
          "tol": {
            "name": "Toledo"
          }
        }
      },
      "ca": {
        "name": "Canada",
        "calling_code": "+1",
        "region": {
          "ab": {
            "name": "Alberta"
          },
          "bc": {
            "name": "British Columbia"
          },
          "mb": {
            "name": "Manitoba"
          },
          "nb": {
            "name": "New Brunswick"
          },
          "nl": {
            "name": "Newfoundland and Labrador"
          },
          "ns": {
            "name": "Nova Scotia"
          },
          "nt": {
            "name": "Northwest Territories"
          },
          "nu": {
            "name": "Nunavut"
          },
          "on": {
            "name": "Ontario"
          },
          "pe": {
            "name": "Prince Edward Island"
          },
          "qc": {
            "name": "Quebec"
          },
          "sk": {
            "name": "Saskatchewan"
          },
          "yt": {
            "name": "Yukon"
          }
        }
      },
      "cc": {
        "name": "Cocos (Keeling) Islands",
        "calling_code": "+61",
        "region": {}
      },
      "cd": {
        "name": "Congo, The Democratic Republic of the",
        "calling_code": "+243",
        "region": {
          "bc": {
            "name": "Bas-Congo"
          },
          "bu": {
            "name": "Bas-Uélé"
          },
          "eq": {
            "name": "Équateur"
          },
          "hk": {
            "name": "Haut-Katanga"
          },
          "hl": {
            "name": "Haut-Lomami"
          },
          "hu": {
            "name": "Haut-Uélé"
          },
          "it": {
            "name": "Ituri"
          },
          "kc": {
            "name": "Kasaï Central"
          },
          "ke": {
            "name": "Kasaï-Oriental"
          },
          "kg": {
            "name": "Kwango"
          },
          "kl": {
            "name": "Kwilu"
          },
          "kn": {
            "name": "Kinshasa"
          },
          "ks": {
            "name": "Kasaï"
          },
          "lo": {
            "name": "Lomami"
          },
          "lu": {
            "name": "Lualaba"
          },
          "ma": {
            "name": "Maniema"
          },
          "mn": {
            "name": "Mai-Ndombe"
          },
          "mo": {
            "name": "Mongala"
          },
          "nk": {
            "name": "North Kivu"
          },
          "nu": {
            "name": "Nord-Ubangi"
          },
          "sa": {
            "name": "Sankuru"
          },
          "sk": {
            "name": "South Kivu"
          },
          "su": {
            "name": "Sud-Ubangi"
          },
          "ta": {
            "name": "Tanganyika"
          },
          "to": {
            "name": "Tshopo"
          },
          "tu": {
            "name": "Tshuapa"
          }
        }
      },
      "cf": {
        "name": "Central African Republic",
        "calling_code": "+236",
        "region": {
          "ac": {
            "name": "Ouham"
          },
          "bb": {
            "name": "Bamingui-Bangoran"
          },
          "bgf": {
            "name": "Bangui"
          },
          "bk": {
            "name": "Basse-Kotto"
          },
          "hk": {
            "name": "Haute-Kotto"
          },
          "hm": {
            "name": "Haut-Mbomou"
          },
          "hs": {
            "name": "Mambéré-Kadéï"
          },
          "kb": {
            "name": "Nana-Grébizi"
          },
          "kg": {
            "name": "Kémo"
          },
          "lb": {
            "name": "Lobaye"
          },
          "mb": {
            "name": "Mbomou"
          },
          "mp": {
            "name": "Ombella-M’Poko"
          },
          "nm": {
            "name": "Nana-Mambéré"
          },
          "op": {
            "name": "Ouham-Pendé"
          },
          "se": {
            "name": "Sangha-Mbaéré"
          },
          "uk": {
            "name": "Ouaka"
          },
          "vk": {
            "name": "Vakaga"
          }
        }
      },
      "cg": {
        "name": "Congo",
        "calling_code": "+242",
        "region": {
          "11": {
            "name": "Bouenza"
          },
          "12": {
            "name": "Pool"
          },
          "13": {
            "name": "Sangha"
          },
          "14": {
            "name": "Plateaux"
          },
          "15": {
            "name": "Cuvette-Ouest"
          },
          "16": {
            "name": "Pointe-Noire"
          },
          "2": {
            "name": "Lékoumou"
          },
          "5": {
            "name": "Kouilou"
          },
          "7": {
            "name": "Likouala"
          },
          "8": {
            "name": "Cuvette"
          },
          "9": {
            "name": "Niari"
          },
          "bzv": {
            "name": "Brazzaville"
          }
        }
      },
      "ch": {
        "name": "Switzerland",
        "calling_code": "+41",
        "region": {
          "ag": {
            "name": "Aargau"
          },
          "ai": {
            "name": "Appenzell Innerrhoden"
          },
          "ar": {
            "name": "Appenzell Ausserrhoden"
          },
          "be": {
            "name": "Bern"
          },
          "bl": {
            "name": "Basel-Landschaft"
          },
          "bs": {
            "name": "Basel-Stadt"
          },
          "fr": {
            "name": "Fribourg"
          },
          "ge": {
            "name": "Geneva"
          },
          "gl": {
            "name": "Glarus"
          },
          "gr": {
            "name": "Graubünden"
          },
          "ju": {
            "name": "Jura"
          },
          "lu": {
            "name": "Lucerne"
          },
          "ne": {
            "name": "Neuchâtel"
          },
          "nw": {
            "name": "Nidwalden"
          },
          "ow": {
            "name": "Obwalden"
          },
          "sg": {
            "name": "St. Gallen"
          },
          "sh": {
            "name": "Schaffhausen"
          },
          "so": {
            "name": "Solothurn"
          },
          "sz": {
            "name": "Schwyz"
          },
          "tg": {
            "name": "Thurgau"
          },
          "ti": {
            "name": "Ticino"
          },
          "ur": {
            "name": "Uri"
          },
          "vd": {
            "name": "Vaud"
          },
          "vs": {
            "name": "Valais"
          },
          "zg": {
            "name": "Zug"
          },
          "zh": {
            "name": "Zürich"
          }
        }
      },
      "ci": {
        "name": "Côte d'Ivoire",
        "calling_code": "+225",
        "region": {
          "ab": {
            "name": "Abidjan"
          },
          "bs": {
            "name": "Bas-Sassandra²"
          },
          "cm": {
            "name": "Comoé"
          },
          "dn": {
            "name": "Denguélé²"
          },
          "gd": {
            "name": "Gôh-Djiboua"
          },
          "lc": {
            "name": "Lacs²"
          },
          "lg": {
            "name": "Lagunes²"
          },
          "mg": {
            "name": "Montagnes"
          },
          "sm": {
            "name": "Sassandra-Marahoué"
          },
          "sv": {
            "name": "Savanes"
          },
          "vb": {
            "name": "Vallée du Bandama²"
          },
          "wr": {
            "name": "Woroba"
          },
          "ym": {
            "name": "Yamoussoukro"
          },
          "zz": {
            "name": "Zanzan²"
          }
        }
      },
      "ck": {
        "name": "Cook Islands",
        "calling_code": "+682",
        "region": {}
      },
      "cl": {
        "name": "Chile",
        "calling_code": "+56",
        "region": {
          "ai": {
            "name": "Aysén"
          },
          "an": {
            "name": "Antofagasta"
          },
          "ap": {
            "name": "Arica y Parinacota"
          },
          "ar": {
            "name": "Araucanía"
          },
          "at": {
            "name": "Atacama"
          },
          "bi": {
            "name": "Bío Bío"
          },
          "co": {
            "name": "Coquimbo"
          },
          "li": {
            "name": "Libertador General Bernardo O’Higgins"
          },
          "ll": {
            "name": "Los Lagos"
          },
          "lr": {
            "name": "Los Ríos"
          },
          "ma": {
            "name": "Magallanes Region"
          },
          "ml": {
            "name": "Maule"
          },
          "nb": {
            "name": "Ñuble"
          },
          "rm": {
            "name": "Santiago Metropolitan"
          },
          "ta": {
            "name": "Tarapacá"
          },
          "vs": {
            "name": "Valparaíso"
          }
        }
      },
      "cm": {
        "name": "Cameroon",
        "calling_code": "+237",
        "region": {
          "ad": {
            "name": "Adamawa"
          },
          "ce": {
            "name": "Centre"
          },
          "en": {
            "name": "Far North"
          },
          "es": {
            "name": "East"
          },
          "lt": {
            "name": "Littoral"
          },
          "no": {
            "name": "North"
          },
          "nw": {
            "name": "Northwest"
          },
          "ou": {
            "name": "West"
          },
          "su": {
            "name": "South"
          },
          "sw": {
            "name": "Southwest"
          }
        }
      },
      "cn": {
        "name": "China",
        "calling_code": "+86",
        "region": {
          "ah": {
            "name": "Anhui"
          },
          "bj": {
            "name": "Beijing"
          },
          "cq": {
            "name": "Chongqing"
          },
          "fj": {
            "name": "Fujian"
          },
          "gd": {
            "name": "Guangdong"
          },
          "gs": {
            "name": "Gansu"
          },
          "gx": {
            "name": "Guangxi"
          },
          "gz": {
            "name": "Guizhou"
          },
          "ha": {
            "name": "Henan"
          },
          "hb": {
            "name": "Hubei"
          },
          "he": {
            "name": "Hebei"
          },
          "hi": {
            "name": "Hainan"
          },
          "hk": {
            "name": "Hong Kong"
          },
          "hl": {
            "name": "Heilongjiang"
          },
          "hn": {
            "name": "Hunan"
          },
          "jl": {
            "name": "Jilin"
          },
          "js": {
            "name": "Jiangsu"
          },
          "jx": {
            "name": "Jiangxi"
          },
          "ln": {
            "name": "Liaoning"
          },
          "mo": {
            "name": "Macau"
          },
          "nm": {
            "name": "Inner Mongolia"
          },
          "nx": {
            "name": "Ningxia"
          },
          "qh": {
            "name": "Qinghai"
          },
          "sc": {
            "name": "Sichuan"
          },
          "sd": {
            "name": "Shandong"
          },
          "sh": {
            "name": "Shanghai"
          },
          "sn": {
            "name": "Shaanxi"
          },
          "sx": {
            "name": "Shanxi"
          },
          "tj": {
            "name": "Tianjin"
          },
          "tw": {
            "name": "Taiwan"
          },
          "xj": {
            "name": "Xinjiang"
          },
          "xz": {
            "name": "Tibet"
          },
          "yn": {
            "name": "Yunnan"
          },
          "zj": {
            "name": "Zhejiang"
          }
        }
      },
      "co": {
        "name": "Colombia",
        "calling_code": "+57",
        "region": {
          "ama": {
            "name": "Amazonas"
          },
          "ant": {
            "name": "Antioquia"
          },
          "ara": {
            "name": "Arauca"
          },
          "atl": {
            "name": "Atlántico"
          },
          "bol": {
            "name": "Bolívar"
          },
          "boy": {
            "name": "Boyacá"
          },
          "cal": {
            "name": "Caldas"
          },
          "caq": {
            "name": "Caquetá"
          },
          "cas": {
            "name": "Casanare"
          },
          "cau": {
            "name": "Cauca"
          },
          "ces": {
            "name": "Cesar"
          },
          "cho": {
            "name": "Chocó"
          },
          "cor": {
            "name": "Córdoba"
          },
          "cun": {
            "name": "Cundinamarca"
          },
          "dc": {
            "name": "Capital District"
          },
          "gua": {
            "name": "Guainía"
          },
          "guv": {
            "name": "Guaviare"
          },
          "hui": {
            "name": "Huila"
          },
          "lag": {
            "name": "La Guajira"
          },
          "mag": {
            "name": "Magdalena"
          },
          "met": {
            "name": "Meta"
          },
          "nar": {
            "name": "Nariño"
          },
          "nsa": {
            "name": "Norte de Santander"
          },
          "put": {
            "name": "Putumayo"
          },
          "qui": {
            "name": "Quindío"
          },
          "ris": {
            "name": "Risaralda"
          },
          "san": {
            "name": "Santander"
          },
          "sap": {
            "name": "San Andrés & Providencia"
          },
          "suc": {
            "name": "Sucre"
          },
          "tol": {
            "name": "Tolima"
          },
          "vac": {
            "name": "Valle del Cauca"
          },
          "vau": {
            "name": "Vaupés"
          },
          "vid": {
            "name": "Vichada"
          }
        }
      },
      "cr": {
        "name": "Costa Rica",
        "calling_code": "+506",
        "region": {
          "a": {
            "name": "Alajuela"
          },
          "c": {
            "name": "Cartago"
          },
          "g": {
            "name": "Guanacaste"
          },
          "h": {
            "name": "Heredia"
          },
          "l": {
            "name": "Limón"
          },
          "p": {
            "name": "Puntarenas"
          },
          "sj": {
            "name": "San José"
          }
        }
      },
      "cu": {
        "name": "Cuba",
        "calling_code": "+53",
        "region": {
          "01": {
            "name": "Pinar del Río"
          },
          "03": {
            "name": "Havana"
          },
          "04": {
            "name": "Matanzas"
          },
          "05": {
            "name": "Villa Clara"
          },
          "06": {
            "name": "Cienfuegos"
          },
          "07": {
            "name": "Sancti Spíritus"
          },
          "08": {
            "name": "Ciego de Ávila"
          },
          "09": {
            "name": "Camagüey"
          },
          "10": {
            "name": "Las Tunas"
          },
          "11": {
            "name": "Holguín"
          },
          "12": {
            "name": "Granma"
          },
          "13": {
            "name": "Santiago de Cuba"
          },
          "14": {
            "name": "Guantánamo"
          },
          "15": {
            "name": "Artemisa"
          },
          "16": {
            "name": "Mayabeque"
          },
          "99": {
            "name": "Isla de la Juventud"
          }
        }
      },
      "cv": {
        "name": "Cabo Verde",
        "calling_code": "+238",
        "region": {
          "b": {
            "name": "Barlavento Islands"
          },
          "br": {
            "name": "Brava"
          },
          "bv": {
            "name": "Boa Vista"
          },
          "ca": {
            "name": "Santa Catarina"
          },
          "cf": {
            "name": "Santa Catarina do Fogo"
          },
          "cr": {
            "name": "Santa Cruz"
          },
          "cs": {
            "name": "Calheta de São Miguel"
          },
          "ma": {
            "name": "Maio"
          },
          "mo": {
            "name": "Mosteiros"
          },
          "pa": {
            "name": "Paul"
          },
          "pn": {
            "name": "Porto Novo"
          },
          "pr": {
            "name": "Praia"
          },
          "rb": {
            "name": "Ribeira Brava"
          },
          "rg": {
            "name": "Ribeira Grande"
          },
          "rs": {
            "name": "Ribeira Grande de Santiago"
          },
          "s": {
            "name": "Sotavento Islands"
          },
          "sd": {
            "name": "São Domingos"
          },
          "sf": {
            "name": "São Filipe"
          },
          "sl": {
            "name": "Sal"
          },
          "sm": {
            "name": "São Miguel"
          },
          "sn": {
            "name": "São Nicolau"
          },
          "so": {
            "name": "São Lourenço dos Órgãos"
          },
          "ss": {
            "name": "São Salvador do Mundo"
          },
          "sv": {
            "name": "São Vicente"
          },
          "ta": {
            "name": "Tarrafal"
          },
          "ts": {
            "name": "Tarrafal de São Nicolau"
          }
        }
      },
      "cw": {
        "name": "Curaçao",
        "calling_code": "+599",
        "region": {}
      },
      "cx": {
        "name": "Christmas Island",
        "calling_code": "+61",
        "region": {}
      },
      "cy": {
        "name": "Cyprus",
        "calling_code": "+357",
        "region": {
          "01": {
            "name": "Nicosia"
          },
          "02": {
            "name": "Limassol"
          },
          "03": {
            "name": "Larnaca"
          },
          "04": {
            "name": "Famagusta"
          },
          "05": {
            "name": "Paphos"
          },
          "06": {
            "name": "Kyrenia"
          }
        }
      },
      "cz": {
        "name": "Czechia",
        "calling_code": "+420",
        "region": {
          "10": {
            "name": "Prague, Hlavní mešto"
          },
          "20": {
            "name": "Středočeský"
          },
          "201": {
            "name": "Benešov"
          },
          "202": {
            "name": "Beroun"
          },
          "203": {
            "name": "Kladno"
          },
          "204": {
            "name": "Kolín"
          },
          "205": {
            "name": "Kutná Hora"
          },
          "206": {
            "name": "Mělník"
          },
          "207": {
            "name": "Mladá Boleslav"
          },
          "208": {
            "name": "Nymburk"
          },
          "209": {
            "name": "Prague-East"
          },
          "20a": {
            "name": "Prague-West"
          },
          "20b": {
            "name": "Příbram"
          },
          "20c": {
            "name": "Rakovník"
          },
          "31": {
            "name": "Jihočeský"
          },
          "311": {
            "name": "České Budějovice"
          },
          "312": {
            "name": "Český Krumlov"
          },
          "313": {
            "name": "Jindřichův Hradec"
          },
          "314": {
            "name": "Písek"
          },
          "315": {
            "name": "Prachatice"
          },
          "316": {
            "name": "Strakonice"
          },
          "317": {
            "name": "Tábor"
          },
          "32": {
            "name": "Plzeňský"
          },
          "321": {
            "name": "Domažlice"
          },
          "322": {
            "name": "Klatovy"
          },
          "323": {
            "name": "Plzeň"
          },
          "324": {
            "name": "Plzeň-South"
          },
          "325": {
            "name": "Plzeň-North"
          },
          "326": {
            "name": "Rokycany"
          },
          "327": {
            "name": "Tachov"
          },
          "41": {
            "name": "Karlovarský"
          },
          "411": {
            "name": "Cheb"
          },
          "412": {
            "name": "Karlovy Vary"
          },
          "413": {
            "name": "Sokolov"
          },
          "42": {
            "name": "Ústecký"
          },
          "421": {
            "name": "Děčín"
          },
          "422": {
            "name": "Chomutov"
          },
          "423": {
            "name": "Litoměřice"
          },
          "424": {
            "name": "Louny"
          },
          "425": {
            "name": "Most"
          },
          "426": {
            "name": "Teplice"
          },
          "427": {
            "name": "Ústí nad Labem"
          },
          "51": {
            "name": "Liberecký"
          },
          "511": {
            "name": "Česká Lípa"
          },
          "512": {
            "name": "Jablonec nad Nisou"
          },
          "513": {
            "name": "Liberec"
          },
          "514": {
            "name": "Semily"
          },
          "52": {
            "name": "Královéhradecký"
          },
          "521": {
            "name": "Hradec Králové"
          },
          "522": {
            "name": "Jičín"
          },
          "523": {
            "name": "Náchod"
          },
          "524": {
            "name": "Rychnov nad Kněžnou"
          },
          "525": {
            "name": "Trutnov"
          },
          "53": {
            "name": "Pardubický"
          },
          "531": {
            "name": "Chrudim"
          },
          "532": {
            "name": "Pardubice"
          },
          "533": {
            "name": "Svitavy"
          },
          "534": {
            "name": "Ústí nad Orlicí"
          },
          "63": {
            "name": "Vysočina"
          },
          "631": {
            "name": "Havlíčkův Brod"
          },
          "632": {
            "name": "Jihlava"
          },
          "633": {
            "name": "Pelhřimov"
          },
          "634": {
            "name": "Třebíč"
          },
          "635": {
            "name": "Žďár nad Sázavou"
          },
          "64": {
            "name": "Jihomoravský"
          },
          "641": {
            "name": "Blansko"
          },
          "642": {
            "name": "Brno-město"
          },
          "643": {
            "name": "Brno-venkov"
          },
          "644": {
            "name": "Břeclav"
          },
          "645": {
            "name": "Hodonín"
          },
          "646": {
            "name": "Vyškov"
          },
          "647": {
            "name": "Znojmo"
          },
          "71": {
            "name": "Olomoucký"
          },
          "711": {
            "name": "Jeseník"
          },
          "712": {
            "name": "Olomouc"
          },
          "713": {
            "name": "Prostějov"
          },
          "714": {
            "name": "Přerov"
          },
          "715": {
            "name": "Šumperk"
          },
          "72": {
            "name": "Zlínský"
          },
          "721": {
            "name": "Kroměříž"
          },
          "722": {
            "name": "Uherské Hradiště"
          },
          "723": {
            "name": "Vsetín"
          },
          "724": {
            "name": "Zlín"
          },
          "80": {
            "name": "Moravskoslezský"
          },
          "801": {
            "name": "Bruntál"
          },
          "802": {
            "name": "Frýdek-Místek"
          },
          "803": {
            "name": "Karviná"
          },
          "804": {
            "name": "Nový Jičín"
          },
          "805": {
            "name": "Opava"
          },
          "806": {
            "name": "Ostrava"
          }
        }
      },
      "de": {
        "name": "Germany",
        "calling_code": "+49",
        "region": {
          "bb": {
            "name": "Brandenburg"
          },
          "be": {
            "name": "Berlin"
          },
          "bw": {
            "name": "Baden-Württemberg"
          },
          "by": {
            "name": "Bavaria"
          },
          "hb": {
            "name": "Bremen"
          },
          "he": {
            "name": "Hesse"
          },
          "hh": {
            "name": "Hamburg"
          },
          "mv": {
            "name": "Mecklenburg-Vorpommern"
          },
          "ni": {
            "name": "Lower Saxony"
          },
          "nw": {
            "name": "North Rhine-Westphalia"
          },
          "rp": {
            "name": "Rhineland-Palatinate"
          },
          "sh": {
            "name": "Schleswig-Holstein"
          },
          "sl": {
            "name": "Saarland"
          },
          "sn": {
            "name": "Saxony"
          },
          "st": {
            "name": "Saxony-Anhalt"
          },
          "th": {
            "name": "Thuringia"
          }
        }
      },
      "dj": {
        "name": "Djibouti",
        "calling_code": "+253",
        "region": {
          "ar": {
            "name": "Arta"
          },
          "as": {
            "name": "Ali Sabieh"
          },
          "di": {
            "name": "Dikhil"
          },
          "dj": {
            "name": "Djibouti"
          },
          "ob": {
            "name": "Obock"
          },
          "ta": {
            "name": "Tadjourah"
          }
        }
      },
      "dk": {
        "name": "Denmark",
        "calling_code": "+45",
        "region": {
          "81": {
            "name": "Northern Denmark"
          },
          "82": {
            "name": "Central Denmark"
          },
          "83": {
            "name": "Southern Denmark"
          },
          "84": {
            "name": "Capital Region"
          },
          "85": {
            "name": "Zealand"
          }
        }
      },
      "dm": {
        "name": "Dominica",
        "calling_code": "+1",
        "region": {
          "02": {
            "name": "Saint Andrew"
          },
          "03": {
            "name": "Saint David"
          },
          "04": {
            "name": "Saint George"
          },
          "05": {
            "name": "Saint John"
          },
          "06": {
            "name": "Saint Joseph"
          },
          "07": {
            "name": "Saint Luke"
          },
          "08": {
            "name": "Saint Mark"
          },
          "09": {
            "name": "Saint Patrick"
          },
          "10": {
            "name": "Saint Paul"
          },
          "11": {
            "name": "Saint Peter"
          }
        }
      },
      "do": {
        "name": "Dominican Republic",
        "calling_code": "+1",
        "region": {
          "01": {
            "name": "Distrito Nacional"
          },
          "02": {
            "name": "Azua"
          },
          "03": {
            "name": "Baoruco"
          },
          "04": {
            "name": "Barahona"
          },
          "05": {
            "name": "Dajabón"
          },
          "06": {
            "name": "Duarte"
          },
          "07": {
            "name": "Elías Piña"
          },
          "08": {
            "name": "El Seibo"
          },
          "09": {
            "name": "Espaillat"
          },
          "10": {
            "name": "Independencia"
          },
          "11": {
            "name": "La Altagracia"
          },
          "12": {
            "name": "La Romana"
          },
          "13": {
            "name": "La Vega"
          },
          "14": {
            "name": "María Trinidad Sánchez"
          },
          "15": {
            "name": "Monte Cristi"
          },
          "16": {
            "name": "Pedernales"
          },
          "17": {
            "name": "Peravia"
          },
          "18": {
            "name": "Puerto Plata"
          },
          "19": {
            "name": "Hermanas Mirabal"
          },
          "20": {
            "name": "Samaná"
          },
          "21": {
            "name": "San Cristóbal"
          },
          "22": {
            "name": "San Juan"
          },
          "23": {
            "name": "San Pedro de Macorís"
          },
          "24": {
            "name": "Sánchez Ramírez"
          },
          "25": {
            "name": "Santiago"
          },
          "26": {
            "name": "Santiago Rodríguez"
          },
          "27": {
            "name": "Valverde"
          },
          "28": {
            "name": "Monseñor Nouel"
          },
          "29": {
            "name": "Monte Plata"
          },
          "30": {
            "name": "Hato Mayor"
          },
          "31": {
            "name": "San José de Ocoa"
          },
          "32": {
            "name": "Santo Domingo"
          },
          "33": {
            "name": "Cibao Nordeste"
          },
          "34": {
            "name": "Cibao Noroeste"
          },
          "35": {
            "name": "Cibao Norte"
          },
          "36": {
            "name": "Cibao Sur"
          },
          "37": {
            "name": "El Valle"
          },
          "38": {
            "name": "Enriquillo"
          },
          "39": {
            "name": "Higüamo"
          },
          "40": {
            "name": "Ozama"
          },
          "41": {
            "name": "Valdesia"
          },
          "42": {
            "name": "Yuma"
          }
        }
      },
      "dz": {
        "name": "Algeria",
        "calling_code": "+213",
        "region": {
          "01": {
            "name": "Adrar"
          },
          "02": {
            "name": "Chlef"
          },
          "03": {
            "name": "Laghouat"
          },
          "04": {
            "name": "Oum El Bouaghi"
          },
          "05": {
            "name": "Batna"
          },
          "06": {
            "name": "Béjaïa"
          },
          "07": {
            "name": "Biskra"
          },
          "08": {
            "name": "Béchar"
          },
          "09": {
            "name": "Blida"
          },
          "10": {
            "name": "Bouira"
          },
          "11": {
            "name": "Tamanghasset"
          },
          "12": {
            "name": "Tébessa"
          },
          "13": {
            "name": "Tlemcen"
          },
          "14": {
            "name": "Tiaret"
          },
          "15": {
            "name": "Tizi Ouzou"
          },
          "16": {
            "name": "Algiers"
          },
          "17": {
            "name": "Djelfa"
          },
          "18": {
            "name": "Jijel"
          },
          "19": {
            "name": "Sétif"
          },
          "20": {
            "name": "Saïda"
          },
          "21": {
            "name": "Skikda"
          },
          "22": {
            "name": "Sidi Bel Abbès"
          },
          "23": {
            "name": "Annaba"
          },
          "24": {
            "name": "Guelma"
          },
          "25": {
            "name": "Constantine"
          },
          "26": {
            "name": "Médéa"
          },
          "27": {
            "name": "Mostaganem"
          },
          "28": {
            "name": "M’Sila"
          },
          "29": {
            "name": "Mascara"
          },
          "30": {
            "name": "Ouargla"
          },
          "31": {
            "name": "Oran"
          },
          "32": {
            "name": "El Bayadh"
          },
          "33": {
            "name": "Illizi"
          },
          "34": {
            "name": "Bordj Bou Arréridj"
          },
          "35": {
            "name": "Boumerdès"
          },
          "36": {
            "name": "El Tarf"
          },
          "37": {
            "name": "Tindouf"
          },
          "38": {
            "name": "Tissemsilt"
          },
          "39": {
            "name": "El Oued"
          },
          "40": {
            "name": "Khenchela"
          },
          "41": {
            "name": "Souk Ahras"
          },
          "42": {
            "name": "Tipasa"
          },
          "43": {
            "name": "Mila"
          },
          "44": {
            "name": "Aïn Defla"
          },
          "45": {
            "name": "Naama"
          },
          "46": {
            "name": "Aïn Témouchent"
          },
          "47": {
            "name": "Ghardaïa"
          },
          "48": {
            "name": "Relizane"
          }
        }
      },
      "ec": {
        "name": "Ecuador",
        "calling_code": "+593",
        "region": {
          "a": {
            "name": "Azuay"
          },
          "b": {
            "name": "Bolívar"
          },
          "c": {
            "name": "Carchi"
          },
          "d": {
            "name": "Orellana"
          },
          "e": {
            "name": "Esmeraldas"
          },
          "f": {
            "name": "Cañar"
          },
          "g": {
            "name": "Guayas"
          },
          "h": {
            "name": "Chimborazo"
          },
          "i": {
            "name": "Imbabura"
          },
          "l": {
            "name": "Loja"
          },
          "m": {
            "name": "Manabí"
          },
          "n": {
            "name": "Napo"
          },
          "o": {
            "name": "El Oro"
          },
          "p": {
            "name": "Pichincha"
          },
          "r": {
            "name": "Los Ríos"
          },
          "s": {
            "name": "Morona-Santiago"
          },
          "sd": {
            "name": "Santo Domingo de los Tsáchilas"
          },
          "se": {
            "name": "Santa Elena"
          },
          "t": {
            "name": "Tungurahua"
          },
          "u": {
            "name": "Sucumbíos"
          },
          "w": {
            "name": "Galápagos"
          },
          "x": {
            "name": "Cotopaxi"
          },
          "y": {
            "name": "Pastaza"
          },
          "z": {
            "name": "Zamora-Chinchipe"
          }
        }
      },
      "ee": {
        "name": "Estonia",
        "calling_code": "+372",
        "region": {
          "130": {
            "name": "Alutaguse"
          },
          "141": {
            "name": "Anija"
          },
          "142": {
            "name": "Antsla"
          },
          "171": {
            "name": "Elva"
          },
          "184": {
            "name": "Haapsalu"
          },
          "191": {
            "name": "Haljala"
          },
          "198": {
            "name": "Harku"
          },
          "205": {
            "name": "Hiiumaa"
          },
          "214": {
            "name": "Häädemeeste"
          },
          "245": {
            "name": "Jõelähtme"
          },
          "247": {
            "name": "Jõgeva"
          },
          "251": {
            "name": "Jõhvi"
          },
          "255": {
            "name": "Järva"
          },
          "272": {
            "name": "Kadrina"
          },
          "283": {
            "name": "Kambja"
          },
          "284": {
            "name": "Kanepi"
          },
          "291": {
            "name": "Kastre"
          },
          "293": {
            "name": "Kehtna"
          },
          "296": {
            "name": "Keila"
          },
          "303": {
            "name": "Kihnu"
          },
          "305": {
            "name": "Kiili"
          },
          "317": {
            "name": "Kohila"
          },
          "321": {
            "name": "Kohtla-Järve"
          },
          "338": {
            "name": "Kose"
          },
          "353": {
            "name": "Kuusalu"
          },
          "37": {
            "name": "Harju"
          },
          "39": {
            "name": "Hiiu"
          },
          "424": {
            "name": "Loksa"
          },
          "430": {
            "name": "Lääneranna"
          },
          "431": {
            "name": "Lääne-Harju"
          },
          "432": {
            "name": "Luunja"
          },
          "441": {
            "name": "Lääne-Nigula"
          },
          "442": {
            "name": "Lüganuse"
          },
          "446": {
            "name": "Maardu"
          },
          "45": {
            "name": "Ida-Virumaa"
          },
          "478": {
            "name": "Muhu"
          },
          "480": {
            "name": "Mulgi"
          },
          "486": {
            "name": "Mustvee"
          },
          "50": {
            "name": "Jõgevamaa"
          },
          "503": {
            "name": "Märjamaa"
          },
          "511": {
            "name": "Narva"
          },
          "514": {
            "name": "Narva-Jõesuu"
          },
          "52": {
            "name": "Järvamaa"
          },
          "528": {
            "name": "Nõo"
          },
          "557": {
            "name": "Otepää"
          },
          "56": {
            "name": "Läänemaa"
          },
          "567": {
            "name": "Paide"
          },
          "586": {
            "name": "Peipsiääre"
          },
          "60": {
            "name": "Lääne-Virumaa"
          },
          "615": {
            "name": "Põhja-Sakala"
          },
          "618": {
            "name": "Põltsamaa"
          },
          "622": {
            "name": "Põlva"
          },
          "624": {
            "name": "Pärnu"
          },
          "638": {
            "name": "Põhja-Pärnumaa"
          },
          "64": {
            "name": "Põlvamaa"
          },
          "651": {
            "name": "Raasiku"
          },
          "653": {
            "name": "Rae"
          },
          "661": {
            "name": "Rakvere"
          },
          "663": {
            "name": "Rakvere"
          },
          "668": {
            "name": "Rapla"
          },
          "68": {
            "name": "Pärnumaa"
          },
          "689": {
            "name": "Ruhnu"
          },
          "698": {
            "name": "Rõuge"
          },
          "708": {
            "name": "Räpina"
          },
          "71": {
            "name": "Raplamaa"
          },
          "712": {
            "name": "Saarde"
          },
          "714": {
            "name": "Saaremaa"
          },
          "719": {
            "name": "Saku"
          },
          "726": {
            "name": "Saue"
          },
          "732": {
            "name": "Setomaa"
          },
          "735": {
            "name": "Sillamäe"
          },
          "74": {
            "name": "Saare"
          },
          "784": {
            "name": "Tallinn"
          },
          "79": {
            "name": "Tartumaa"
          },
          "792": {
            "name": "Tapa"
          },
          "793": {
            "name": "Tartu"
          },
          "796": {
            "name": "Tartu"
          },
          "803": {
            "name": "Toila"
          },
          "809": {
            "name": "Tori"
          },
          "81": {
            "name": "Valgamaa"
          },
          "824": {
            "name": "Tõrva"
          },
          "834": {
            "name": "Türi"
          },
          "84": {
            "name": "Viljandi"
          },
          "855": {
            "name": "Valga"
          },
          "87": {
            "name": "Võrumaa"
          },
          "890": {
            "name": "Viimsi"
          },
          "897": {
            "name": "Viljandi"
          },
          "899": {
            "name": "Viljandi"
          },
          "901": {
            "name": "Vinni"
          },
          "903": {
            "name": "Viru-Nigula"
          },
          "907": {
            "name": "Vormsi"
          },
          "917": {
            "name": "Võru"
          },
          "919": {
            "name": "Võru"
          },
          "928": {
            "name": "Väike-Maarja"
          }
        }
      },
      "eg": {
        "name": "Egypt",
        "calling_code": "+20",
        "region": {
          "alx": {
            "name": "Alexandria"
          },
          "asn": {
            "name": "Aswan"
          },
          "ast": {
            "name": "Asyut"
          },
          "ba": {
            "name": "Red Sea"
          },
          "bh": {
            "name": "Beheira"
          },
          "bns": {
            "name": "Beni Suef"
          },
          "c": {
            "name": "Cairo"
          },
          "dk": {
            "name": "Dakahlia"
          },
          "dt": {
            "name": "Damietta"
          },
          "fym": {
            "name": "Faiyum"
          },
          "gh": {
            "name": "Gharbia"
          },
          "gz": {
            "name": "Giza"
          },
          "is": {
            "name": "Ismailia"
          },
          "js": {
            "name": "South Sinai"
          },
          "kb": {
            "name": "Qalyubia"
          },
          "kfs": {
            "name": "Kafr el-Sheikh"
          },
          "kn": {
            "name": "Qena"
          },
          "lx": {
            "name": "Luxor"
          },
          "mn": {
            "name": "Minya"
          },
          "mnf": {
            "name": "Monufia"
          },
          "mt": {
            "name": "Matrouh"
          },
          "pts": {
            "name": "Port Said"
          },
          "shg": {
            "name": "Sohag"
          },
          "shr": {
            "name": "Al Sharqia"
          },
          "sin": {
            "name": "North Sinai"
          },
          "suz": {
            "name": "Suez"
          },
          "wad": {
            "name": "New Valley"
          }
        }
      },
      "eh": {
        "name": "Western Sahara",
        "calling_code": "+212",
        "region": {}
      },
      "er": {
        "name": "Eritrea",
        "calling_code": "+291",
        "region": {
          "an": {
            "name": "Anseba"
          },
          "dk": {
            "name": "Southern Red Sea"
          },
          "du": {
            "name": "Debub"
          },
          "gb": {
            "name": "Gash-Barka"
          },
          "ma": {
            "name": "Maekel"
          },
          "sk": {
            "name": "Northern Red Sea"
          }
        }
      },
      "es": {
        "name": "Spain",
        "calling_code": "+34",
        "region": {
          "a": {
            "name": "Alicante"
          },
          "ab": {
            "name": "Albacete"
          },
          "al": {
            "name": "Almería"
          },
          "an": {
            "name": "Andalusia"
          },
          "ar": {
            "name": "Aragon"
          },
          "as": {
            "name": "Asturias"
          },
          "av": {
            "name": "Ávila"
          },
          "b": {
            "name": "Barcelona"
          },
          "ba": {
            "name": "Badajoz"
          },
          "bi": {
            "name": "Biscay"
          },
          "bu": {
            "name": "Burgos"
          },
          "c": {
            "name": "A Coruña"
          },
          "ca": {
            "name": "Cádiz"
          },
          "cb": {
            "name": "Cantabria"
          },
          "cc": {
            "name": "Cáceres"
          },
          "ce": {
            "name": "Ceuta"
          },
          "cl": {
            "name": "Castile and León"
          },
          "cm": {
            "name": "Castile-La Mancha"
          },
          "cn": {
            "name": "Canary Islands"
          },
          "co": {
            "name": "Córdoba"
          },
          "cr": {
            "name": "Ciudad Real"
          },
          "cs": {
            "name": "Castellón"
          },
          "ct": {
            "name": "Catalonia"
          },
          "cu": {
            "name": "Cuenca"
          },
          "ex": {
            "name": "Extremadura"
          },
          "ga": {
            "name": "Galicia"
          },
          "gc": {
            "name": "Las Palmas"
          },
          "gi": {
            "name": "Girona"
          },
          "gr": {
            "name": "Granada"
          },
          "gu": {
            "name": "Guadalajara"
          },
          "h": {
            "name": "Huelva"
          },
          "hu": {
            "name": "Huesca"
          },
          "ib": {
            "name": "Balearic Islands"
          },
          "j": {
            "name": "Jaén"
          },
          "l": {
            "name": "Lleida"
          },
          "le": {
            "name": "León"
          },
          "lo": {
            "name": "La Rioja Province"
          },
          "lu": {
            "name": "Lugo"
          },
          "m": {
            "name": "Madrid Province"
          },
          "ma": {
            "name": "Málaga"
          },
          "mc": {
            "name": "Murcia Region"
          },
          "md": {
            "name": "Madrid Autonomous Community"
          },
          "ml": {
            "name": "Melilla"
          },
          "mu": {
            "name": "Murcia"
          },
          "na": {
            "name": "Navarra"
          },
          "nc": {
            "name": "Navarra Chartered Community"
          },
          "o": {
            "name": "Asturias Province"
          },
          "or": {
            "name": "Ourense"
          },
          "p": {
            "name": "Palencia"
          },
          "pm": {
            "name": "Balears Province"
          },
          "po": {
            "name": "Pontevedra"
          },
          "pv": {
            "name": "Basque Country"
          },
          "ri": {
            "name": "La Rioja"
          },
          "s": {
            "name": "Cantabria Province"
          },
          "sa": {
            "name": "Salamanca"
          },
          "se": {
            "name": "Seville"
          },
          "sg": {
            "name": "Segovia"
          },
          "so": {
            "name": "Soria"
          },
          "ss": {
            "name": "Gipuzkoa"
          },
          "t": {
            "name": "Tarragona"
          },
          "te": {
            "name": "Teruel"
          },
          "tf": {
            "name": "Santa Cruz de Tenerife"
          },
          "to": {
            "name": "Toledo"
          },
          "v": {
            "name": "Valencia"
          },
          "va": {
            "name": "Valladolid"
          },
          "vc": {
            "name": "Valencian Community"
          },
          "vi": {
            "name": "Álava"
          },
          "z": {
            "name": "Zaragoza"
          },
          "za": {
            "name": "Zamora"
          }
        }
      },
      "et": {
        "name": "Ethiopia",
        "calling_code": "+251",
        "region": {
          "aa": {
            "name": "Addis Ababa"
          },
          "af": {
            "name": "Afar"
          },
          "am": {
            "name": "Amhara"
          },
          "be": {
            "name": "Benishangul-Gumuz"
          },
          "dd": {
            "name": "Dire Dawa"
          },
          "ga": {
            "name": "Gambela"
          },
          "ha": {
            "name": "Harari"
          },
          "or": {
            "name": "Oromia"
          },
          "sn": {
            "name": "Southern Nations, Nationalities, and Peoples"
          },
          "so": {
            "name": "Somali"
          },
          "ti": {
            "name": "Tigray"
          }
        }
      },
      "fi": {
        "name": "Finland",
        "calling_code": "+358",
        "region": {
          "01": {
            "name": "Åland Islands"
          },
          "02": {
            "name": "South Karelia"
          },
          "03": {
            "name": "Southern Ostrobothnia"
          },
          "04": {
            "name": "Southern Savonia"
          },
          "05": {
            "name": "Kainuu"
          },
          "06": {
            "name": "Tavastia Proper"
          },
          "07": {
            "name": "Central Ostrobothnia"
          },
          "08": {
            "name": "Central Finland"
          },
          "09": {
            "name": "Kymenlaakso"
          },
          "10": {
            "name": "Lapland"
          },
          "11": {
            "name": "Pirkanmaa"
          },
          "12": {
            "name": "Ostrobothnia"
          },
          "13": {
            "name": "North Karelia"
          },
          "14": {
            "name": "Northern Ostrobothnia"
          },
          "15": {
            "name": "Northern Savonia"
          },
          "16": {
            "name": "Päijänne Tavastia"
          },
          "17": {
            "name": "Satakunta"
          },
          "18": {
            "name": "Uusimaa"
          },
          "19": {
            "name": "Southwest Finland"
          }
        }
      },
      "fj": {
        "name": "Fiji",
        "calling_code": "+679",
        "region": {
          "01": {
            "name": "Ba"
          },
          "02": {
            "name": "Bua"
          },
          "03": {
            "name": "Cakaudrove"
          },
          "04": {
            "name": "Kadavu"
          },
          "05": {
            "name": "Lau"
          },
          "06": {
            "name": "Lomaiviti"
          },
          "07": {
            "name": "Macuata"
          },
          "08": {
            "name": "Nadroga-Navosa"
          },
          "09": {
            "name": "Naitasiri"
          },
          "10": {
            "name": "Namosi"
          },
          "11": {
            "name": "Ra"
          },
          "12": {
            "name": "Rewa"
          },
          "13": {
            "name": "Serua"
          },
          "14": {
            "name": "Tailevu"
          },
          "c": {
            "name": "Central"
          },
          "e": {
            "name": "Eastern"
          },
          "n": {
            "name": "Northern"
          },
          "r": {
            "name": "Rotuma"
          },
          "w": {
            "name": "Western"
          }
        }
      },
      "fk": {
        "name": "Falkland Islands (Malvinas)",
        "calling_code": "+500",
        "region": {}
      },
      "fm": {
        "name": "Micronesia, Federated States of",
        "calling_code": "+691",
        "region": {
          "ksa": {
            "name": "Kosrae"
          },
          "pni": {
            "name": "Pohnpei"
          },
          "trk": {
            "name": "Chuuk"
          },
          "yap": {
            "name": "Yap"
          }
        }
      },
      "fo": {
        "name": "Faroe Islands",
        "calling_code": "+298",
        "region": {}
      },
      "fr": {
        "name": "France",
        "calling_code": "+33",
        "region": {
          "01": {
            "name": "Ain"
          },
          "02": {
            "name": "Aisne"
          },
          "03": {
            "name": "Allier"
          },
          "04": {
            "name": "Alpes-de-Haute-Provence"
          },
          "05": {
            "name": "Hautes-Alpes"
          },
          "06": {
            "name": "Alpes-Maritimes"
          },
          "07": {
            "name": "Ardèche"
          },
          "08": {
            "name": "Ardennes"
          },
          "09": {
            "name": "Ariège"
          },
          "10": {
            "name": "Aube"
          },
          "11": {
            "name": "Aude"
          },
          "12": {
            "name": "Aveyron"
          },
          "13": {
            "name": "Bouches-du-Rhône"
          },
          "14": {
            "name": "Calvados"
          },
          "15": {
            "name": "Cantal"
          },
          "16": {
            "name": "Charente"
          },
          "17": {
            "name": "Charente-Maritime"
          },
          "18": {
            "name": "Cher"
          },
          "19": {
            "name": "Corrèze"
          },
          "20r": {
            "name": "Corsica"
          },
          "21": {
            "name": "Côte-d’Or"
          },
          "22": {
            "name": "Côtes-d’Armor"
          },
          "23": {
            "name": "Creuse"
          },
          "24": {
            "name": "Dordogne"
          },
          "25": {
            "name": "Doubs"
          },
          "26": {
            "name": "Drôme"
          },
          "27": {
            "name": "Eure"
          },
          "28": {
            "name": "Eure-et-Loir"
          },
          "29": {
            "name": "Finistère"
          },
          "2a": {
            "name": "Corse-du-Sud"
          },
          "2b": {
            "name": "Haute-Corse"
          },
          "30": {
            "name": "Gard"
          },
          "31": {
            "name": "Haute-Garonne"
          },
          "32": {
            "name": "Gers"
          },
          "33": {
            "name": "Gironde"
          },
          "34": {
            "name": "Hérault"
          },
          "35": {
            "name": "Ille-et-Vilaine"
          },
          "36": {
            "name": "Indre"
          },
          "37": {
            "name": "Indre-et-Loire"
          },
          "38": {
            "name": "Isère"
          },
          "39": {
            "name": "Jura"
          },
          "40": {
            "name": "Landes"
          },
          "41": {
            "name": "Loir-et-Cher"
          },
          "42": {
            "name": "Loire"
          },
          "43": {
            "name": "Haute-Loire"
          },
          "44": {
            "name": "Loire-Atlantique"
          },
          "45": {
            "name": "Loiret"
          },
          "46": {
            "name": "Lot"
          },
          "47": {
            "name": "Lot-et-Garonne"
          },
          "48": {
            "name": "Lozère"
          },
          "49": {
            "name": "Maine-et-Loire"
          },
          "50": {
            "name": "Manche"
          },
          "51": {
            "name": "Marne"
          },
          "52": {
            "name": "Haute-Marne"
          },
          "53": {
            "name": "Mayenne"
          },
          "54": {
            "name": "Meurthe-et-Moselle"
          },
          "55": {
            "name": "Meuse"
          },
          "56": {
            "name": "Morbihan"
          },
          "57": {
            "name": "Moselle"
          },
          "58": {
            "name": "Nièvre"
          },
          "59": {
            "name": "Nord"
          },
          "60": {
            "name": "Oise"
          },
          "61": {
            "name": "Orne"
          },
          "62": {
            "name": "Pas-de-Calais"
          },
          "63": {
            "name": "Puy-de-Dôme"
          },
          "64": {
            "name": "Pyrénées-Atlantiques"
          },
          "65": {
            "name": "Hautes-Pyrénées"
          },
          "66": {
            "name": "Pyrénées-Orientales"
          },
          "67": {
            "name": "Bas-Rhin"
          },
          "68": {
            "name": "Haut-Rhin"
          },
          "69": {
            "name": "Rhône"
          },
          "69m": {
            "name": "Lyon Metropolis"
          },
          "6ae": {
            "name": "Alsace"
          },
          "70": {
            "name": "Haute-Saône"
          },
          "71": {
            "name": "Saône-et-Loire"
          },
          "72": {
            "name": "Sarthe"
          },
          "73": {
            "name": "Savoie"
          },
          "74": {
            "name": "Haute-Savoie"
          },
          "75c": {
            "name": "Paris"
          },
          "76": {
            "name": "Seine-Maritime"
          },
          "77": {
            "name": "Seine-et-Marne"
          },
          "78": {
            "name": "Yvelines"
          },
          "79": {
            "name": "Deux-Sèvres"
          },
          "80": {
            "name": "Somme"
          },
          "81": {
            "name": "Tarn"
          },
          "82": {
            "name": "Tarn-et-Garonne"
          },
          "83": {
            "name": "Var"
          },
          "84": {
            "name": "Vaucluse"
          },
          "85": {
            "name": "Vendée"
          },
          "86": {
            "name": "Vienne"
          },
          "87": {
            "name": "Haute-Vienne"
          },
          "88": {
            "name": "Vosges"
          },
          "89": {
            "name": "Yonne"
          },
          "90": {
            "name": "Territoire de Belfort"
          },
          "91": {
            "name": "Essonne"
          },
          "92": {
            "name": "Hauts-de-Seine"
          },
          "93": {
            "name": "Seine-Saint-Denis"
          },
          "94": {
            "name": "Val-de-Marne"
          },
          "95": {
            "name": "Val-d’Oise"
          },
          "971": {
            "name": "Guadeloupe"
          },
          "972": {
            "name": "Martinique"
          },
          "973": {
            "name": "French Guiana"
          },
          "974": {
            "name": "La Réunion"
          },
          "976": {
            "name": "Mayotte"
          },
          "ara": {
            "name": "Auvergne-Rhône-Alpes"
          },
          "bfc": {
            "name": "Burgundy-Franche-Comté"
          },
          "bl": {
            "name": "Saint Barthélemy"
          },
          "bre": {
            "name": "Brittany"
          },
          "cp": {
            "name": "Clipperton Island"
          },
          "cvl": {
            "name": "Centre-Val de Loire"
          },
          "ges": {
            "name": "Grand-Est"
          },
          "hdf": {
            "name": "Hauts-de-France"
          },
          "idf": {
            "name": "Île-de-France"
          },
          "mf": {
            "name": "St. Martin"
          },
          "naq": {
            "name": "Nouvelle-Aquitaine"
          },
          "nc": {
            "name": "New Caledonia"
          },
          "nor": {
            "name": "Normandie"
          },
          "occ": {
            "name": "Occitanie"
          },
          "pac": {
            "name": "Provence-Alpes-Côte-d’Azur"
          },
          "pdl": {
            "name": "Pays-de-la-Loire"
          },
          "pf": {
            "name": "French Polynesia"
          },
          "pm": {
            "name": "St. Pierre & Miquelon"
          },
          "tf": {
            "name": "French Southern Territories"
          },
          "wf": {
            "name": "Wallis & Futuna"
          }
        }
      },
      "ga": {
        "name": "Gabon",
        "calling_code": "+241",
        "region": {
          "1": {
            "name": "Estuaire"
          },
          "2": {
            "name": "Haut-Ogooué"
          },
          "3": {
            "name": "Moyen-Ogooué"
          },
          "4": {
            "name": "Ngounié"
          },
          "5": {
            "name": "Nyanga"
          },
          "6": {
            "name": "Ogooué-Ivindo"
          },
          "7": {
            "name": "Ogooué-Lolo"
          },
          "8": {
            "name": "Ogooué-Maritime"
          },
          "9": {
            "name": "Woleu-Ntem"
          }
        }
      },
      "gb": {
        "name": "United Kingdom",
        "calling_code": "+44",
        "region": {
          "abc": {
            "name": "Armagh, Banbridge and Craigavon"
          },
          "abd": {
            "name": "Aberdeenshire"
          },
          "abe": {
            "name": "Aberdeen"
          },
          "agb": {
            "name": "Argyll and Bute"
          },
          "agy": {
            "name": "Anglesey"
          },
          "and": {
            "name": "Ards and North Down"
          },
          "ann": {
            "name": "Antrim and Newtownabbey"
          },
          "ans": {
            "name": "Angus"
          },
          "bas": {
            "name": "Bath and North East Somerset"
          },
          "bbd": {
            "name": "Blackburn with Darwen"
          },
          "bcp": {
            "name": "Bournemouth, Christchurch and Poole"
          },
          "bdf": {
            "name": "Bedford"
          },
          "bdg": {
            "name": "Barking and Dagenham"
          },
          "ben": {
            "name": "Brent"
          },
          "bex": {
            "name": "Bexley"
          },
          "bfs": {
            "name": "Belfast"
          },
          "bge": {
            "name": "Bridgend"
          },
          "bgw": {
            "name": "Blaenau Gwent"
          },
          "bir": {
            "name": "Birmingham"
          },
          "bkm": {
            "name": "Buckinghamshire"
          },
          "bne": {
            "name": "Barnet"
          },
          "bnh": {
            "name": "Brighton and Hove"
          },
          "bns": {
            "name": "Barnsley"
          },
          "bol": {
            "name": "Bolton"
          },
          "bpl": {
            "name": "Blackpool"
          },
          "brc": {
            "name": "Bracknell Forest"
          },
          "brd": {
            "name": "Bradford"
          },
          "bry": {
            "name": "Bromley"
          },
          "bst": {
            "name": "Bristol"
          },
          "bur": {
            "name": "Bury"
          },
          "cam": {
            "name": "Cambridgeshire"
          },
          "cay": {
            "name": "Caerphilly"
          },
          "cbf": {
            "name": "Central Bedfordshire"
          },
          "ccg": {
            "name": "Causeway Coast and Glens"
          },
          "cgn": {
            "name": "Ceredigion"
          },
          "che": {
            "name": "Cheshire East"
          },
          "chw": {
            "name": "Cheshire West and Chester"
          },
          "cld": {
            "name": "Calderdale"
          },
          "clk": {
            "name": "Clackmannanshire"
          },
          "cma": {
            "name": "Cumbria"
          },
          "cmd": {
            "name": "Camden"
          },
          "cmn": {
            "name": "Carmarthenshire"
          },
          "con": {
            "name": "Cornwall"
          },
          "cov": {
            "name": "Coventry"
          },
          "crf": {
            "name": "Cardiff"
          },
          "cry": {
            "name": "Croydon"
          },
          "cwy": {
            "name": "Conwy"
          },
          "dal": {
            "name": "Darlington"
          },
          "dby": {
            "name": "Derbyshire"
          },
          "den": {
            "name": "Denbighshire"
          },
          "der": {
            "name": "Derby"
          },
          "dev": {
            "name": "Devon"
          },
          "dgy": {
            "name": "Dumfries and Galloway"
          },
          "dnc": {
            "name": "Doncaster"
          },
          "dnd": {
            "name": "Dundee"
          },
          "dor": {
            "name": "Dorset"
          },
          "drs": {
            "name": "Derry and Strabane"
          },
          "dud": {
            "name": "Dudley"
          },
          "dur": {
            "name": "Durham"
          },
          "eal": {
            "name": "Ealing"
          },
          "eay": {
            "name": "East Ayrshire"
          },
          "edh": {
            "name": "Edinburgh"
          },
          "edu": {
            "name": "East Dunbartonshire"
          },
          "eln": {
            "name": "East Lothian"
          },
          "els": {
            "name": "Outer Hebrides"
          },
          "enf": {
            "name": "Enfield"
          },
          "eng": {
            "name": "England"
          },
          "erw": {
            "name": "East Renfrewshire"
          },
          "ery": {
            "name": "East Riding of Yorkshire"
          },
          "ess": {
            "name": "Essex"
          },
          "esx": {
            "name": "East Sussex"
          },
          "fal": {
            "name": "Falkirk"
          },
          "fif": {
            "name": "Fife"
          },
          "fln": {
            "name": "Flintshire"
          },
          "fmo": {
            "name": "Fermanagh and Omagh"
          },
          "gat": {
            "name": "Gateshead"
          },
          "glg": {
            "name": "Glasgow"
          },
          "gls": {
            "name": "Gloucestershire"
          },
          "gre": {
            "name": "Greenwich"
          },
          "gwn": {
            "name": "Gwynedd"
          },
          "hal": {
            "name": "Halton"
          },
          "ham": {
            "name": "Hampshire"
          },
          "hav": {
            "name": "Havering"
          },
          "hck": {
            "name": "Hackney"
          },
          "hef": {
            "name": "Herefordshire"
          },
          "hil": {
            "name": "Hillingdon"
          },
          "hld": {
            "name": "Highland"
          },
          "hmf": {
            "name": "Hammersmith and Fulham"
          },
          "hns": {
            "name": "Hounslow"
          },
          "hpl": {
            "name": "Hartlepool"
          },
          "hrt": {
            "name": "Hertfordshire"
          },
          "hrw": {
            "name": "Harrow"
          },
          "hry": {
            "name": "Haringey"
          },
          "ios": {
            "name": "Isles of Scilly"
          },
          "iow": {
            "name": "Isle of Wight"
          },
          "isl": {
            "name": "Islington"
          },
          "ivc": {
            "name": "Inverclyde"
          },
          "kec": {
            "name": "Kensington and Chelsea"
          },
          "ken": {
            "name": "Kent"
          },
          "khl": {
            "name": "Kingston upon Hull"
          },
          "kir": {
            "name": "Kirklees"
          },
          "ktt": {
            "name": "Kingston upon Thames"
          },
          "kwl": {
            "name": "Knowsley"
          },
          "lan": {
            "name": "Lancashire"
          },
          "lbc": {
            "name": "Lisburn and Castlereagh"
          },
          "lbh": {
            "name": "Lambeth"
          },
          "lce": {
            "name": "Leicester"
          },
          "lds": {
            "name": "Leeds"
          },
          "lec": {
            "name": "Leicestershire"
          },
          "lew": {
            "name": "Lewisham"
          },
          "lin": {
            "name": "Lincolnshire"
          },
          "liv": {
            "name": "Liverpool"
          },
          "lnd": {
            "name": "London"
          },
          "lut": {
            "name": "Luton"
          },
          "man": {
            "name": "Manchester"
          },
          "mdb": {
            "name": "Middlesbrough"
          },
          "mdw": {
            "name": "Medway"
          },
          "mea": {
            "name": "Mid and East Antrim"
          },
          "mik": {
            "name": "Milton Keynes"
          },
          "mln": {
            "name": "Midlothian"
          },
          "mon": {
            "name": "Monmouthshire"
          },
          "mrt": {
            "name": "Merton"
          },
          "mry": {
            "name": "Moray"
          },
          "mty": {
            "name": "Merthyr Tydfil"
          },
          "mul": {
            "name": "Mid Ulster"
          },
          "nay": {
            "name": "North Ayrshire"
          },
          "nbl": {
            "name": "Northumberland"
          },
          "nel": {
            "name": "North East Lincolnshire"
          },
          "net": {
            "name": "Newcastle upon Tyne"
          },
          "nfk": {
            "name": "Norfolk"
          },
          "ngm": {
            "name": "Nottingham"
          },
          "nir": {
            "name": "Northern Ireland"
          },
          "nlk": {
            "name": "North Lanarkshire"
          },
          "nln": {
            "name": "North Lincolnshire"
          },
          "nmd": {
            "name": "Newry, Mourne and Down"
          },
          "nsm": {
            "name": "North Somerset"
          },
          "nth": {
            "name": "Northamptonshire"
          },
          "ntl": {
            "name": "Neath Port Talbot"
          },
          "ntt": {
            "name": "Nottinghamshire"
          },
          "nty": {
            "name": "North Tyneside"
          },
          "nwm": {
            "name": "Newham"
          },
          "nwp": {
            "name": "Newport"
          },
          "nyk": {
            "name": "North Yorkshire"
          },
          "old": {
            "name": "Oldham"
          },
          "ork": {
            "name": "Orkney Islands"
          },
          "oxf": {
            "name": "Oxfordshire"
          },
          "pem": {
            "name": "Pembrokeshire"
          },
          "pkn": {
            "name": "Perth and Kinross"
          },
          "ply": {
            "name": "Plymouth"
          },
          "por": {
            "name": "Portsmouth"
          },
          "pow": {
            "name": "Powys"
          },
          "pte": {
            "name": "Peterborough"
          },
          "rcc": {
            "name": "Redcar and Cleveland"
          },
          "rch": {
            "name": "Rochdale"
          },
          "rct": {
            "name": "Rhondda Cynon Taf"
          },
          "rdb": {
            "name": "Redbridge"
          },
          "rdg": {
            "name": "Reading"
          },
          "rfw": {
            "name": "Renfrewshire"
          },
          "ric": {
            "name": "Richmond upon Thames"
          },
          "rot": {
            "name": "Rotherham"
          },
          "rut": {
            "name": "Rutland"
          },
          "saw": {
            "name": "Sandwell"
          },
          "say": {
            "name": "South Ayrshire"
          },
          "scb": {
            "name": "Scottish Borders"
          },
          "sct": {
            "name": "Scotland"
          },
          "sfk": {
            "name": "Suffolk"
          },
          "sft": {
            "name": "Sefton"
          },
          "sgc": {
            "name": "South Gloucestershire"
          },
          "shf": {
            "name": "Sheffield"
          },
          "shn": {
            "name": "Saint Helens"
          },
          "shr": {
            "name": "Shropshire"
          },
          "skp": {
            "name": "Stockport"
          },
          "slf": {
            "name": "Salford"
          },
          "slg": {
            "name": "Slough"
          },
          "slk": {
            "name": "South Lanarkshire"
          },
          "snd": {
            "name": "Sunderland"
          },
          "sol": {
            "name": "Solihull"
          },
          "som": {
            "name": "Somerset"
          },
          "sos": {
            "name": "Southend-on-Sea"
          },
          "sry": {
            "name": "Surrey"
          },
          "ste": {
            "name": "Stoke-on-Trent"
          },
          "stg": {
            "name": "Stirling"
          },
          "sth": {
            "name": "Southampton"
          },
          "stn": {
            "name": "Sutton"
          },
          "sts": {
            "name": "Staffordshire"
          },
          "stt": {
            "name": "Stockton-on-Tees"
          },
          "sty": {
            "name": "South Tyneside"
          },
          "swa": {
            "name": "Swansea"
          },
          "swd": {
            "name": "Swindon"
          },
          "swk": {
            "name": "Southwark"
          },
          "tam": {
            "name": "Tameside"
          },
          "tfw": {
            "name": "Telford and Wrekin"
          },
          "thr": {
            "name": "Thurrock"
          },
          "tob": {
            "name": "Torbay"
          },
          "tof": {
            "name": "Torfaen"
          },
          "trf": {
            "name": "Trafford"
          },
          "twh": {
            "name": "Tower Hamlets"
          },
          "vgl": {
            "name": "Vale of Glamorgan"
          },
          "war": {
            "name": "Warwickshire"
          },
          "wbk": {
            "name": "West Berkshire"
          },
          "wdu": {
            "name": "West Dunbartonshire"
          },
          "wft": {
            "name": "Waltham Forest"
          },
          "wgn": {
            "name": "Wigan"
          },
          "wil": {
            "name": "Wiltshire"
          },
          "wkf": {
            "name": "Wakefield"
          },
          "wll": {
            "name": "Walsall"
          },
          "wln": {
            "name": "West Lothian"
          },
          "wls": {
            "name": "Wales"
          },
          "wlv": {
            "name": "Wolverhampton"
          },
          "wnd": {
            "name": "Wandsworth"
          },
          "wnm": {
            "name": "Windsor and Maidenhead"
          },
          "wok": {
            "name": "Wokingham"
          },
          "wor": {
            "name": "Worcestershire"
          },
          "wrl": {
            "name": "Wirral"
          },
          "wrt": {
            "name": "Warrington"
          },
          "wrx": {
            "name": "Wrexham"
          },
          "wsm": {
            "name": "Westminster"
          },
          "wsx": {
            "name": "West Sussex"
          },
          "yor": {
            "name": "York"
          },
          "zet": {
            "name": "Shetland"
          }
        }
      },
      "gd": {
        "name": "Grenada",
        "calling_code": "+1",
        "region": {
          "01": {
            "name": "Saint Andrew"
          },
          "02": {
            "name": "Saint David"
          },
          "03": {
            "name": "Saint George"
          },
          "04": {
            "name": "Saint John"
          },
          "05": {
            "name": "Saint Mark"
          },
          "06": {
            "name": "Saint Patrick"
          },
          "10": {
            "name": "Carriacou and Petite Martinique"
          }
        }
      },
      "ge": {
        "name": "Georgia",
        "calling_code": "+995",
        "region": {
          "ab": {
            "name": "Abkhazia"
          },
          "aj": {
            "name": "Adjara"
          },
          "gu": {
            "name": "Guria"
          },
          "im": {
            "name": "Imereti"
          },
          "ka": {
            "name": "Kakheti"
          },
          "kk": {
            "name": "Kvemo Kartli"
          },
          "mm": {
            "name": "Mtskheta-Mtianeti"
          },
          "rl": {
            "name": "Racha-Lechkhumi and Kvemo Svaneti"
          },
          "sj": {
            "name": "Samtskhe-Javakheti"
          },
          "sk": {
            "name": "Shida Kartli"
          },
          "sz": {
            "name": "Samegrelo-Zemo Svaneti"
          },
          "tb": {
            "name": "Tbilisi"
          }
        }
      },
      "gf": {
        "name": "French Guiana",
        "calling_code": "+594",
        "region": {}
      },
      "gg": {
        "name": "Guernsey",
        "calling_code": "+44",
        "region": {}
      },
      "gh": {
        "name": "Ghana",
        "calling_code": "+233",
        "region": {
          "aa": {
            "name": "Greater Accra"
          },
          "af": {
            "name": "Ahafo"
          },
          "ah": {
            "name": "Ashanti"
          },
          "be": {
            "name": "Bono East"
          },
          "bo": {
            "name": "Bono"
          },
          "cp": {
            "name": "Central"
          },
          "ep": {
            "name": "Eastern"
          },
          "ne": {
            "name": "North East"
          },
          "np": {
            "name": "Northern"
          },
          "ot": {
            "name": "Oti"
          },
          "sv": {
            "name": "Savannah"
          },
          "tv": {
            "name": "Volta"
          },
          "ue": {
            "name": "Upper East"
          },
          "uw": {
            "name": "Upper West"
          },
          "wn": {
            "name": "Western North"
          },
          "wp": {
            "name": "Western"
          }
        }
      },
      "gi": {
        "name": "Gibraltar",
        "calling_code": "+350",
        "region": {}
      },
      "gl": {
        "name": "Greenland",
        "calling_code": "+299",
        "region": {
          "av": {
            "name": "Avannaata Kommunia"
          },
          "ku": {
            "name": "Kujalleq"
          },
          "qe": {
            "name": "Qeqqata"
          },
          "qt": {
            "name": "Kommune Qeqertalik"
          },
          "sm": {
            "name": "Sermersooq"
          }
        }
      },
      "gm": {
        "name": "Gambia",
        "calling_code": "+220",
        "region": {
          "b": {
            "name": "Banjul"
          },
          "l": {
            "name": "Lower River Division"
          },
          "m": {
            "name": "Central River Division"
          },
          "n": {
            "name": "North Bank Division"
          },
          "u": {
            "name": "Upper River Division"
          },
          "w": {
            "name": "West Coast Division"
          }
        }
      },
      "gn": {
        "name": "Guinea",
        "calling_code": "+224",
        "region": {
          "b": {
            "name": "Boké Region"
          },
          "be": {
            "name": "Beyla"
          },
          "bf": {
            "name": "Boffa"
          },
          "bk": {
            "name": "Boké"
          },
          "c": {
            "name": "Conakry"
          },
          "co": {
            "name": "Coyah"
          },
          "d": {
            "name": "Kindia Region"
          },
          "db": {
            "name": "Dabola"
          },
          "di": {
            "name": "Dinguiraye"
          },
          "dl": {
            "name": "Dalaba"
          },
          "du": {
            "name": "Dubréka"
          },
          "f": {
            "name": "Faranah Region"
          },
          "fa": {
            "name": "Faranah"
          },
          "fo": {
            "name": "Forécariah"
          },
          "fr": {
            "name": "Fria"
          },
          "ga": {
            "name": "Gaoual"
          },
          "gu": {
            "name": "Guéckédou"
          },
          "k": {
            "name": "Kankan Region"
          },
          "ka": {
            "name": "Kankan"
          },
          "kb": {
            "name": "Koubia"
          },
          "kd": {
            "name": "Kindia"
          },
          "ke": {
            "name": "Kérouané"
          },
          "kn": {
            "name": "Koundara"
          },
          "ko": {
            "name": "Kouroussa"
          },
          "ks": {
            "name": "Kissidougou"
          },
          "l": {
            "name": "Labé Region"
          },
          "la": {
            "name": "Labé"
          },
          "le": {
            "name": "Lélouma"
          },
          "lo": {
            "name": "Lola"
          },
          "m": {
            "name": "Mamou Region"
          },
          "mc": {
            "name": "Macenta"
          },
          "md": {
            "name": "Mandiana"
          },
          "ml": {
            "name": "Mali"
          },
          "mm": {
            "name": "Mamou"
          },
          "n": {
            "name": "Nzérékoré Region"
          },
          "nz": {
            "name": "Nzérékoré"
          },
          "pi": {
            "name": "Pita"
          },
          "si": {
            "name": "Siguiri"
          },
          "te": {
            "name": "Télimélé"
          },
          "to": {
            "name": "Tougué"
          },
          "yo": {
            "name": "Yomou"
          }
        }
      },
      "gp": {
        "name": "Guadeloupe",
        "calling_code": "+590",
        "region": {}
      },
      "gq": {
        "name": "Equatorial Guinea",
        "calling_code": "+240",
        "region": {
          "an": {
            "name": "Annobón"
          },
          "bn": {
            "name": "Bioko Norte"
          },
          "bs": {
            "name": "Bioko Sur"
          },
          "c": {
            "name": "Río Muni"
          },
          "cs": {
            "name": "Centro Sur"
          },
          "dj": {
            "name": "Djibloho"
          },
          "i": {
            "name": "Insular"
          },
          "kn": {
            "name": "Kié-Ntem"
          },
          "li": {
            "name": "Litoral"
          },
          "wn": {
            "name": "Wele-Nzas"
          }
        }
      },
      "gr": {
        "name": "Greece",
        "calling_code": "+30",
        "region": {
          "69": {
            "name": "Mount Athos"
          },
          "a": {
            "name": "East Macedonia and Thrace"
          },
          "b": {
            "name": "Central Macedonia"
          },
          "c": {
            "name": "West Macedonia"
          },
          "d": {
            "name": "Epirus"
          },
          "e": {
            "name": "Thessaly"
          },
          "f": {
            "name": "Ionian Islands"
          },
          "g": {
            "name": "West Greece"
          },
          "h": {
            "name": "Central Greece"
          },
          "i": {
            "name": "Attica"
          },
          "j": {
            "name": "Peloponnese"
          },
          "k": {
            "name": "North Aegean"
          },
          "l": {
            "name": "South Aegean"
          },
          "m": {
            "name": "Crete"
          }
        }
      },
      "gs": {
        "name": "South Georgia and the South Sandwich Islands",
        "calling_code": "+500",
        "region": {}
      },
      "gt": {
        "name": "Guatemala",
        "calling_code": "+502",
        "region": {
          "16": {
            "name": "Alta Verapaz"
          },
          "15": {
            "name": "Baja Verapaz"
          },
          "04": {
            "name": "Chimaltenango"
          },
          "20": {
            "name": "Chiquimula"
          },
          "05": {
            "name": "Escuintla"
          },
          "01": {
            "name": "Guatemala"
          },
          "13": {
            "name": "Huehuetenango"
          },
          "18": {
            "name": "Izabal"
          },
          "21": {
            "name": "Jalapa"
          },
          "22": {
            "name": "Jutiapa"
          },
          "17": {
            "name": "Petén"
          },
          "02": {
            "name": "El Progreso"
          },
          "14": {
            "name": "Quiché"
          },
          "09": {
            "name": "Quetzaltenango"
          },
          "11": {
            "name": "Retalhuleu"
          },
          "03": {
            "name": "Sacatepéquez"
          },
          "12": {
            "name": "San Marcos"
          },
          "07": {
            "name": "Sololá"
          },
          "06": {
            "name": "Santa Rosa"
          },
          "10": {
            "name": "Suchitepéquez"
          },
          "08": {
            "name": "Totonicapán"
          },
          "19": {
            "name": "Zacapa"
          }
        }
      },
      "gu": {
        "name": "Guam",
        "calling_code": "+1",
        "region": {}
      },
      "gw": {
        "name": "Guinea-Bissau",
        "calling_code": "+245",
        "region": {
          "ba": {
            "name": "Bafatá"
          },
          "bl": {
            "name": "Bolama"
          },
          "bm": {
            "name": "Biombo"
          },
          "bs": {
            "name": "Bissau"
          },
          "ca": {
            "name": "Cacheu"
          },
          "ga": {
            "name": "Gabú"
          },
          "l": {
            "name": "Leste"
          },
          "n": {
            "name": "Norte"
          },
          "oi": {
            "name": "Oio"
          },
          "qu": {
            "name": "Quinara"
          },
          "s": {
            "name": "Sul"
          },
          "to": {
            "name": "Tombali"
          }
        }
      },
      "gy": {
        "name": "Guyana",
        "calling_code": "+592",
        "region": {
          "ba": {
            "name": "Barima-Waini"
          },
          "cu": {
            "name": "Cuyuni-Mazaruni"
          },
          "de": {
            "name": "Demerara-Mahaica"
          },
          "eb": {
            "name": "East Berbice-Corentyne"
          },
          "es": {
            "name": "Essequibo Islands-West Demerara"
          },
          "ma": {
            "name": "Mahaica-Berbice"
          },
          "pm": {
            "name": "Pomeroon-Supenaam"
          },
          "pt": {
            "name": "Potaro-Siparuni"
          },
          "ud": {
            "name": "Upper Demerara-Berbice"
          },
          "ut": {
            "name": "Upper Takutu-Upper Essequibo"
          }
        }
      },
      "hk": {
        "name": "Hong Kong",
        "calling_code": "+852",
        "region": {}
      },
      "hm": {
        "name": "Heard Island and McDonald Islands",
        "calling_code": "+672",
        "region": {}
      },
      "hn": {
        "name": "Honduras",
        "calling_code": "+504",
        "region": {
          "at": {
            "name": "Atlántida"
          },
          "ch": {
            "name": "Choluteca"
          },
          "cl": {
            "name": "Colón"
          },
          "cm": {
            "name": "Comayagua"
          },
          "cp": {
            "name": "Copán"
          },
          "cr": {
            "name": "Cortés"
          },
          "ep": {
            "name": "El Paraíso"
          },
          "fm": {
            "name": "Francisco Morazán"
          },
          "gd": {
            "name": "Gracias a Dios"
          },
          "ib": {
            "name": "Bay Islands"
          },
          "in": {
            "name": "Intibucá"
          },
          "le": {
            "name": "Lempira"
          },
          "lp": {
            "name": "La Paz"
          },
          "oc": {
            "name": "Ocotepeque"
          },
          "ol": {
            "name": "Olancho"
          },
          "sb": {
            "name": "Santa Bárbara"
          },
          "va": {
            "name": "Valle"
          },
          "yo": {
            "name": "Yoro"
          }
        }
      },
      "hr": {
        "name": "Croatia",
        "calling_code": "+385",
        "region": {
          "01": {
            "name": "Zagreb County"
          },
          "02": {
            "name": "Krapina-Zagorje"
          },
          "03": {
            "name": "Sisak-Moslavina"
          },
          "04": {
            "name": "Karlovac"
          },
          "05": {
            "name": "Varaždin"
          },
          "06": {
            "name": "Koprivnica-Križevci"
          },
          "07": {
            "name": "Bjelovar-Bilogora"
          },
          "08": {
            "name": "Primorje-Gorski Kotar"
          },
          "09": {
            "name": "Lika-Senj"
          },
          "10": {
            "name": "Virovitica-Podravina"
          },
          "11": {
            "name": "Požega-Slavonia"
          },
          "12": {
            "name": "Brod-Posavina"
          },
          "13": {
            "name": "Zadar"
          },
          "14": {
            "name": "Osijek-Baranja"
          },
          "15": {
            "name": "Šibenik-Knin"
          },
          "16": {
            "name": "Vukovar-Syrmia"
          },
          "17": {
            "name": "Split-Dalmatia"
          },
          "18": {
            "name": "Istria"
          },
          "19": {
            "name": "Dubrovnik-Neretva"
          },
          "20": {
            "name": "Međimurje"
          },
          "21": {
            "name": "Zagreb"
          }
        }
      },
      "ht": {
        "name": "Haiti",
        "calling_code": "+509",
        "region": {
          "ar": {
            "name": "Artibonite"
          },
          "ce": {
            "name": "Centre"
          },
          "ga": {
            "name": "Grand’Anse"
          },
          "nd": {
            "name": "Nord"
          },
          "ne": {
            "name": "Nord-Est"
          },
          "ni": {
            "name": "Nippes"
          },
          "no": {
            "name": "Nord-Ouest"
          },
          "ou": {
            "name": "Ouest"
          },
          "sd": {
            "name": "Sud"
          },
          "se": {
            "name": "Sud-Est"
          }
        }
      },
      "hu": {
        "name": "Hungary",
        "calling_code": "+36",
        "region": {
          "ba": {
            "name": "Baranya"
          },
          "bc": {
            "name": "Békéscsaba"
          },
          "be": {
            "name": "Békés"
          },
          "bk": {
            "name": "Bács-Kiskun"
          },
          "bu": {
            "name": "Budapest"
          },
          "bz": {
            "name": "Borsod-Abaúj-Zemplén"
          },
          "cs": {
            "name": "Csongrád"
          },
          "de": {
            "name": "Debrecen"
          },
          "du": {
            "name": "Dunaújváros"
          },
          "eg": {
            "name": "Eger"
          },
          "er": {
            "name": "Érd"
          },
          "fe": {
            "name": "Fejér"
          },
          "gs": {
            "name": "Győr-Moson-Sopron"
          },
          "gy": {
            "name": "Győr"
          },
          "hb": {
            "name": "Hajdú-Bihar"
          },
          "he": {
            "name": "Heves"
          },
          "hv": {
            "name": "Hódmezővásárhely"
          },
          "jn": {
            "name": "Jász-Nagykun-Szolnok"
          },
          "ke": {
            "name": "Komárom-Esztergom"
          },
          "km": {
            "name": "Kecskemét"
          },
          "kv": {
            "name": "Kaposvár"
          },
          "mi": {
            "name": "Miskolc"
          },
          "nk": {
            "name": "Nagykanizsa"
          },
          "no": {
            "name": "Nógrád"
          },
          "ny": {
            "name": "Nyíregyháza"
          },
          "pe": {
            "name": "Pest"
          },
          "ps": {
            "name": "Pécs"
          },
          "sd": {
            "name": "Szeged"
          },
          "sf": {
            "name": "Székesfehérvár"
          },
          "sh": {
            "name": "Szombathely"
          },
          "sk": {
            "name": "Szolnok"
          },
          "sn": {
            "name": "Sopron"
          },
          "so": {
            "name": "Somogy"
          },
          "ss": {
            "name": "Szekszárd"
          },
          "st": {
            "name": "Salgótarján"
          },
          "sz": {
            "name": "Szabolcs-Szatmár-Bereg"
          },
          "tb": {
            "name": "Tatabánya"
          },
          "to": {
            "name": "Tolna"
          },
          "va": {
            "name": "Vas"
          },
          "ve": {
            "name": "Veszprém County"
          },
          "vm": {
            "name": "Veszprém"
          },
          "za": {
            "name": "Zala"
          },
          "ze": {
            "name": "Zalaegerszeg"
          }
        }
      },
      "id": {
        "name": "Indonesia",
        "calling_code": "+62",
        "region": {
          "ac": {
            "name": "Aceh"
          },
          "ba": {
            "name": "Bali"
          },
          "bb": {
            "name": "Bangka–Belitung Islands"
          },
          "be": {
            "name": "Bengkulu"
          },
          "bt": {
            "name": "Banten"
          },
          "go": {
            "name": "Gorontalo"
          },
          "ja": {
            "name": "Jambi"
          },
          "jb": {
            "name": "West Java"
          },
          "ji": {
            "name": "East Java"
          },
          "jk": {
            "name": "Jakarta"
          },
          "jt": {
            "name": "Central Java"
          },
          "jw": {
            "name": "Java"
          },
          "ka": {
            "name": "Kalimantan"
          },
          "kb": {
            "name": "West Kalimantan"
          },
          "ki": {
            "name": "East Kalimantan"
          },
          "kr": {
            "name": "Riau Islands"
          },
          "ks": {
            "name": "South Kalimantan"
          },
          "kt": {
            "name": "Central Kalimantan"
          },
          "ku": {
            "name": "North Kalimantan"
          },
          "la": {
            "name": "Lampung"
          },
          "ma": {
            "name": "Maluku"
          },
          "ml": {
            "name": "Maluku Islands"
          },
          "mu": {
            "name": "North Maluku"
          },
          "nb": {
            "name": "West Nusa Tenggara"
          },
          "nt": {
            "name": "East Nusa Tenggara"
          },
          "nu": {
            "name": "Lesser Sunda Islands"
          },
          "pa": {
            "name": "Papua"
          },
          "pb": {
            "name": "West Papua"
          },
          "pp": {
            "name": "Papua Islands"
          },
          "ri": {
            "name": "Riau"
          },
          "sa": {
            "name": "North Sulawesi"
          },
          "sb": {
            "name": "West Sumatra"
          },
          "sg": {
            "name": "Southeast Sulawesi"
          },
          "sl": {
            "name": "Sulawesi"
          },
          "sm": {
            "name": "Sumatra"
          },
          "sn": {
            "name": "South Sulawesi"
          },
          "sr": {
            "name": "West Sulawesi"
          },
          "ss": {
            "name": "South Sumatra"
          },
          "st": {
            "name": "Central Sulawesi"
          },
          "su": {
            "name": "North Sumatra"
          },
          "yo": {
            "name": "Yogyakarta"
          }
        }
      },
      "ie": {
        "name": "Ireland",
        "calling_code": "+353",
        "region": {
          "c": {
            "name": "Connacht"
          },
          "ce": {
            "name": "Clare"
          },
          "cn": {
            "name": "Cavan"
          },
          "co": {
            "name": "Cork"
          },
          "cw": {
            "name": "Carlow"
          },
          "d": {
            "name": "Dublin"
          },
          "dl": {
            "name": "Donegal"
          },
          "g": {
            "name": "Galway"
          },
          "ke": {
            "name": "Kildare"
          },
          "kk": {
            "name": "Kilkenny"
          },
          "ky": {
            "name": "Kerry"
          },
          "l": {
            "name": "Leinster"
          },
          "ld": {
            "name": "Longford"
          },
          "lh": {
            "name": "Louth"
          },
          "lk": {
            "name": "Limerick"
          },
          "lm": {
            "name": "Leitrim"
          },
          "ls": {
            "name": "Laois"
          },
          "m": {
            "name": "Munster"
          },
          "mh": {
            "name": "Meath"
          },
          "mn": {
            "name": "Monaghan"
          },
          "mo": {
            "name": "Mayo"
          },
          "oy": {
            "name": "Offaly"
          },
          "rn": {
            "name": "Roscommon"
          },
          "so": {
            "name": "Sligo"
          },
          "ta": {
            "name": "Tipperary"
          },
          "u": {
            "name": "Ulster"
          },
          "wd": {
            "name": "Waterford"
          },
          "wh": {
            "name": "Westmeath"
          },
          "ww": {
            "name": "Wicklow"
          },
          "wx": {
            "name": "Wexford"
          }
        }
      },
      "il": {
        "name": "Israel",
        "calling_code": "+972",
        "region": {
          "d": {
            "name": "Southern District"
          },
          "ha": {
            "name": "Haifa District"
          },
          "jm": {
            "name": "Jerusalem"
          },
          "m": {
            "name": "Central District"
          },
          "ta": {
            "name": "Tel Aviv District"
          },
          "z": {
            "name": "Northern District"
          }
        }
      },
      "im": {
        "name": "Isle of Man",
        "calling_code": "+44",
        "region": {}
      },
      "in": {
        "name": "India",
        "calling_code": "+91",
        "region": {
          "an": {
            "name": "Andaman and Nicobar Islands"
          },
          "ap": {
            "name": "Andhra Pradesh"
          },
          "ar": {
            "name": "Arunachal Pradesh"
          },
          "as": {
            "name": "Assam"
          },
          "br": {
            "name": "Bihar"
          },
          "ch": {
            "name": "Chandigarh"
          },
          "cg": {
            "name": "Chhattisgarh"
          },
          "dh": {
            "name": "Dādra and Nagar Haveli and Damān and Diu"
          },
          "dl": {
            "name": "Delhi"
          },
          "ga": {
            "name": "Goa"
          },
          "gj": {
            "name": "Gujarat"
          },
          "hp": {
            "name": "Himachal Pradesh"
          },
          "hr": {
            "name": "Haryana"
          },
          "jh": {
            "name": "Jharkhand"
          },
          "jk": {
            "name": "Jammu and Kashmir"
          },
          "ka": {
            "name": "Karnataka"
          },
          "kl": {
            "name": "Kerala"
          },
          "la": {
            "name": "Ladakh"
          },
          "ld": {
            "name": "Lakshadweep"
          },
          "mh": {
            "name": "Maharashtra"
          },
          "ml": {
            "name": "Meghalaya"
          },
          "mn": {
            "name": "Manipur"
          },
          "mp": {
            "name": "Madhya Pradesh"
          },
          "mz": {
            "name": "Mizoram"
          },
          "nl": {
            "name": "Nagaland"
          },
          "od": {
            "name": "Odisha"
          },
          "pb": {
            "name": "Punjab"
          },
          "py": {
            "name": "Puducherry"
          },
          "rj": {
            "name": "Rajasthan"
          },
          "sk": {
            "name": "Sikkim"
          },
          "ts": {
            "name": "Telangana"
          },
          "tn": {
            "name": "Tamil Nadu"
          },
          "tr": {
            "name": "Tripura"
          },
          "up": {
            "name": "Uttar Pradesh"
          },
          "uk": {
            "name": "Uttarakhand"
          },
          "wb": {
            "name": "West Bengal"
          }
        }
      },
      "io": {
        "name": "British Indian Ocean Territory",
        "calling_code": "+246",
        "region": {}
      },
      "iq": {
        "name": "Iraq",
        "calling_code": "+964",
        "region": {
          "an": {
            "name": "Al Anbar"
          },
          "ar": {
            "name": "Erbil"
          },
          "ba": {
            "name": "Basra"
          },
          "bb": {
            "name": "Babylon"
          },
          "bg": {
            "name": "Baghdad"
          },
          "da": {
            "name": "Dohuk"
          },
          "di": {
            "name": "Diyala"
          },
          "dq": {
            "name": "Dhi Qar"
          },
          "ka": {
            "name": "Karbala"
          },
          "ki": {
            "name": "Kirkuk"
          },
          "kr": {
            "name": "Kurdistan"
          },
          "ma": {
            "name": "Maysan"
          },
          "mu": {
            "name": "Al Muthanna"
          },
          "na": {
            "name": "Najaf"
          },
          "ni": {
            "name": "Nineveh"
          },
          "qa": {
            "name": "Al-Qādisiyyah"
          },
          "sd": {
            "name": "Saladin"
          },
          "su": {
            "name": "Sulaymaniyah"
          },
          "wa": {
            "name": "Wasit"
          }
        }
      },
      "ir": {
        "name": "Iran",
        "calling_code": "+98",
        "region": {
          "00": {
            "name": "Markazi"
          },
          "01": {
            "name": "Gilan"
          },
          "02": {
            "name": "Mazandaran"
          },
          "03": {
            "name": "East Azerbaijan"
          },
          "04": {
            "name": "West Azarbaijan"
          },
          "05": {
            "name": "Kermanshah"
          },
          "06": {
            "name": "Khuzestan"
          },
          "07": {
            "name": "Fars"
          },
          "08": {
            "name": "Kerman"
          },
          "09": {
            "name": "Razavi Khorasan"
          },
          "10": {
            "name": "Isfahan"
          },
          "11": {
            "name": "Sistan and Baluchestan"
          },
          "12": {
            "name": "Kurdistan"
          },
          "13": {
            "name": "Hamadan"
          },
          "14": {
            "name": "Chaharmahal and Bakhtiari"
          },
          "15": {
            "name": "Lorestan"
          },
          "16": {
            "name": "Ilam"
          },
          "17": {
            "name": "Kohgiluyeh and Boyer-Ahmad"
          },
          "18": {
            "name": "Bushehr"
          },
          "19": {
            "name": "Zanjan"
          },
          "20": {
            "name": "Semnan"
          },
          "21": {
            "name": "Yazd"
          },
          "22": {
            "name": "Hormozgan"
          },
          "23": {
            "name": "Tehran"
          },
          "24": {
            "name": "Ardabil"
          },
          "25": {
            "name": "Qom"
          },
          "26": {
            "name": "Qazvin"
          },
          "27": {
            "name": "Golestan"
          },
          "28": {
            "name": "North Khorasan"
          },
          "29": {
            "name": "South Khorasan"
          },
          "30": {
            "name": "Alborz"
          }
        }
      },
      "is": {
        "name": "Iceland",
        "calling_code": "+354",
        "region": {
          "0": {
            "name": "Reykjavík"
          },
          "1": {
            "name": "Capital"
          },
          "2": {
            "name": "Southern Peninsula"
          },
          "3": {
            "name": "Western"
          },
          "4": {
            "name": "Westfjords"
          },
          "5": {
            "name": "Northwestern"
          },
          "6": {
            "name": "Northeastern"
          },
          "7": {
            "name": "Eastern"
          },
          "8": {
            "name": "Southern"
          },
          "akh": {
            "name": "Akrahreppur"
          },
          "akn": {
            "name": "Akraneskaupstaður"
          },
          "aku": {
            "name": "Akureyrarbær"
          },
          "arn": {
            "name": "Árneshreppur"
          },
          "asa": {
            "name": "Ásahreppur"
          },
          "bla": {
            "name": "Bláskógabyggð"
          },
          "blo": {
            "name": "Blönduósbær"
          },
          "bog": {
            "name": "Borgarbyggð"
          },
          "bol": {
            "name": "Bolungarvíkurkaupstaður"
          },
          "dab": {
            "name": "Dalabyggð"
          },
          "dav": {
            "name": "Dalvíkurbyggð"
          },
          "eom": {
            "name": "Eyja- og Miklaholtshreppur"
          },
          "eyf": {
            "name": "Eyjafjarðarsveit"
          },
          "fjd": {
            "name": "Fjarðabyggð"
          },
          "fjl": {
            "name": "Fjallabyggð"
          },
          "fla": {
            "name": "Flóahreppur"
          },
          "flr": {
            "name": "Fljótsdalshreppur"
          },
          "gar": {
            "name": "Garðabær"
          },
          "gog": {
            "name": "Grímsnes- og Grafningshreppur"
          },
          "grn": {
            "name": "Grindavíkurbær"
          },
          "gru": {
            "name": "Grundarfjarðarbær"
          },
          "gry": {
            "name": "Grýtubakkahreppur"
          },
          "haf": {
            "name": "Hafnarfjarðarkaupstaður"
          },
          "hel": {
            "name": "Helgafellssveit"
          },
          "hrg": {
            "name": "Hörgársveit"
          },
          "hru": {
            "name": "Hrunamannahreppur"
          },
          "hut": {
            "name": "Húnavatnshreppur"
          },
          "huv": {
            "name": "Húnaþing vestra"
          },
          "hva": {
            "name": "Hvalfjarðarsveit"
          },
          "hve": {
            "name": "Hveragerðisbær"
          },
          "isa": {
            "name": "Ísafjarðarbær"
          },
          "kal": {
            "name": "Kaldrananeshreppur"
          },
          "kjo": {
            "name": "Kjósarhreppur"
          },
          "kop": {
            "name": "Kópavogsbær"
          },
          "lan": {
            "name": "Langanesbyggð"
          },
          "mos": {
            "name": "Mosfellsbær"
          },
          "mul": {
            "name": "Múlaþing"
          },
          "myr": {
            "name": "Mýrdalshreppur"
          },
          "nor": {
            "name": "Norðurþing"
          },
          "rge": {
            "name": "Rangárþing eystra"
          },
          "rgy": {
            "name": "Rangárþing ytra"
          },
          "rhh": {
            "name": "Reykhólahreppur"
          },
          "rkn": {
            "name": "Reykjanesbær"
          },
          "rkv": {
            "name": "Reykjavíkurborg"
          },
          "sbh": {
            "name": "Svalbarðshreppur"
          },
          "sbt": {
            "name": "Svalbarðsstrandarhreppur"
          },
          "sdn": {
            "name": "Suðurnesjabær"
          },
          "sdv": {
            "name": "Súðavíkurhreppur"
          },
          "sel": {
            "name": "Seltjarnarnesbær"
          },
          "sfa": {
            "name": "Sveitarfélagið Árborg"
          },
          "shf": {
            "name": "Sveitarfélagið Hornafjörður"
          },
          "skf": {
            "name": "Skaftárhreppur"
          },
          "skg": {
            "name": "Skagabyggð"
          },
          "sko": {
            "name": "Skorradalshreppur"
          },
          "sku": {
            "name": "Skútustaðahreppur"
          },
          "snf": {
            "name": "Snæfellsbær"
          },
          "sog": {
            "name": "Skeiða- og Gnúpverjahreppur"
          },
          "sol": {
            "name": "Sveitarfélagið Ölfus"
          },
          "ssf": {
            "name": "Sveitarfélagið Skagafjörður"
          },
          "sss": {
            "name": "Sveitarfélagið Skagaströnd"
          },
          "str": {
            "name": "Strandabyggð"
          },
          "sty": {
            "name": "Stykkishólmsbær"
          },
          "svg": {
            "name": "Sveitarfélagið Vogar"
          },
          "tal": {
            "name": "Tálknafjarðarhreppur"
          },
          "thg": {
            "name": "Þingeyjarsveit"
          },
          "tjo": {
            "name": "Tjörneshreppur"
          },
          "vem": {
            "name": "Vestmannaeyjabær"
          },
          "ver": {
            "name": "Vesturbyggð"
          },
          "vop": {
            "name": "Vopnafjarðarhreppur"
          }
        }
      },
      "it": {
        "name": "Italy",
        "calling_code": "+39",
        "region": {
          "21": {
            "name": "Piedmont"
          },
          "23": {
            "name": "Aosta Valley"
          },
          "25": {
            "name": "Lombardy"
          },
          "32": {
            "name": "Trentino-South Tyrol"
          },
          "34": {
            "name": "Veneto"
          },
          "36": {
            "name": "Friuli–Venezia Giulia"
          },
          "42": {
            "name": "Liguria"
          },
          "45": {
            "name": "Emilia-Romagna"
          },
          "52": {
            "name": "Tuscany"
          },
          "55": {
            "name": "Umbria"
          },
          "57": {
            "name": "Marche"
          },
          "62": {
            "name": "Lazio"
          },
          "65": {
            "name": "Abruzzo"
          },
          "67": {
            "name": "Molise"
          },
          "72": {
            "name": "Campania"
          },
          "75": {
            "name": "Apulia"
          },
          "77": {
            "name": "Basilicata"
          },
          "78": {
            "name": "Calabria"
          },
          "82": {
            "name": "Sicily"
          },
          "88": {
            "name": "Sardinia"
          },
          "ag": {
            "name": "Agrigento"
          },
          "al": {
            "name": "Alessandria"
          },
          "an": {
            "name": "Ancona"
          },
          "ap": {
            "name": "Ascoli Piceno"
          },
          "aq": {
            "name": "L’Aquila"
          },
          "ar": {
            "name": "Arezzo"
          },
          "at": {
            "name": "Asti"
          },
          "av": {
            "name": "Avellino"
          },
          "ba": {
            "name": "Bari"
          },
          "bg": {
            "name": "Bergamo"
          },
          "bi": {
            "name": "Biella"
          },
          "bl": {
            "name": "Belluno"
          },
          "bn": {
            "name": "Benevento"
          },
          "bo": {
            "name": "Bologna"
          },
          "br": {
            "name": "Brindisi"
          },
          "bs": {
            "name": "Brescia"
          },
          "bt": {
            "name": "Barletta-Andria-Trani"
          },
          "bz": {
            "name": "South Tyrol"
          },
          "ca": {
            "name": "Cagliari"
          },
          "cb": {
            "name": "Campobasso"
          },
          "ce": {
            "name": "Caserta"
          },
          "ch": {
            "name": "Chieti"
          },
          "cl": {
            "name": "Caltanissetta"
          },
          "cn": {
            "name": "Cuneo"
          },
          "co": {
            "name": "Como"
          },
          "cr": {
            "name": "Cremona"
          },
          "cs": {
            "name": "Cosenza"
          },
          "ct": {
            "name": "Catania"
          },
          "cz": {
            "name": "Catanzaro"
          },
          "en": {
            "name": "Enna"
          },
          "fc": {
            "name": "Forlì-Cesena"
          },
          "fe": {
            "name": "Ferrara"
          },
          "fg": {
            "name": "Foggia"
          },
          "fi": {
            "name": "Florence"
          },
          "fm": {
            "name": "Fermo"
          },
          "fr": {
            "name": "Frosinone"
          },
          "ge": {
            "name": "Genoa"
          },
          "go": {
            "name": "Gorizia"
          },
          "gr": {
            "name": "Grosseto"
          },
          "im": {
            "name": "Imperia"
          },
          "is": {
            "name": "Isernia"
          },
          "kr": {
            "name": "Crotone"
          },
          "lc": {
            "name": "Lecco"
          },
          "le": {
            "name": "Lecce"
          },
          "li": {
            "name": "Livorno"
          },
          "lo": {
            "name": "Lodi"
          },
          "lt": {
            "name": "Latina"
          },
          "lu": {
            "name": "Lucca"
          },
          "mb": {
            "name": "Monza and Brianza"
          },
          "mc": {
            "name": "Macerata"
          },
          "me": {
            "name": "Messina"
          },
          "mi": {
            "name": "Milan"
          },
          "mn": {
            "name": "Mantua"
          },
          "mo": {
            "name": "Modena"
          },
          "ms": {
            "name": "Massa and Carrara"
          },
          "mt": {
            "name": "Matera"
          },
          "na": {
            "name": "Naples"
          },
          "no": {
            "name": "Novara"
          },
          "nu": {
            "name": "Nuoro"
          },
          "or": {
            "name": "Oristano"
          },
          "pa": {
            "name": "Palermo"
          },
          "pc": {
            "name": "Piacenza"
          },
          "pd": {
            "name": "Padua"
          },
          "pe": {
            "name": "Pescara"
          },
          "pg": {
            "name": "Perugia"
          },
          "pi": {
            "name": "Pisa"
          },
          "pn": {
            "name": "Pordenone"
          },
          "po": {
            "name": "Prato"
          },
          "pr": {
            "name": "Parma"
          },
          "pt": {
            "name": "Pistoia"
          },
          "pu": {
            "name": "Pesaro and Urbino"
          },
          "pv": {
            "name": "Pavia"
          },
          "pz": {
            "name": "Potenza"
          },
          "ra": {
            "name": "Ravenna"
          },
          "rc": {
            "name": "Reggio Calabria"
          },
          "re": {
            "name": "Reggio Emilia"
          },
          "rg": {
            "name": "Ragusa"
          },
          "ri": {
            "name": "Rieti"
          },
          "rm": {
            "name": "Rome"
          },
          "rn": {
            "name": "Rimini"
          },
          "ro": {
            "name": "Rovigo"
          },
          "sa": {
            "name": "Salerno"
          },
          "si": {
            "name": "Siena"
          },
          "so": {
            "name": "Sondrio"
          },
          "sp": {
            "name": "La Spezia"
          },
          "sr": {
            "name": "Syracuse"
          },
          "ss": {
            "name": "Sassari"
          },
          "su": {
            "name": "Sud Sardegna"
          },
          "sv": {
            "name": "Savona"
          },
          "ta": {
            "name": "Taranto"
          },
          "te": {
            "name": "Teramo"
          },
          "tn": {
            "name": "Trentino"
          },
          "to": {
            "name": "Turin"
          },
          "tp": {
            "name": "Trapani"
          },
          "tr": {
            "name": "Terni"
          },
          "ts": {
            "name": "Trieste"
          },
          "tv": {
            "name": "Treviso"
          },
          "ud": {
            "name": "Udine"
          },
          "va": {
            "name": "Varese"
          },
          "vb": {
            "name": "Verbano-Cusio-Ossola"
          },
          "vc": {
            "name": "Vercelli"
          },
          "ve": {
            "name": "Venice"
          },
          "vi": {
            "name": "Vicenza"
          },
          "vr": {
            "name": "Verona"
          },
          "vt": {
            "name": "Viterbo"
          },
          "vv": {
            "name": "Vibo Valentia"
          }
        }
      },
      "je": {
        "name": "Jersey",
        "calling_code": "+44",
        "region": {}
      },
      "jm": {
        "name": "Jamaica",
        "calling_code": "+1",
        "region": {
          "01": {
            "name": "Kingston"
          },
          "02": {
            "name": "Saint Andrew"
          },
          "03": {
            "name": "Saint Thomas"
          },
          "04": {
            "name": "Portland"
          },
          "05": {
            "name": "Saint Mary"
          },
          "06": {
            "name": "Saint Ann"
          },
          "07": {
            "name": "Trelawny"
          },
          "08": {
            "name": "Saint James"
          },
          "09": {
            "name": "Hanover"
          },
          "10": {
            "name": "Westmoreland"
          },
          "11": {
            "name": "Saint Elizabeth"
          },
          "12": {
            "name": "Manchester"
          },
          "13": {
            "name": "Clarendon"
          },
          "14": {
            "name": "Saint Catherine"
          }
        }
      },
      "jo": {
        "name": "Jordan",
        "calling_code": "+962",
        "region": {
          "aj": {
            "name": "Ajloun"
          },
          "am": {
            "name": "Amman"
          },
          "aq": {
            "name": "Aqaba"
          },
          "at": {
            "name": "Tafilah"
          },
          "az": {
            "name": "Zarqa"
          },
          "ba": {
            "name": "Balqa"
          },
          "ir": {
            "name": "Irbid"
          },
          "ja": {
            "name": "Jerash"
          },
          "ka": {
            "name": "Karak"
          },
          "ma": {
            "name": "Mafraq"
          },
          "md": {
            "name": "Madaba"
          },
          "mn": {
            "name": "Ma’an"
          }
        }
      },
      "jp": {
        "name": "Japan",
        "calling_code": "+81",
        "region": {
          "01": {
            "name": "Hokkaidō"
          },
          "02": {
            "name": "Aomori"
          },
          "03": {
            "name": "Iwate"
          },
          "04": {
            "name": "Miyagi"
          },
          "05": {
            "name": "Akita"
          },
          "06": {
            "name": "Yamagata"
          },
          "07": {
            "name": "Fukushima"
          },
          "08": {
            "name": "Ibaraki"
          },
          "09": {
            "name": "Tochigi"
          },
          "10": {
            "name": "Gunma"
          },
          "11": {
            "name": "Saitama"
          },
          "12": {
            "name": "Chiba"
          },
          "13": {
            "name": "Tokyo"
          },
          "14": {
            "name": "Kanagawa"
          },
          "15": {
            "name": "Niigata"
          },
          "16": {
            "name": "Toyama"
          },
          "17": {
            "name": "Ishikawa"
          },
          "18": {
            "name": "Fukui"
          },
          "19": {
            "name": "Yamanashi"
          },
          "20": {
            "name": "Nagano"
          },
          "21": {
            "name": "Gifu"
          },
          "22": {
            "name": "Shizuoka"
          },
          "23": {
            "name": "Aichi"
          },
          "24": {
            "name": "Mie"
          },
          "25": {
            "name": "Shiga"
          },
          "26": {
            "name": "Kyōto"
          },
          "27": {
            "name": "Ōsaka"
          },
          "28": {
            "name": "Hyōgo"
          },
          "29": {
            "name": "Nara"
          },
          "30": {
            "name": "Wakayama"
          },
          "31": {
            "name": "Tottori"
          },
          "32": {
            "name": "Shimane"
          },
          "33": {
            "name": "Okayama"
          },
          "34": {
            "name": "Hiroshima"
          },
          "35": {
            "name": "Yamaguchi"
          },
          "36": {
            "name": "Tokushima"
          },
          "37": {
            "name": "Kagawa"
          },
          "38": {
            "name": "Ehime"
          },
          "39": {
            "name": "Kōchi"
          },
          "40": {
            "name": "Fukuoka"
          },
          "41": {
            "name": "Saga"
          },
          "42": {
            "name": "Nagasaki"
          },
          "43": {
            "name": "Kumamoto"
          },
          "44": {
            "name": "Ōita"
          },
          "45": {
            "name": "Miyazaki"
          },
          "46": {
            "name": "Kagoshima"
          },
          "47": {
            "name": "Okinawa"
          }
        }
      },
      "ke": {
        "name": "Kenya",
        "calling_code": "+254",
        "region": {
          "01": {
            "name": "Baringo"
          },
          "02": {
            "name": "Bomet"
          },
          "03": {
            "name": "Bungoma"
          },
          "04": {
            "name": "Busia"
          },
          "05": {
            "name": "Elgeyo-Marakwet"
          },
          "06": {
            "name": "Embu"
          },
          "07": {
            "name": "Garissa"
          },
          "08": {
            "name": "Homa Bay"
          },
          "09": {
            "name": "Isiolo"
          },
          "10": {
            "name": "Kajiado"
          },
          "11": {
            "name": "Kakamega"
          },
          "12": {
            "name": "Kericho"
          },
          "13": {
            "name": "Kiambu"
          },
          "14": {
            "name": "Kilifi"
          },
          "15": {
            "name": "Kirinyaga"
          },
          "16": {
            "name": "Kisii"
          },
          "17": {
            "name": "Kisumu"
          },
          "18": {
            "name": "Kitui"
          },
          "19": {
            "name": "Kwale"
          },
          "20": {
            "name": "Laikipia"
          },
          "21": {
            "name": "Lamu"
          },
          "22": {
            "name": "Machakos"
          },
          "23": {
            "name": "Makueni"
          },
          "24": {
            "name": "Mandera"
          },
          "25": {
            "name": "Marsabit"
          },
          "26": {
            "name": "Meru"
          },
          "27": {
            "name": "Migori"
          },
          "28": {
            "name": "Mombasa"
          },
          "29": {
            "name": "Murang’a"
          },
          "30": {
            "name": "Nairobi County"
          },
          "31": {
            "name": "Nakuru"
          },
          "32": {
            "name": "Nandi"
          },
          "33": {
            "name": "Narok"
          },
          "34": {
            "name": "Nyamira"
          },
          "35": {
            "name": "Nyandarua"
          },
          "36": {
            "name": "Nyeri"
          },
          "37": {
            "name": "Samburu"
          },
          "38": {
            "name": "Siaya"
          },
          "39": {
            "name": "Taita-Taveta"
          },
          "40": {
            "name": "Tana River"
          },
          "41": {
            "name": "Tharaka-Nithi"
          },
          "42": {
            "name": "Trans Nzoia"
          },
          "43": {
            "name": "Turkana"
          },
          "44": {
            "name": "Uasin Gishu"
          },
          "45": {
            "name": "Vihiga"
          },
          "46": {
            "name": "Wajir"
          },
          "47": {
            "name": "West Pokot"
          }
        }
      },
      "kg": {
        "name": "Kyrgyzstan",
        "calling_code": "+996",
        "region": {
          "b": {
            "name": "Batken"
          },
          "c": {
            "name": "Chuy"
          },
          "gb": {
            "name": "Bishkek"
          },
          "go": {
            "name": "Osh"
          },
          "j": {
            "name": "Jalal-Abad"
          },
          "n": {
            "name": "Naryn"
          },
          "o": {
            "name": "Osh Region"
          },
          "t": {
            "name": "Talas"
          },
          "y": {
            "name": "Issyk-Kul"
          }
        }
      },
      "kh": {
        "name": "Cambodia",
        "calling_code": "+855",
        "region": {
          "1": {
            "name": "Banteay Meanchey"
          },
          "10": {
            "name": "Kratié"
          },
          "11": {
            "name": "Mondulkiri"
          },
          "12": {
            "name": "Phnom Penh"
          },
          "13": {
            "name": "Preah Vihear"
          },
          "14": {
            "name": "Prey Veng"
          },
          "15": {
            "name": "Pursat"
          },
          "16": {
            "name": "Ratanakiri"
          },
          "17": {
            "name": "Siem Reap"
          },
          "18": {
            "name": "Sihanoukville"
          },
          "19": {
            "name": "Stung Treng"
          },
          "2": {
            "name": "Battambang"
          },
          "20": {
            "name": "Svay Rieng"
          },
          "21": {
            "name": "Takéo"
          },
          "22": {
            "name": "Oddar Meanchey"
          },
          "23": {
            "name": "Kep"
          },
          "24": {
            "name": "Pailin"
          },
          "25": {
            "name": "Tbong Khmum"
          },
          "3": {
            "name": "Kampong Cham"
          },
          "4": {
            "name": "Kampong Chhnang"
          },
          "5": {
            "name": "Kampong Speu"
          },
          "6": {
            "name": "Kampong Thom"
          },
          "7": {
            "name": "Kampot"
          },
          "8": {
            "name": "Kandal"
          },
          "9": {
            "name": "Koh Kong"
          }
        }
      },
      "ki": {
        "name": "Kiribati",
        "calling_code": "+686",
        "region": {
          "g": {
            "name": "Gilbert Islands"
          },
          "l": {
            "name": "Line Islands"
          },
          "p": {
            "name": "Phoenix Islands"
          }
        }
      },
      "km": {
        "name": "Comoros",
        "calling_code": "+269",
        "region": {
          "a": {
            "name": "Anjouan"
          },
          "g": {
            "name": "Grande Comore"
          },
          "m": {
            "name": "Mohéli"
          }
        }
      },
      "kn": {
        "name": "Saint Kitts and Nevis",
        "calling_code": "+1",
        "region": {
          "01": {
            "name": "Christ Church Nichola Town"
          },
          "02": {
            "name": "Saint Anne Sandy Point"
          },
          "03": {
            "name": "Saint George Basseterre"
          },
          "04": {
            "name": "Saint George Gingerland"
          },
          "05": {
            "name": "Saint James Windward"
          },
          "06": {
            "name": "Saint John Capisterre"
          },
          "07": {
            "name": "Saint John Figtree"
          },
          "08": {
            "name": "Saint Mary Cayon"
          },
          "09": {
            "name": "Saint Paul Capisterre"
          },
          "10": {
            "name": "Saint Paul Charlestown"
          },
          "11": {
            "name": "Saint Peter Basseterre"
          },
          "12": {
            "name": "Saint Thomas Lowland"
          },
          "13": {
            "name": "Saint Thomas Middle Island"
          },
          "15": {
            "name": "Trinity Palmetto Point"
          },
          "k": {
            "name": "Saint Kitts"
          },
          "n": {
            "name": "Nevis"
          }
        }
      },
      "kp": {
        "name": "North Korea",
        "calling_code": "+850",
        "region": {
          "01": {
            "name": "Pyongyang"
          },
          "02": {
            "name": "South Pyongan"
          },
          "03": {
            "name": "North Pyongan"
          },
          "04": {
            "name": "Chagang"
          },
          "05": {
            "name": "South Hwanghae"
          },
          "06": {
            "name": "North Hwanghae"
          },
          "07": {
            "name": "Kangwon"
          },
          "08": {
            "name": "South Hamgyong"
          },
          "09": {
            "name": "North Hamgyong"
          },
          "10": {
            "name": "Ryanggang"
          },
          "13": {
            "name": "Rason"
          },
          "14": {
            "name": "Nampho"
          }
        }
      },
      "kr": {
        "name": "South Korea",
        "calling_code": "+82",
        "region": {
          "11": {
            "name": "Seoul"
          },
          "26": {
            "name": "Busan"
          },
          "27": {
            "name": "Daegu"
          },
          "28": {
            "name": "Incheon"
          },
          "29": {
            "name": "Gwangju City"
          },
          "30": {
            "name": "Daejeon"
          },
          "31": {
            "name": "Ulsan"
          },
          "41": {
            "name": "Gyeonggi"
          },
          "42": {
            "name": "Gangwon"
          },
          "43": {
            "name": "North Chungcheong"
          },
          "44": {
            "name": "South Chungcheong"
          },
          "45": {
            "name": "North Jeolla"
          },
          "46": {
            "name": "South Jeolla"
          },
          "47": {
            "name": "North Gyeongsang"
          },
          "48": {
            "name": "South Gyeongsang"
          },
          "49": {
            "name": "Jeju"
          },
          "50": {
            "name": "Sejong"
          }
        }
      },
      "kw": {
        "name": "Kuwait",
        "calling_code": "+965",
        "region": {
          "ah": {
            "name": "Al Ahmadi"
          },
          "fa": {
            "name": "Al Farwaniyah"
          },
          "ha": {
            "name": "Hawalli"
          },
          "ja": {
            "name": "Al Jahra"
          },
          "ku": {
            "name": "Al Asimah"
          },
          "mu": {
            "name": "Mubarak Al-Kabeer"
          }
        }
      },
      "ky": {
        "name": "Cayman Islands",
        "calling_code": "+1",
        "region": {}
      },
      "kz": {
        "name": "Kazakhstan",
        "calling_code": "+7",
        "region": {
          "akm": {
            "name": "Akmola"
          },
          "akt": {
            "name": "Aktobe"
          },
          "ala": {
            "name": "Almaty"
          },
          "alm": {
            "name": "Almaty Region"
          },
          "ast": {
            "name": "Astana"
          },
          "aty": {
            "name": "Atyrau"
          },
          "kar": {
            "name": "Karagandy"
          },
          "kus": {
            "name": "Kostanay"
          },
          "kzy": {
            "name": "Kyzylorda"
          },
          "man": {
            "name": "Mangystau"
          },
          "pav": {
            "name": "Pavlodar"
          },
          "sev": {
            "name": "North Kazakhstan"
          },
          "shy": {
            "name": "Shymkent"
          },
          "vos": {
            "name": "East Kazakhstan"
          },
          "yuz": {
            "name": "South Kazakhstan"
          },
          "zap": {
            "name": "West Kazakhstan"
          },
          "zha": {
            "name": "Jambyl"
          }
        }
      },
      "la": {
        "name": "Lao People's Democratic Republic",
        "calling_code": "+856",
        "region": {
          "at": {
            "name": "Attapeu"
          },
          "bk": {
            "name": "Bokeo"
          },
          "bl": {
            "name": "Bolikhamsai"
          },
          "ch": {
            "name": "Champasak"
          },
          "ho": {
            "name": "Houaphanh"
          },
          "kh": {
            "name": "Khammouane"
          },
          "lm": {
            "name": "Luang Namtha"
          },
          "lp": {
            "name": "Luang Prabang"
          },
          "ou": {
            "name": "Oudomxay"
          },
          "ph": {
            "name": "Phongsaly"
          },
          "sl": {
            "name": "Salavan"
          },
          "sv": {
            "name": "Savannakhet"
          },
          "vi": {
            "name": "Vientiane Province"
          },
          "vt": {
            "name": "Vientiane"
          },
          "xa": {
            "name": "Sainyabuli"
          },
          "xe": {
            "name": "Sekong"
          },
          "xi": {
            "name": "Xiangkhouang"
          },
          "xs": {
            "name": "Xaisomboun"
          }
        }
      },
      "lb": {
        "name": "Lebanon",
        "calling_code": "+961",
        "region": {
          "ak": {
            "name": "Akkar"
          },
          "as": {
            "name": "North"
          },
          "ba": {
            "name": "Beirut"
          },
          "bh": {
            "name": "Baalbek-Hermel"
          },
          "bi": {
            "name": "Beqaa"
          },
          "ja": {
            "name": "South"
          },
          "jl": {
            "name": "Mount Lebanon"
          },
          "na": {
            "name": "Nabatieh"
          }
        }
      },
      "lc": {
        "name": "Saint Lucia",
        "calling_code": "+1",
        "region": {
          "01": {
            "name": "Anse la Raye"
          },
          "02": {
            "name": "Castries"
          },
          "03": {
            "name": "Choiseul"
          },
          "05": {
            "name": "Dennery"
          },
          "06": {
            "name": "Gros Islet"
          },
          "07": {
            "name": "Laborie"
          },
          "08": {
            "name": "Micoud"
          },
          "10": {
            "name": "Soufrière"
          },
          "11": {
            "name": "Vieux Fort"
          },
          "12": {
            "name": "Canaries"
          }
        }
      },
      "li": {
        "name": "Liechtenstein",
        "calling_code": "+423",
        "region": {
          "01": {
            "name": "Balzers"
          },
          "02": {
            "name": "Eschen"
          },
          "03": {
            "name": "Gamprin"
          },
          "04": {
            "name": "Mauren"
          },
          "05": {
            "name": "Planken"
          },
          "06": {
            "name": "Ruggell"
          },
          "07": {
            "name": "Schaan"
          },
          "08": {
            "name": "Schellenberg"
          },
          "09": {
            "name": "Triesen"
          },
          "10": {
            "name": "Triesenberg"
          },
          "11": {
            "name": "Vaduz"
          }
        }
      },
      "lk": {
        "name": "Sri Lanka",
        "calling_code": "+94",
        "region": {
          "1": {
            "name": "Western"
          },
          "11": {
            "name": "Colombo"
          },
          "12": {
            "name": "Gampaha"
          },
          "13": {
            "name": "Kalutara"
          },
          "2": {
            "name": "Central"
          },
          "21": {
            "name": "Kandy"
          },
          "22": {
            "name": "Matale"
          },
          "23": {
            "name": "Nuwara Eliya"
          },
          "3": {
            "name": "Southern"
          },
          "31": {
            "name": "Galle"
          },
          "32": {
            "name": "Matara"
          },
          "33": {
            "name": "Hambantota"
          },
          "4": {
            "name": "Northern"
          },
          "41": {
            "name": "Jaffna"
          },
          "42": {
            "name": "Kilinochchi"
          },
          "43": {
            "name": "Mannar"
          },
          "44": {
            "name": "Vavuniya"
          },
          "45": {
            "name": "Mullaitivu"
          },
          "5": {
            "name": "Eastern"
          },
          "51": {
            "name": "Batticaloa"
          },
          "52": {
            "name": "Ampara"
          },
          "53": {
            "name": "Trincomalee"
          },
          "6": {
            "name": "North Western"
          },
          "61": {
            "name": "Kurunegala"
          },
          "62": {
            "name": "Puttalam"
          },
          "7": {
            "name": "North Central"
          },
          "71": {
            "name": "Anuradhapura"
          },
          "72": {
            "name": "Polonnaruwa"
          },
          "8": {
            "name": "Uva"
          },
          "81": {
            "name": "Badulla"
          },
          "82": {
            "name": "Moneragala"
          },
          "9": {
            "name": "Sabaragamuwa"
          },
          "91": {
            "name": "Ratnapura"
          },
          "92": {
            "name": "Kegalle"
          }
        }
      },
      "lr": {
        "name": "Liberia",
        "calling_code": "+231",
        "region": {
          "bg": {
            "name": "Bong"
          },
          "bm": {
            "name": "Bomi"
          },
          "cm": {
            "name": "Grand Cape Mount"
          },
          "gb": {
            "name": "Grand Bassa"
          },
          "gg": {
            "name": "Grand Gedeh"
          },
          "gk": {
            "name": "Grand Kru"
          },
          "gp": {
            "name": "Gbarpolu"
          },
          "lo": {
            "name": "Lofa"
          },
          "mg": {
            "name": "Margibi"
          },
          "mo": {
            "name": "Montserrado"
          },
          "my": {
            "name": "Maryland"
          },
          "ni": {
            "name": "Nimba"
          },
          "rg": {
            "name": "River Gee"
          },
          "ri": {
            "name": "Rivercess"
          },
          "si": {
            "name": "Sinoe"
          },
          "x1~": {
            "name": "Gbarpolu"
          },
          "x2~": {
            "name": "River Gee"
          }
        }
      },
      "ls": {
        "name": "Lesotho",
        "calling_code": "+266",
        "region": {
          "a": {
            "name": "Maseru"
          },
          "b": {
            "name": "Butha-Buthe"
          },
          "c": {
            "name": "Leribe"
          },
          "d": {
            "name": "Berea"
          },
          "e": {
            "name": "Mafeteng"
          },
          "f": {
            "name": "Mohale’s Hoek"
          },
          "g": {
            "name": "Quthing"
          },
          "h": {
            "name": "Qacha’s Nek"
          },
          "j": {
            "name": "Mokhotlong"
          },
          "k": {
            "name": "Thaba-Tseka"
          }
        }
      },
      "lt": {
        "name": "Lithuania",
        "calling_code": "+370",
        "region": {
          "01": {
            "name": "Akmenė"
          },
          "02": {
            "name": "Alytus Municipality"
          },
          "03": {
            "name": "Alytus"
          },
          "04": {
            "name": "Anykščiai"
          },
          "05": {
            "name": "Birštonas"
          },
          "06": {
            "name": "Biržai"
          },
          "07": {
            "name": "Druskininkai"
          },
          "08": {
            "name": "Elektrėnai"
          },
          "09": {
            "name": "Ignalina"
          },
          "10": {
            "name": "Jonava"
          },
          "11": {
            "name": "Joniškis"
          },
          "12": {
            "name": "Jurbarkas"
          },
          "13": {
            "name": "Kaišiadorys"
          },
          "14": {
            "name": "Kalvarija"
          },
          "15": {
            "name": "Kauno Municipality"
          },
          "16": {
            "name": "Kaunas"
          },
          "17": {
            "name": "Kazlų Rūda"
          },
          "18": {
            "name": "Kėdainiai"
          },
          "19": {
            "name": "Kelmė"
          },
          "20": {
            "name": "Klaipėdos Municipality"
          },
          "21": {
            "name": "Klaipėda"
          },
          "22": {
            "name": "Kretinga"
          },
          "23": {
            "name": "Kupiškis"
          },
          "24": {
            "name": "Lazdijai"
          },
          "25": {
            "name": "Marijampolė"
          },
          "26": {
            "name": "Mažeikiai"
          },
          "27": {
            "name": "Molėtai"
          },
          "28": {
            "name": "Neringa"
          },
          "29": {
            "name": "Pagėgiai"
          },
          "30": {
            "name": "Pakruojis"
          },
          "31": {
            "name": "Palanga"
          },
          "32": {
            "name": "Panevėžio Municipality"
          },
          "33": {
            "name": "Panevėžys"
          },
          "34": {
            "name": "Pasvalys"
          },
          "35": {
            "name": "Plungė"
          },
          "36": {
            "name": "Prienai"
          },
          "37": {
            "name": "Radviliškis"
          },
          "38": {
            "name": "Raseiniai"
          },
          "39": {
            "name": "Rietavas"
          },
          "40": {
            "name": "Rokiškis"
          },
          "41": {
            "name": "Šakiai"
          },
          "42": {
            "name": "Šalčininkai"
          },
          "43": {
            "name": "Šiaulių Municipality"
          },
          "44": {
            "name": "Šiauliai"
          },
          "45": {
            "name": "Šilalė"
          },
          "46": {
            "name": "Šilutė"
          },
          "47": {
            "name": "Širvintos"
          },
          "48": {
            "name": "Skuodas"
          },
          "49": {
            "name": "Švenčionys"
          },
          "50": {
            "name": "Tauragė"
          },
          "51": {
            "name": "Telšiai"
          },
          "52": {
            "name": "Trakai"
          },
          "53": {
            "name": "Ukmergė"
          },
          "54": {
            "name": "Utena"
          },
          "55": {
            "name": "Varėna"
          },
          "56": {
            "name": "Vilkaviškis"
          },
          "57": {
            "name": "Vilniaus Municipality"
          },
          "58": {
            "name": "Vilnius"
          },
          "59": {
            "name": "Visaginas"
          },
          "60": {
            "name": "Zarasai"
          },
          "al": {
            "name": "Alytus County"
          },
          "kl": {
            "name": "Klaipėda County"
          },
          "ku": {
            "name": "Kaunas County"
          },
          "mr": {
            "name": "Marijampolė County"
          },
          "pn": {
            "name": "Panevėžys County"
          },
          "sa": {
            "name": "Šiauliai County"
          },
          "ta": {
            "name": "Tauragė County"
          },
          "te": {
            "name": "Telšiai County"
          },
          "ut": {
            "name": "Utena County"
          },
          "vl": {
            "name": "Vilnius County"
          }
        }
      },
      "lu": {
        "name": "Luxembourg",
        "calling_code": "+352",
        "region": {
          "ca": {
            "name": "Capellen"
          },
          "cl": {
            "name": "Clervaux"
          },
          "di": {
            "name": "Diekirch"
          },
          "ec": {
            "name": "Echternach"
          },
          "es": {
            "name": "Esch-sur-Alzette"
          },
          "gr": {
            "name": "Grevenmacher"
          },
          "lu": {
            "name": "Luxembourg"
          },
          "me": {
            "name": "Mersch"
          },
          "rd": {
            "name": "Redange"
          },
          "rm": {
            "name": "Remich"
          },
          "vd": {
            "name": "Vianden"
          },
          "wi": {
            "name": "Wiltz"
          }
        }
      },
      "lv": {
        "name": "Latvia",
        "calling_code": "+371",
        "region": {
          "002": {
            "name": "Aizkraukle"
          },
          "007": {
            "name": "Alūksne"
          },
          "011": {
            "name": "Ādaži"
          },
          "015": {
            "name": "Balvi"
          },
          "016": {
            "name": "Bauska"
          },
          "022": {
            "name": "Cēsis"
          },
          "026": {
            "name": "Dobele"
          },
          "033": {
            "name": "Gulbene"
          },
          "041": {
            "name": "Jelgava Municipality"
          },
          "042": {
            "name": "Jēkabpils Municipality"
          },
          "047": {
            "name": "Krāslava"
          },
          "050": {
            "name": "Kuldīga"
          },
          "052": {
            "name": "Ķekava"
          },
          "054": {
            "name": "Limbaži"
          },
          "056": {
            "name": "Līvāni"
          },
          "058": {
            "name": "Ludza"
          },
          "059": {
            "name": "Madona"
          },
          "062": {
            "name": "Mārupe"
          },
          "067": {
            "name": "Ogre"
          },
          "068": {
            "name": "Olaine"
          },
          "073": {
            "name": "Preiļi"
          },
          "077": {
            "name": "Rēzekne Municipality"
          },
          "080": {
            "name": "Ropaži"
          },
          "087": {
            "name": "Salaspils"
          },
          "088": {
            "name": "Saldus"
          },
          "089": {
            "name": "Saulkrasti"
          },
          "091": {
            "name": "Sigulda"
          },
          "094": {
            "name": "Smiltene"
          },
          "097": {
            "name": "Talsi"
          },
          "099": {
            "name": "Tukums"
          },
          "101": {
            "name": "Valka"
          },
          "102": {
            "name": "Varakļāni"
          },
          "106": {
            "name": "Ventspils Municipality"
          },
          "111": {
            "name": "Augšdaugavas novads"
          },
          "112": {
            "name": "Dienvidkurzemes Novads"
          },
          "113": {
            "name": "Valmieras Novads"
          },
          "dgv": {
            "name": "Daugavpils"
          },
          "jel": {
            "name": "Jelgava"
          },
          "jur": {
            "name": "Jūrmala"
          },
          "lpx": {
            "name": "Liepāja"
          },
          "rez": {
            "name": "Rēzekne"
          },
          "rix": {
            "name": "Riga"
          },
          "ven": {
            "name": "Ventspils"
          }
        }
      },
      "ly": {
        "name": "Libya",
        "calling_code": "+218",
        "region": {
          "ba": {
            "name": "Benghazi"
          },
          "bu": {
            "name": "Butnan"
          },
          "dr": {
            "name": "Derna"
          },
          "gt": {
            "name": "Ghat"
          },
          "ja": {
            "name": "Jabal al Akhdar"
          },
          "jg": {
            "name": "Jabal al Gharbi"
          },
          "ji": {
            "name": "Jafara"
          },
          "ju": {
            "name": "Jufra"
          },
          "kf": {
            "name": "Kufra"
          },
          "mb": {
            "name": "Murqub"
          },
          "mi": {
            "name": "Misrata"
          },
          "mj": {
            "name": "Marj"
          },
          "mq": {
            "name": "Murzuq"
          },
          "nl": {
            "name": "Nalut"
          },
          "nq": {
            "name": "Nuqat al Khams"
          },
          "sb": {
            "name": "Sabha"
          },
          "sr": {
            "name": "Sirte"
          },
          "tb": {
            "name": "Tripoli"
          },
          "wa": {
            "name": "Al Wahat"
          },
          "wd": {
            "name": "Wadi al Hayaa"
          },
          "ws": {
            "name": "Wadi al Shatii"
          },
          "za": {
            "name": "Zawiya"
          }
        }
      },
      "ma": {
        "name": "Morocco",
        "calling_code": "+212",
        "region": {
          "01": {
            "name": "Tangier-Tétouan"
          },
          "02": {
            "name": "Gharb-Chrarda-Béni Hssen"
          },
          "03": {
            "name": "Taza-Al Hoceima-Taounate"
          },
          "04": {
            "name": "Oriental"
          },
          "05": {
            "name": "Fès-Boulemane"
          },
          "06": {
            "name": "Meknès-Tafilalet"
          },
          "07": {
            "name": "Rabat-Salé-Zemmour-Zaer"
          },
          "08": {
            "name": "Grand Casablanca"
          },
          "09": {
            "name": "Chaouia-Ouardigha"
          },
          "10": {
            "name": "Doukkala-Abda"
          },
          "11": {
            "name": "Marrakesh-Tensift-El Haouz"
          },
          "12": {
            "name": "Tadla-Azilal"
          },
          "agd": {
            "name": "Agadir-Ida Ou Tanane"
          },
          "aou": {
            "name": "Aousserd"
          },
          "asz": {
            "name": "Assa-Zag"
          },
          "azi": {
            "name": "Azilal"
          },
          "bah": {
            "name": "Aït Baha"
          },
          "bem": {
            "name": "Béni-Mellal"
          },
          "ber": {
            "name": "Berkane"
          },
          "bes": {
            "name": "Ben Slimane"
          },
          "bod": {
            "name": "Boujdour"
          },
          "bom": {
            "name": "Boulemane"
          },
          "brr": {
            "name": "Berrechid"
          },
          "cas": {
            "name": "Casablanca"
          },
          "che": {
            "name": "Chefchaouen"
          },
          "chi": {
            "name": "Chichaoua"
          },
          "cht": {
            "name": "Chtouka Aït Baha"
          },
          "dri": {
            "name": "Driouch"
          },
          "err": {
            "name": "Errachidia"
          },
          "esi": {
            "name": "Essaouira"
          },
          "esm": {
            "name": "Es Semara"
          },
          "fah": {
            "name": "Fahs-Beni Makada"
          },
          "fes": {
            "name": "Fès-Dar-Dbibegh"
          },
          "fig": {
            "name": "Figuig"
          },
          "fqh": {
            "name": "Fquih Ben Salah"
          },
          "gue": {
            "name": "Guelmim"
          },
          "guf": {
            "name": "Guercif"
          },
          "haj": {
            "name": "El Hajeb"
          },
          "hao": {
            "name": "Al Haouz"
          },
          "hoc": {
            "name": "Al Hoceïma"
          },
          "ifr": {
            "name": "Ifrane"
          },
          "ine": {
            "name": "Inezgane-Aït Melloul"
          },
          "jdi": {
            "name": "El Jadida"
          },
          "jra": {
            "name": "Jerada"
          },
          "ken": {
            "name": "Kénitra"
          },
          "kes": {
            "name": "Kelaat Sraghna"
          },
          "khe": {
            "name": "Khemisset"
          },
          "khn": {
            "name": "Khénifra"
          },
          "kho": {
            "name": "Khouribga"
          },
          "laa": {
            "name": "Laâyoune"
          },
          "lar": {
            "name": "Larache"
          },
          "mar": {
            "name": "Marrakech"
          },
          "mdf": {
            "name": "M’diq-Fnideq"
          },
          "med": {
            "name": "Médiouna"
          },
          "mek": {
            "name": "Meknès"
          },
          "mel": {
            "name": "Aït Melloul"
          },
          "mid": {
            "name": "Midelt"
          },
          "mmd": {
            "name": "Marrakech-Medina"
          },
          "mmn": {
            "name": "Marrakech-Menara"
          },
          "moh": {
            "name": "Mohammedia"
          },
          "mou": {
            "name": "Moulay Yacoub"
          },
          "nad": {
            "name": "Nador"
          },
          "nou": {
            "name": "Nouaceur"
          },
          "oua": {
            "name": "Ouarzazate"
          },
          "oud": {
            "name": "Oued Ed-Dahab"
          },
          "ouj": {
            "name": "Oujda-Angad"
          },
          "ouz": {
            "name": "Ouezzane"
          },
          "rab": {
            "name": "Rabat"
          },
          "reh": {
            "name": "Rehamna"
          },
          "saf": {
            "name": "Safi"
          },
          "sal": {
            "name": "Salé"
          },
          "sef": {
            "name": "Sefrou"
          },
          "set": {
            "name": "Settat"
          },
          "sib": {
            "name": "Sidi Bennour"
          },
          "sif": {
            "name": "Sidi Ifni"
          },
          "sik": {
            "name": "Sidi Kacem"
          },
          "sil": {
            "name": "Sidi Slimane"
          },
          "skh": {
            "name": "Skhirat-Témara"
          },
          "syb": {
            "name": "Sidi Youssef Ben Ali"
          },
          "taf": {
            "name": "Tarfaya (EH-partial)"
          },
          "tai": {
            "name": "Taourirt"
          },
          "tao": {
            "name": "Taounate"
          },
          "tar": {
            "name": "Taroudant"
          },
          "tat": {
            "name": "Tata"
          },
          "taz": {
            "name": "Taza"
          },
          "tet": {
            "name": "Tétouan"
          },
          "tin": {
            "name": "Tinghir"
          },
          "tiz": {
            "name": "Tiznit"
          },
          "tng": {
            "name": "Tangier-Assilah"
          },
          "tnt": {
            "name": "Tan-Tan"
          },
          "x1~": {
            "name": "Laayoune-Boujdour-Sakia El Hamra"
          },
          "yus": {
            "name": "Youssoufia"
          },
          "zag": {
            "name": "Zagora"
          }
        }
      },
      "mc": {
        "name": "Monaco",
        "calling_code": "+377",
        "region": {
          "cl": {
            "name": "La Colle"
          },
          "co": {
            "name": "La Condamine"
          },
          "fo": {
            "name": "Fontvieille"
          },
          "ga": {
            "name": "La Gare"
          },
          "je": {
            "name": "Jardin Exotique de Monaco"
          },
          "la": {
            "name": "Larvotto"
          },
          "ma": {
            "name": "Malbousquet"
          },
          "mc": {
            "name": "Monte Carlo"
          },
          "mg": {
            "name": "Moneghetti"
          },
          "mo": {
            "name": "Monaco-Ville"
          },
          "mu": {
            "name": "Moulins"
          },
          "ph": {
            "name": "Port Hercules"
          },
          "sd": {
            "name": "Sainte-Dévote Chapel"
          },
          "so": {
            "name": "La Source"
          },
          "sp": {
            "name": "Spélugues"
          },
          "sr": {
            "name": "Saint Roman"
          },
          "vr": {
            "name": "Vallon de la Rousse"
          }
        }
      },
      "md": {
        "name": "Moldova",
        "calling_code": "+373",
        "region": {
          "an": {
            "name": "Anenii Noi"
          },
          "ba": {
            "name": "Bălţi"
          },
          "bd": {
            "name": "Bender"
          },
          "br": {
            "name": "Briceni"
          },
          "bs": {
            "name": "Basarabeasca"
          },
          "ca": {
            "name": "Cahul"
          },
          "cl": {
            "name": "Călărași"
          },
          "cm": {
            "name": "Cimișlia"
          },
          "cr": {
            "name": "Criuleni"
          },
          "cs": {
            "name": "Căușeni"
          },
          "ct": {
            "name": "Cantemir"
          },
          "cu": {
            "name": "Chișinău"
          },
          "do": {
            "name": "Dondușeni"
          },
          "dr": {
            "name": "Drochia"
          },
          "du": {
            "name": "Dubăsari"
          },
          "ed": {
            "name": "Edineț"
          },
          "fa": {
            "name": "Fălești"
          },
          "fl": {
            "name": "Florești"
          },
          "ga": {
            "name": "Gagauzia"
          },
          "gl": {
            "name": "Glodeni"
          },
          "hi": {
            "name": "Hîncești"
          },
          "ia": {
            "name": "Ialoveni"
          },
          "le": {
            "name": "Leova"
          },
          "ni": {
            "name": "Nisporeni"
          },
          "oc": {
            "name": "Ocniţa"
          },
          "or": {
            "name": "Orhei"
          },
          "re": {
            "name": "Rezina"
          },
          "ri": {
            "name": "Rîșcani"
          },
          "sd": {
            "name": "Șoldănești"
          },
          "si": {
            "name": "Sîngerei"
          },
          "sn": {
            "name": "Transnistria"
          },
          "so": {
            "name": "Soroca"
          },
          "st": {
            "name": "Strășeni"
          },
          "sv": {
            "name": "Ştefan Vodă"
          },
          "ta": {
            "name": "Taraclia"
          },
          "te": {
            "name": "Telenești"
          },
          "un": {
            "name": "Ungheni"
          }
        }
      },
      "me": {
        "name": "Montenegro",
        "calling_code": "+382",
        "region": {
          "01": {
            "name": "Andrijevica"
          },
          "02": {
            "name": "Bar"
          },
          "03": {
            "name": "Berane"
          },
          "04": {
            "name": "Bijelo Polje"
          },
          "05": {
            "name": "Budva"
          },
          "06": {
            "name": "Cetinje"
          },
          "07": {
            "name": "Danilovgrad"
          },
          "08": {
            "name": "Herceg Novi"
          },
          "09": {
            "name": "Kolašin"
          },
          "10": {
            "name": "Kotor"
          },
          "11": {
            "name": "Mojkovac"
          },
          "12": {
            "name": "Nikšić"
          },
          "13": {
            "name": "Plav"
          },
          "14": {
            "name": "Pljevlja"
          },
          "15": {
            "name": "Plužine"
          },
          "16": {
            "name": "Podgorica"
          },
          "17": {
            "name": "Rožaje"
          },
          "18": {
            "name": "Šavnik"
          },
          "19": {
            "name": "Tivat"
          },
          "20": {
            "name": "Ulcinj"
          },
          "21": {
            "name": "Žabljak"
          },
          "22": {
            "name": "Gusinje"
          },
          "23": {
            "name": "Petnjica"
          },
          "24": {
            "name": "Tuzi"
          }
        }
      },
      "mf": {
        "name": "Saint Martin (French part)",
        "calling_code": "+590",
        "region": {}
      },
      "mg": {
        "name": "Madagascar",
        "calling_code": "+261",
        "region": {
          "a": {
            "name": "Toamasina"
          },
          "d": {
            "name": "Antsiranana"
          },
          "f": {
            "name": "Fianarantsoa"
          },
          "m": {
            "name": "Mahajanga"
          },
          "t": {
            "name": "Antananarivo"
          },
          "u": {
            "name": "Toliara"
          }
        }
      },
      "mh": {
        "name": "Marshall Islands",
        "calling_code": "+692",
        "region": {
          "alk": {
            "name": "Ailuk Atoll"
          },
          "all": {
            "name": "Ailinglaplap Atoll"
          },
          "arn": {
            "name": "Arno"
          },
          "aur": {
            "name": "Aur Atoll"
          },
          "ebo": {
            "name": "Ebon Atoll"
          },
          "eni": {
            "name": "Enewetak Atoll"
          },
          "jab": {
            "name": "Jabat Island"
          },
          "jal": {
            "name": "Jaluit Atoll"
          },
          "kil": {
            "name": "Kili Island"
          },
          "kwa": {
            "name": "Kwajalein"
          },
          "l": {
            "name": "Ralik Chain"
          },
          "lae": {
            "name": "Lae Atoll"
          },
          "lib": {
            "name": "Lib Island"
          },
          "lik": {
            "name": "Likiep Atoll"
          },
          "maj": {
            "name": "Majuro"
          },
          "mal": {
            "name": "Maloelap Atoll"
          },
          "mej": {
            "name": "Mejit Island"
          },
          "mil": {
            "name": "Mili Atoll"
          },
          "nmk": {
            "name": "Namdrik Atoll"
          },
          "nmu": {
            "name": "Namu Atoll"
          },
          "ron": {
            "name": "Rongelap Atoll"
          },
          "t": {
            "name": "Ratak Chain"
          },
          "uja": {
            "name": "Ujae Atoll"
          },
          "ujl": {
            "name": "Ujelang"
          },
          "uti": {
            "name": "Utirik Atoll"
          },
          "wth": {
            "name": "Wotho Atoll"
          },
          "wtj": {
            "name": "Wotje Atoll"
          }
        }
      },
      "mk": {
        "name": "North Macedonia",
        "calling_code": "+389",
        "region": {
          "101": {
            "name": "Veles"
          },
          "102": {
            "name": "Gradsko"
          },
          "103": {
            "name": "Demir Kapija"
          },
          "104": {
            "name": "Kavadarci"
          },
          "105": {
            "name": "Lozovo"
          },
          "106": {
            "name": "Negotino"
          },
          "107": {
            "name": "Rosoman"
          },
          "108": {
            "name": "Sveti Nikole"
          },
          "109": {
            "name": "Čaška"
          },
          "201": {
            "name": "Berovo"
          },
          "202": {
            "name": "Vinica"
          },
          "203": {
            "name": "Delčevo"
          },
          "204": {
            "name": "Zrnovci"
          },
          "205": {
            "name": "Karbinci"
          },
          "206": {
            "name": "Kočani"
          },
          "207": {
            "name": "Makedonska Kamenica"
          },
          "208": {
            "name": "Pehčevo"
          },
          "209": {
            "name": "Probištip"
          },
          "210": {
            "name": "Češinovo-Obleševo"
          },
          "211": {
            "name": "Štip"
          },
          "301": {
            "name": "Vevčani"
          },
          "303": {
            "name": "Debar"
          },
          "304": {
            "name": "Debarca"
          },
          "307": {
            "name": "Kičevo"
          },
          "308": {
            "name": "Makedonski Brod"
          },
          "310": {
            "name": "Ohrid"
          },
          "311": {
            "name": "Plasnica"
          },
          "312": {
            "name": "Struga"
          },
          "313": {
            "name": "Centar Župa"
          },
          "401": {
            "name": "Bogdanci"
          },
          "402": {
            "name": "Bosilovo"
          },
          "403": {
            "name": "Valandovo"
          },
          "404": {
            "name": "Vasilevo"
          },
          "405": {
            "name": "Gevgelija"
          },
          "406": {
            "name": "Dojran"
          },
          "407": {
            "name": "Konče"
          },
          "408": {
            "name": "Novo Selo"
          },
          "409": {
            "name": "Radoviš"
          },
          "410": {
            "name": "Strumica"
          },
          "501": {
            "name": "Bitola"
          },
          "502": {
            "name": "Demir Hisar"
          },
          "503": {
            "name": "Dolneni"
          },
          "504": {
            "name": "Krivogaštani"
          },
          "505": {
            "name": "Kruševo"
          },
          "506": {
            "name": "Mogila"
          },
          "507": {
            "name": "Novaci"
          },
          "508": {
            "name": "Prilep"
          },
          "509": {
            "name": "Resen"
          },
          "601": {
            "name": "Bogovinje"
          },
          "602": {
            "name": "Brvenica"
          },
          "603": {
            "name": "Vrapčište"
          },
          "604": {
            "name": "Gostivar"
          },
          "605": {
            "name": "Želino"
          },
          "606": {
            "name": "Jegunovce"
          },
          "607": {
            "name": "Mavrovo and Rostuša"
          },
          "608": {
            "name": "Tearce"
          },
          "609": {
            "name": "Tetovo"
          },
          "701": {
            "name": "Kratovo"
          },
          "702": {
            "name": "Kriva Palanka"
          },
          "703": {
            "name": "Kumanovo"
          },
          "704": {
            "name": "Lipkovo"
          },
          "705": {
            "name": "Rankovce"
          },
          "706": {
            "name": "Staro Nagoričane"
          },
          "801": {
            "name": "Aerodrom †"
          },
          "802": {
            "name": "Aračinovo"
          },
          "803": {
            "name": "Butel †"
          },
          "804": {
            "name": "Gazi Baba †"
          },
          "805": {
            "name": "Gjorče Petrov †"
          },
          "806": {
            "name": "Zelenikovo"
          },
          "807": {
            "name": "Ilinden"
          },
          "808": {
            "name": "Karpoš †"
          },
          "809": {
            "name": "Kisela Voda †"
          },
          "810": {
            "name": "Petrovec"
          },
          "811": {
            "name": "Saraj †"
          },
          "812": {
            "name": "Sopište"
          },
          "813": {
            "name": "Studeničani"
          },
          "814": {
            "name": "Centar †"
          },
          "815": {
            "name": "Čair †"
          },
          "816": {
            "name": "Čučer-Sandevo"
          },
          "817": {
            "name": "Šuto Orizari †"
          }
        }
      },
      "ml": {
        "name": "Mali",
        "calling_code": "+223",
        "region": {
          "1": {
            "name": "Kayes"
          },
          "10": {
            "name": "Taoudénit"
          },
          "2": {
            "name": "Koulikoro"
          },
          "3": {
            "name": "Sikasso"
          },
          "4": {
            "name": "Ségou"
          },
          "5": {
            "name": "Mopti"
          },
          "6": {
            "name": "Tombouctou"
          },
          "7": {
            "name": "Gao"
          },
          "8": {
            "name": "Kidal"
          },
          "9": {
            "name": "Ménaka"
          },
          "bko": {
            "name": "Bamako"
          }
        }
      },
      "mm": {
        "name": "Myanmar",
        "calling_code": "+95",
        "region": {
          "01": {
            "name": "Sagaing"
          },
          "02": {
            "name": "Bago"
          },
          "03": {
            "name": "Magway"
          },
          "04": {
            "name": "Mandalay"
          },
          "05": {
            "name": "Tanintharyi"
          },
          "06": {
            "name": "Yangon"
          },
          "07": {
            "name": "Ayeyarwady"
          },
          "11": {
            "name": "Kachin"
          },
          "12": {
            "name": "Kayah"
          },
          "13": {
            "name": "Kayin"
          },
          "14": {
            "name": "Chin"
          },
          "15": {
            "name": "Mon"
          },
          "16": {
            "name": "Rakhine"
          },
          "17": {
            "name": "Shan"
          },
          "18": {
            "name": "Naypyidaw"
          }
        }
      },
      "mn": {
        "name": "Mongolia",
        "calling_code": "+976",
        "region": {
          "035": {
            "name": "Orkhon"
          },
          "037": {
            "name": "Darkhan-Uul"
          },
          "039": {
            "name": "Khentii"
          },
          "041": {
            "name": "Khövsgöl"
          },
          "043": {
            "name": "Khovd"
          },
          "046": {
            "name": "Uvs"
          },
          "047": {
            "name": "Töv"
          },
          "049": {
            "name": "Selenge"
          },
          "051": {
            "name": "Sükhbaatar"
          },
          "053": {
            "name": "Ömnögovi"
          },
          "055": {
            "name": "Övörkhangai"
          },
          "057": {
            "name": "Zavkhan"
          },
          "059": {
            "name": "Dundgovi"
          },
          "061": {
            "name": "Dornod"
          },
          "063": {
            "name": "Dornogovi"
          },
          "064": {
            "name": "Govisümber"
          },
          "065": {
            "name": "Govi-Altai"
          },
          "067": {
            "name": "Bulgan"
          },
          "069": {
            "name": "Bayankhongor"
          },
          "071": {
            "name": "Bayan-Ölgii"
          },
          "073": {
            "name": "Arkhangai"
          },
          "1": {
            "name": "Ulaanbaatar"
          }
        }
      },
      "mo": {
        "name": "Macao",
        "calling_code": "+853",
        "region": {}
      },
      "mp": {
        "name": "Northern Mariana Islands",
        "calling_code": "+1",
        "region": {}
      },
      "mq": {
        "name": "Martinique",
        "calling_code": "+596",
        "region": {}
      },
      "mr": {
        "name": "Mauritania",
        "calling_code": "+222",
        "region": {
          "01": {
            "name": "Hodh Ech Chargui"
          },
          "02": {
            "name": "Hodh El Gharbi"
          },
          "03": {
            "name": "Assaba"
          },
          "04": {
            "name": "Gorgol"
          },
          "05": {
            "name": "Brakna"
          },
          "06": {
            "name": "Trarza"
          },
          "07": {
            "name": "Adrar"
          },
          "08": {
            "name": "Dakhlet Nouadhibou"
          },
          "09": {
            "name": "Tagant"
          },
          "10": {
            "name": "Guidimaka"
          },
          "11": {
            "name": "Tiris Zemmour"
          },
          "12": {
            "name": "Inchiri"
          },
          "13": {
            "name": "Nouakchott Ouest"
          },
          "14": {
            "name": "Nouakchott Nord"
          },
          "15": {
            "name": "Nouakchott Sud"
          }
        }
      },
      "ms": {
        "name": "Montserrat",
        "calling_code": "+1",
        "region": {}
      },
      "mt": {
        "name": "Malta",
        "calling_code": "+356",
        "region": {
          "01": {
            "name": "Attard"
          },
          "02": {
            "name": "Balzan"
          },
          "03": {
            "name": "Birgu"
          },
          "04": {
            "name": "Birkirkara"
          },
          "05": {
            "name": "Birżebbuġa"
          },
          "06": {
            "name": "Cospicua"
          },
          "07": {
            "name": "Dingli"
          },
          "08": {
            "name": "Fgura"
          },
          "09": {
            "name": "Floriana"
          },
          "10": {
            "name": "Fontana"
          },
          "11": {
            "name": "Gudja"
          },
          "12": {
            "name": "Gżira"
          },
          "13": {
            "name": "Għajnsielem"
          },
          "14": {
            "name": "Għarb"
          },
          "15": {
            "name": "Għargħur"
          },
          "16": {
            "name": "Għasri"
          },
          "17": {
            "name": "Għaxaq"
          },
          "18": {
            "name": "Ħamrun"
          },
          "19": {
            "name": "Iklin"
          },
          "20": {
            "name": "Senglea"
          },
          "21": {
            "name": "Kalkara"
          },
          "22": {
            "name": "Kerċem"
          },
          "23": {
            "name": "Kirkop"
          },
          "24": {
            "name": "Lija"
          },
          "25": {
            "name": "Luqa"
          },
          "26": {
            "name": "Marsa"
          },
          "27": {
            "name": "Marsaskala"
          },
          "28": {
            "name": "Marsaxlokk"
          },
          "29": {
            "name": "Mdina"
          },
          "30": {
            "name": "Mellieħa"
          },
          "31": {
            "name": "Mġarr"
          },
          "32": {
            "name": "Mosta"
          },
          "33": {
            "name": "Mqabba"
          },
          "34": {
            "name": "Msida"
          },
          "35": {
            "name": "Imtarfa"
          },
          "36": {
            "name": "Munxar"
          },
          "37": {
            "name": "Nadur"
          },
          "38": {
            "name": "Naxxar"
          },
          "39": {
            "name": "Paola"
          },
          "40": {
            "name": "Pembroke"
          },
          "41": {
            "name": "Pietà"
          },
          "42": {
            "name": "Qala"
          },
          "43": {
            "name": "Qormi"
          },
          "44": {
            "name": "Qrendi"
          },
          "45": {
            "name": "Victoria"
          },
          "46": {
            "name": "Rabat"
          },
          "47": {
            "name": "Safi"
          },
          "48": {
            "name": "St. Julian’s"
          },
          "49": {
            "name": "San Ġwann"
          },
          "50": {
            "name": "Saint Lawrence"
          },
          "51": {
            "name": "St. Paul’s Bay"
          },
          "52": {
            "name": "Sannat"
          },
          "53": {
            "name": "Santa Luċija"
          },
          "54": {
            "name": "Santa Venera"
          },
          "55": {
            "name": "Siġġiewi"
          },
          "56": {
            "name": "Sliema"
          },
          "57": {
            "name": "Swieqi"
          },
          "58": {
            "name": "Ta’ Xbiex"
          },
          "59": {
            "name": "Tarxien"
          },
          "60": {
            "name": "Valletta"
          },
          "61": {
            "name": "Xagħra"
          },
          "62": {
            "name": "Xewkija"
          },
          "63": {
            "name": "Xgħajra"
          },
          "64": {
            "name": "Żabbar"
          },
          "65": {
            "name": "Żebbuġ Gozo"
          },
          "66": {
            "name": "Żebbuġ"
          },
          "67": {
            "name": "Żejtun"
          },
          "68": {
            "name": "Żurrieq"
          }
        }
      },
      "mu": {
        "name": "Mauritius",
        "calling_code": "+230",
        "region": {
          "ag": {
            "name": "Agaléga"
          },
          "bl": {
            "name": "Rivière Noire"
          },
          "cc": {
            "name": "Cargados Carajos"
          },
          "fl": {
            "name": "Flacq"
          },
          "gp": {
            "name": "Grand Port"
          },
          "mo": {
            "name": "Moka"
          },
          "pa": {
            "name": "Pamplemousses"
          },
          "pl": {
            "name": "Port Louis District"
          },
          "pw": {
            "name": "Plaines Wilhems"
          },
          "ro": {
            "name": "Rodrigues"
          },
          "rr": {
            "name": "Rivière du Rempart"
          },
          "sa": {
            "name": "Savanne"
          }
        }
      },
      "mv": {
        "name": "Maldives",
        "calling_code": "+960",
        "region": {
          "00": {
            "name": "South Ari Atoll"
          },
          "01": {
            "name": "Addu City"
          },
          "02": {
            "name": "Alif Alif"
          },
          "03": {
            "name": "Faadhippolhu"
          },
          "04": {
            "name": "Felidhu Atoll"
          },
          "05": {
            "name": "Hahdhunmathi"
          },
          "07": {
            "name": "North Thiladhunmathi"
          },
          "08": {
            "name": "Kolhumadulu"
          },
          "12": {
            "name": "Mulaku Atoll"
          },
          "13": {
            "name": "North Maalhosmadulu"
          },
          "14": {
            "name": "North Nilandhe Atoll"
          },
          "17": {
            "name": "South Nilandhe Atoll"
          },
          "20": {
            "name": "South Maalhosmadulu"
          },
          "23": {
            "name": "South Thiladhunmathi"
          },
          "24": {
            "name": "North Miladhunmadulu"
          },
          "25": {
            "name": "South Miladhunmadulu"
          },
          "26": {
            "name": "Male Atoll"
          },
          "27": {
            "name": "North Huvadhu Atoll"
          },
          "28": {
            "name": "South Huvadhu Atoll"
          },
          "29": {
            "name": "Fuvammulah"
          },
          "mle": {
            "name": "Malé"
          }
        }
      },
      "mw": {
        "name": "Malawi",
        "calling_code": "+265",
        "region": {
          "ba": {
            "name": "Balaka"
          },
          "bl": {
            "name": "Blantyre"
          },
          "c": {
            "name": "Central"
          },
          "ck": {
            "name": "Chikwawa"
          },
          "cr": {
            "name": "Chiradzulu"
          },
          "ct": {
            "name": "Chitipa"
          },
          "de": {
            "name": "Dedza"
          },
          "do": {
            "name": "Dowa"
          },
          "kr": {
            "name": "Karonga"
          },
          "ks": {
            "name": "Kasungu"
          },
          "li": {
            "name": "Lilongwe"
          },
          "lk": {
            "name": "Likoma"
          },
          "mc": {
            "name": "Mchinji"
          },
          "mg": {
            "name": "Mangochi"
          },
          "mh": {
            "name": "Machinga"
          },
          "mu": {
            "name": "Mulanje"
          },
          "mw": {
            "name": "Mwanza"
          },
          "mz": {
            "name": "Mzimba"
          },
          "n": {
            "name": "Northern"
          },
          "nb": {
            "name": "Nkhata Bay"
          },
          "ne": {
            "name": "Neno"
          },
          "ni": {
            "name": "Ntchisi"
          },
          "nk": {
            "name": "Nkhotakota"
          },
          "ns": {
            "name": "Nsanje"
          },
          "nu": {
            "name": "Ntcheu"
          },
          "ph": {
            "name": "Phalombe"
          },
          "ru": {
            "name": "Rumphi"
          },
          "s": {
            "name": "Southern"
          },
          "sa": {
            "name": "Salima"
          },
          "th": {
            "name": "Thyolo"
          },
          "zo": {
            "name": "Zomba"
          }
        }
      },
      "mx": {
        "name": "Mexico",
        "calling_code": "+52",
        "region": {
          "agu": {
            "name": "Aguascalientes"
          },
          "bcn": {
            "name": "Baja California"
          },
          "bcs": {
            "name": "Baja California Sur"
          },
          "cam": {
            "name": "Campeche"
          },
          "chh": {
            "name": "Chihuahua"
          },
          "chp": {
            "name": "Chiapas"
          },
          "cmx": {
            "name": "Ciudad de Mexico"
          },
          "coa": {
            "name": "Coahuila"
          },
          "col": {
            "name": "Colima"
          },
          "dur": {
            "name": "Durango"
          },
          "gro": {
            "name": "Guerrero"
          },
          "gua": {
            "name": "Guanajuato"
          },
          "hid": {
            "name": "Hidalgo"
          },
          "jal": {
            "name": "Jalisco"
          },
          "mex": {
            "name": "Mexico State"
          },
          "mic": {
            "name": "Michoacán"
          },
          "mor": {
            "name": "Morelos"
          },
          "nay": {
            "name": "Nayarit"
          },
          "nle": {
            "name": "Nuevo León"
          },
          "oax": {
            "name": "Oaxaca"
          },
          "pue": {
            "name": "Puebla"
          },
          "que": {
            "name": "Querétaro"
          },
          "roo": {
            "name": "Quintana Roo"
          },
          "sin": {
            "name": "Sinaloa"
          },
          "slp": {
            "name": "San Luis Potosí"
          },
          "son": {
            "name": "Sonora"
          },
          "tab": {
            "name": "Tabasco"
          },
          "tam": {
            "name": "Tamaulipas"
          },
          "tla": {
            "name": "Tlaxcala"
          },
          "ver": {
            "name": "Veracruz"
          },
          "yuc": {
            "name": "Yucatán"
          },
          "zac": {
            "name": "Zacatecas"
          }
        }
      },
      "my": {
        "name": "Malaysia",
        "calling_code": "+60",
        "region": {
          "01": {
            "name": "Johor"
          },
          "02": {
            "name": "Kedah"
          },
          "03": {
            "name": "Kelantan"
          },
          "04": {
            "name": "Malacca"
          },
          "05": {
            "name": "Negeri Sembilan"
          },
          "06": {
            "name": "Pahang"
          },
          "07": {
            "name": "Penang"
          },
          "08": {
            "name": "Perak"
          },
          "09": {
            "name": "Perlis"
          },
          "10": {
            "name": "Selangor"
          },
          "11": {
            "name": "Terengganu"
          },
          "12": {
            "name": "Sabah"
          },
          "13": {
            "name": "Sarawak"
          },
          "14": {
            "name": "Kuala Lumpur"
          },
          "15": {
            "name": "Labuan"
          },
          "16": {
            "name": "Putrajaya"
          }
        }
      },
      "mz": {
        "name": "Mozambique",
        "calling_code": "+258",
        "region": {
          "a": {
            "name": "Niassa"
          },
          "b": {
            "name": "Manica"
          },
          "g": {
            "name": "Gaza"
          },
          "i": {
            "name": "Inhambane"
          },
          "l": {
            "name": "Maputo Province"
          },
          "mpm": {
            "name": "Maputo"
          },
          "n": {
            "name": "Nampula"
          },
          "p": {
            "name": "Cabo Delgado"
          },
          "q": {
            "name": "Zambezia"
          },
          "s": {
            "name": "Sofala"
          },
          "t": {
            "name": "Tete"
          }
        }
      },
      "na": {
        "name": "Namibia",
        "calling_code": "+264",
        "region": {
          "ca": {
            "name": "Zambezi"
          },
          "er": {
            "name": "Erongo"
          },
          "ha": {
            "name": "Hardap"
          },
          "ka": {
            "name": "Karas"
          },
          "ke": {
            "name": "Kavango East"
          },
          "kh": {
            "name": "Khomas"
          },
          "ku": {
            "name": "Kunene"
          },
          "kw": {
            "name": "Kavango West"
          },
          "od": {
            "name": "Otjozondjupa"
          },
          "oh": {
            "name": "Omaheke"
          },
          "on": {
            "name": "Oshana"
          },
          "os": {
            "name": "Omusati"
          },
          "ot": {
            "name": "Oshikoto"
          },
          "ow": {
            "name": "Ohangwena"
          }
        }
      },
      "nc": {
        "name": "New Caledonia",
        "calling_code": "+687",
        "region": {}
      },
      "ne": {
        "name": "Niger",
        "calling_code": "+227",
        "region": {
          "1": {
            "name": "Agadez"
          },
          "2": {
            "name": "Diffa"
          },
          "3": {
            "name": "Dosso"
          },
          "4": {
            "name": "Maradi"
          },
          "5": {
            "name": "Tahoua"
          },
          "6": {
            "name": "Tillabéri"
          },
          "7": {
            "name": "Zinder"
          },
          "8": {
            "name": "Niamey"
          }
        }
      },
      "nf": {
        "name": "Norfolk Island",
        "calling_code": "+672",
        "region": {}
      },
      "ng": {
        "name": "Nigeria",
        "calling_code": "+234",
        "region": {
          "ab": {
            "name": "Abia"
          },
          "ad": {
            "name": "Adamawa"
          },
          "ak": {
            "name": "Akwa Ibom"
          },
          "an": {
            "name": "Anambra"
          },
          "ba": {
            "name": "Bauchi"
          },
          "be": {
            "name": "Benue"
          },
          "bo": {
            "name": "Borno"
          },
          "by": {
            "name": "Bayelsa"
          },
          "cr": {
            "name": "Cross River"
          },
          "de": {
            "name": "Delta"
          },
          "eb": {
            "name": "Ebonyi"
          },
          "ed": {
            "name": "Edo"
          },
          "ek": {
            "name": "Ekiti"
          },
          "en": {
            "name": "Enugu"
          },
          "fc": {
            "name": "Federal Capital Territory"
          },
          "go": {
            "name": "Gombe"
          },
          "im": {
            "name": "Imo"
          },
          "ji": {
            "name": "Jigawa"
          },
          "kd": {
            "name": "Kaduna"
          },
          "ke": {
            "name": "Kebbi"
          },
          "kn": {
            "name": "Kano"
          },
          "ko": {
            "name": "Kogi"
          },
          "kt": {
            "name": "Katsina"
          },
          "kw": {
            "name": "Kwara"
          },
          "la": {
            "name": "Lagos"
          },
          "na": {
            "name": "Nasarawa"
          },
          "ni": {
            "name": "Niger"
          },
          "og": {
            "name": "Ogun"
          },
          "on": {
            "name": "Ondo"
          },
          "os": {
            "name": "Osun"
          },
          "oy": {
            "name": "Oyo"
          },
          "pl": {
            "name": "Plateau"
          },
          "ri": {
            "name": "Rivers"
          },
          "so": {
            "name": "Sokoto"
          },
          "ta": {
            "name": "Taraba"
          },
          "yo": {
            "name": "Yobe"
          },
          "za": {
            "name": "Zamfara"
          }
        }
      },
      "ni": {
        "name": "Nicaragua",
        "calling_code": "+505",
        "region": {
          "an": {
            "name": "Atlántico Norte"
          },
          "as": {
            "name": "Atlántico Sur"
          },
          "bo": {
            "name": "Boaco"
          },
          "ca": {
            "name": "Carazo"
          },
          "ci": {
            "name": "Chinandega"
          },
          "co": {
            "name": "Chontales"
          },
          "es": {
            "name": "Estelí"
          },
          "gr": {
            "name": "Granada"
          },
          "ji": {
            "name": "Jinotega"
          },
          "le": {
            "name": "León"
          },
          "md": {
            "name": "Madriz"
          },
          "mn": {
            "name": "Managua"
          },
          "ms": {
            "name": "Masaya"
          },
          "mt": {
            "name": "Matagalpa"
          },
          "ns": {
            "name": "Nueva Segovia"
          },
          "ri": {
            "name": "Rivas"
          },
          "sj": {
            "name": "Río San Juan"
          }
        }
      },
      "nl": {
        "name": "Netherlands",
        "calling_code": "+31",
        "region": {
          "aw": {
            "name": "Aruba"
          },
          "bq1": {
            "name": "Bonaire"
          },
          "bq2": {
            "name": "Saba"
          },
          "bq3": {
            "name": "Sint Eustatius"
          },
          "cw": {
            "name": "Curaçao"
          },
          "dr": {
            "name": "Drenthe"
          },
          "fl": {
            "name": "Flevoland"
          },
          "fr": {
            "name": "Friesland"
          },
          "ge": {
            "name": "Gelderland"
          },
          "gr": {
            "name": "Groningen"
          },
          "li": {
            "name": "Limburg"
          },
          "nb": {
            "name": "North Brabant"
          },
          "nh": {
            "name": "North Holland"
          },
          "ov": {
            "name": "Overijssel"
          },
          "sx": {
            "name": "Sint Maarten"
          },
          "ut": {
            "name": "Utrecht"
          },
          "ze": {
            "name": "Zeeland"
          },
          "zh": {
            "name": "South Holland"
          }
        }
      },
      "no": {
        "name": "Norway",
        "calling_code": "+47",
        "region": {
          "03": {
            "name": "Oslo"
          },
          "11": {
            "name": "Rogaland"
          },
          "15": {
            "name": "Møre og Romsdal"
          },
          "18": {
            "name": "Nordland"
          },
          "21": {
            "name": "Svalbard"
          },
          "22": {
            "name": "Jan Mayen"
          },
          "30": {
            "name": "Viken"
          },
          "34": {
            "name": "Innlandet"
          },
          "38": {
            "name": "Vestfold og Telemark"
          },
          "42": {
            "name": "Agder"
          },
          "46": {
            "name": "Vestland"
          },
          "50": {
            "name": "Trøndelag"
          },
          "54": {
            "name": "Troms og Finnmark fylke"
          }
        }
      },
      "np": {
        "name": "Nepal",
        "calling_code": "+977",
        "region": {
          "1": {
            "name": "Central"
          },
          "2": {
            "name": "Madhya Pashchimanchal"
          },
          "3": {
            "name": "Western"
          },
          "4": {
            "name": "Purwanchal"
          },
          "5": {
            "name": "Sudur Pashchimanchal"
          },
          "ba": {
            "name": "Bagmati"
          },
          "bh": {
            "name": "Bheri"
          },
          "dh": {
            "name": "Dhawalagiri"
          },
          "ga": {
            "name": "Gandaki"
          },
          "ja": {
            "name": "Janakpur"
          },
          "ka": {
            "name": "Karnali"
          },
          "ko": {
            "name": "Kosi"
          },
          "lu": {
            "name": "Lumbini"
          },
          "ma": {
            "name": "Mahakali"
          },
          "me": {
            "name": "Mechi"
          },
          "na": {
            "name": "Narayani"
          },
          "p1": {
            "name": "Koshi Province"
          },
          "p2": {
            "name": "Madhesh Province"
          },
          "p3": {
            "name": "Bagmati Province"
          },
          "p4": {
            "name": "Gandaki Province"
          },
          "p5": {
            "name": "Lumbini Province"
          },
          "p6": {
            "name": "Karnali Province"
          },
          "p7": {
            "name": "Sudurpashchim Province"
          },
          "ra": {
            "name": "Rapti"
          },
          "sa": {
            "name": "Sagarmatha"
          },
          "se": {
            "name": "Seti"
          }
        }
      },
      "nr": {
        "name": "Nauru",
        "calling_code": "+674",
        "region": {
          "01": {
            "name": "Aiwo"
          },
          "02": {
            "name": "Anabar"
          },
          "03": {
            "name": "Anetan"
          },
          "04": {
            "name": "Anibare"
          },
          "05": {
            "name": "Baiti"
          },
          "06": {
            "name": "Boe"
          },
          "07": {
            "name": "Buada"
          },
          "08": {
            "name": "Denigomodu"
          },
          "09": {
            "name": "Ewa"
          },
          "10": {
            "name": "Ijuw"
          },
          "11": {
            "name": "Meneng"
          },
          "12": {
            "name": "Nibok"
          },
          "13": {
            "name": "Uaboe"
          },
          "14": {
            "name": "Yaren"
          }
        }
      },
      "nu": {
        "name": "Niue",
        "calling_code": "+683",
        "region": {}
      },
      "nz": {
        "name": "New Zealand",
        "calling_code": "+64",
        "region": {
          "auk": {
            "name": "Auckland"
          },
          "bop": {
            "name": "Bay of Plenty"
          },
          "can": {
            "name": "Canterbury"
          },
          "cit": {
            "name": "Chatham Islands"
          },
          "gis": {
            "name": "Gisborne"
          },
          "hkb": {
            "name": "Hawke’s Bay"
          },
          "mbh": {
            "name": "Marlborough"
          },
          "mwt": {
            "name": "Manawatu-Wanganui"
          },
          "nsn": {
            "name": "Nelson"
          },
          "ntl": {
            "name": "Northland"
          },
          "ota": {
            "name": "Otago"
          },
          "stl": {
            "name": "Southland"
          },
          "tas": {
            "name": "Tasman"
          },
          "tki": {
            "name": "Taranaki"
          },
          "wgn": {
            "name": "Wellington"
          },
          "wko": {
            "name": "Waikato"
          },
          "wtc": {
            "name": "West Coast"
          }
        }
      },
      "om": {
        "name": "Oman",
        "calling_code": "+968",
        "region": {
          "bj": {
            "name": "Janub al Batinah"
          },
          "bs": {
            "name": "Shamal al Batinah"
          },
          "bu": {
            "name": "Al Buraimi"
          },
          "da": {
            "name": "Ad Dakhiliyah"
          },
          "ma": {
            "name": "Muscat"
          },
          "mu": {
            "name": "Musandam"
          },
          "sj": {
            "name": "Janub ash Sharqiyah"
          },
          "ss": {
            "name": "Shamal ash Sharqiyah"
          },
          "wu": {
            "name": "Al Wusta"
          },
          "za": {
            "name": "Ad Dhahirah"
          },
          "zu": {
            "name": "Dhofar"
          }
        }
      },
      "pa": {
        "name": "Panama",
        "calling_code": "+507",
        "region": {
          "1": {
            "name": "Bocas del Toro"
          },
          "10": {
            "name": "West Panamá"
          },
          "2": {
            "name": "Coclé"
          },
          "3": {
            "name": "Colón"
          },
          "4": {
            "name": "Chiriquí"
          },
          "5": {
            "name": "Darién"
          },
          "6": {
            "name": "Herrera"
          },
          "7": {
            "name": "Los Santos"
          },
          "8": {
            "name": "Panamá"
          },
          "9": {
            "name": "Veraguas"
          },
          "em": {
            "name": "Emberá"
          },
          "ky": {
            "name": "Guna Yala"
          },
          "nb": {
            "name": "Ngöbe-Buglé"
          }
        }
      },
      "pe": {
        "name": "Peru",
        "calling_code": "+51",
        "region": {
          "ama": {
            "name": "Amazonas"
          },
          "anc": {
            "name": "Ancash"
          },
          "apu": {
            "name": "Apurímac"
          },
          "are": {
            "name": "Arequipa"
          },
          "aya": {
            "name": "Ayacucho"
          },
          "caj": {
            "name": "Cajamarca"
          },
          "cal": {
            "name": "El Callao"
          },
          "cus": {
            "name": "Cusco"
          },
          "huc": {
            "name": "Huánuco"
          },
          "huv": {
            "name": "Huancavelica"
          },
          "ica": {
            "name": "Ica"
          },
          "jun": {
            "name": "Junín"
          },
          "lal": {
            "name": "La Libertad"
          },
          "lam": {
            "name": "Lambayeque"
          },
          "lim": {
            "name": "Lima Region"
          },
          "lma": {
            "name": "Lima"
          },
          "lor": {
            "name": "Loreto"
          },
          "mdd": {
            "name": "Madre de Dios"
          },
          "moq": {
            "name": "Moquegua"
          },
          "pas": {
            "name": "Pasco"
          },
          "piu": {
            "name": "Piura"
          },
          "pun": {
            "name": "Puno"
          },
          "sam": {
            "name": "San Martín"
          },
          "tac": {
            "name": "Tacna"
          },
          "tum": {
            "name": "Tumbes"
          },
          "uca": {
            "name": "Ucayali"
          }
        }
      },
      "pf": {
        "name": "French Polynesia",
        "calling_code": "+689",
        "region": {}
      },
      "pg": {
        "name": "Papua New Guinea",
        "calling_code": "+675",
        "region": {
          "cpk": {
            "name": "Chimbu"
          },
          "cpm": {
            "name": "Central"
          },
          "ebr": {
            "name": "East New Britain"
          },
          "ehg": {
            "name": "Eastern Highlands"
          },
          "epw": {
            "name": "Enga"
          },
          "esw": {
            "name": "East Sepik"
          },
          "gpk": {
            "name": "Gulf"
          },
          "hla": {
            "name": "Hela"
          },
          "jwk": {
            "name": "Jiwaka"
          },
          "mba": {
            "name": "Milne Bay"
          },
          "mpl": {
            "name": "Morobe"
          },
          "mpm": {
            "name": "Madang"
          },
          "mrl": {
            "name": "Manus"
          },
          "ncd": {
            "name": "Port Moresby"
          },
          "nik": {
            "name": "New Ireland"
          },
          "npp": {
            "name": "Oro"
          },
          "nsb": {
            "name": "Bougainville"
          },
          "san": {
            "name": "Sandaun"
          },
          "shm": {
            "name": "Southern Highlands"
          },
          "wbk": {
            "name": "West New Britain"
          },
          "whm": {
            "name": "Western Highlands"
          },
          "wpd": {
            "name": "Western"
          }
        }
      },
      "ph": {
        "name": "Philippines",
        "calling_code": "+63",
        "region": {
          "00": {
            "name": "Metro Manila"
          },
          "01": {
            "name": "Ilocos"
          },
          "02": {
            "name": "Cagayan Valley"
          },
          "03": {
            "name": "Central Luzon"
          },
          "05": {
            "name": "Bicol"
          },
          "06": {
            "name": "Western Visayas"
          },
          "07": {
            "name": "Central Visayas"
          },
          "08": {
            "name": "Eastern Visayas"
          },
          "09": {
            "name": "Zamboanga Peninsula"
          },
          "10": {
            "name": "Northern Mindanao"
          },
          "11": {
            "name": "Davao"
          },
          "12": {
            "name": "Soccsksargen"
          },
          "13": {
            "name": "Caraga"
          },
          "14": {
            "name": "Muslim Mindanao"
          },
          "15": {
            "name": "Cordillera Administrative"
          },
          "40": {
            "name": "Calabarzon"
          },
          "41": {
            "name": "Mimaropa"
          },
          "abr": {
            "name": "Abra"
          },
          "agn": {
            "name": "Agusan del Norte"
          },
          "ags": {
            "name": "Agusan del Sur"
          },
          "akl": {
            "name": "Aklan"
          },
          "alb": {
            "name": "Albay"
          },
          "ant": {
            "name": "Antique"
          },
          "apa": {
            "name": "Apayao"
          },
          "aur": {
            "name": "Aurora"
          },
          "ban": {
            "name": "Bataan"
          },
          "bas": {
            "name": "Basilan"
          },
          "ben": {
            "name": "Benguet"
          },
          "bil": {
            "name": "Biliran"
          },
          "boh": {
            "name": "Bohol"
          },
          "btg": {
            "name": "Batangas"
          },
          "btn": {
            "name": "Batanes"
          },
          "buk": {
            "name": "Bukidnon"
          },
          "bul": {
            "name": "Bulacan"
          },
          "cag": {
            "name": "Cagayan"
          },
          "cam": {
            "name": "Camiguin"
          },
          "can": {
            "name": "Camarines Norte"
          },
          "cap": {
            "name": "Capiz"
          },
          "cas": {
            "name": "Camarines Sur"
          },
          "cat": {
            "name": "Catanduanes"
          },
          "cav": {
            "name": "Cavite"
          },
          "ceb": {
            "name": "Cebu"
          },
          "com": {
            "name": "Compostela Valley"
          },
          "dao": {
            "name": "Davao Oriental"
          },
          "das": {
            "name": "Davao del Sur"
          },
          "dav": {
            "name": "Davao del Norte"
          },
          "din": {
            "name": "Dinagat Islands"
          },
          "dvo": {
            "name": "Davao Occidental"
          },
          "eas": {
            "name": "Eastern Samar"
          },
          "gui": {
            "name": "Guimaras"
          },
          "ifu": {
            "name": "Ifugao"
          },
          "ili": {
            "name": "Iloilo"
          },
          "iln": {
            "name": "Ilocos Norte"
          },
          "ils": {
            "name": "Ilocos Sur"
          },
          "isa": {
            "name": "Isabela"
          },
          "kal": {
            "name": "Kalinga"
          },
          "lag": {
            "name": "Laguna"
          },
          "lan": {
            "name": "Lanao del Norte"
          },
          "las": {
            "name": "Lanao del Sur"
          },
          "ley": {
            "name": "Leyte"
          },
          "lun": {
            "name": "La Union"
          },
          "mad": {
            "name": "Marinduque"
          },
          "mag": {
            "name": "Maguindanao"
          },
          "mas": {
            "name": "Masbate"
          },
          "mdc": {
            "name": "Occidental Mindoro"
          },
          "mdr": {
            "name": "Oriental Mindoro"
          },
          "mou": {
            "name": "Mountain"
          },
          "msc": {
            "name": "Misamis Occidental"
          },
          "msr": {
            "name": "Misamis Oriental"
          },
          "nco": {
            "name": "Cotabato"
          },
          "nec": {
            "name": "Negros Occidental"
          },
          "ner": {
            "name": "Negros Oriental"
          },
          "nsa": {
            "name": "Northern Samar"
          },
          "nue": {
            "name": "Nueva Ecija"
          },
          "nuv": {
            "name": "Nueva Vizcaya"
          },
          "pam": {
            "name": "Pampanga"
          },
          "pan": {
            "name": "Pangasinan"
          },
          "plw": {
            "name": "Palawan"
          },
          "que": {
            "name": "Quezon"
          },
          "qui": {
            "name": "Quirino"
          },
          "riz": {
            "name": "Rizal"
          },
          "rom": {
            "name": "Romblon"
          },
          "sar": {
            "name": "Sarangani"
          },
          "sco": {
            "name": "South Cotabato"
          },
          "sig": {
            "name": "Siquijor"
          },
          "sle": {
            "name": "Southern Leyte"
          },
          "slu": {
            "name": "Sulu"
          },
          "sor": {
            "name": "Sorsogon"
          },
          "suk": {
            "name": "Sultan Kudarat"
          },
          "sun": {
            "name": "Surigao del Norte"
          },
          "sur": {
            "name": "Surigao del Sur"
          },
          "tar": {
            "name": "Tarlac"
          },
          "taw": {
            "name": "Tawi-Tawi"
          },
          "wsa": {
            "name": "Samar"
          },
          "zan": {
            "name": "Zamboanga del Norte"
          },
          "zas": {
            "name": "Zamboanga del Sur"
          },
          "zmb": {
            "name": "Zambales"
          },
          "zsi": {
            "name": "Zamboanga Sibugay"
          }
        }
      },
      "pk": {
        "name": "Pakistan",
        "calling_code": "+92",
        "region": {
          "ba": {
            "name": "Balochistan"
          },
          "gb": {
            "name": "Gilgit-Baltistan"
          },
          "is": {
            "name": "Islamabad"
          },
          "jk": {
            "name": "Azad Kashmir"
          },
          "kp": {
            "name": "Khyber Pakhtunkhwa"
          },
          "pb": {
            "name": "Punjab"
          },
          "sd": {
            "name": "Sindh"
          }
        }
      },
      "pl": {
        "name": "Poland",
        "calling_code": "+48",
        "region": {
          "02": {
            "name": "Lower Silesia"
          },
          "04": {
            "name": "Kuyavia-Pomerania"
          },
          "06": {
            "name": "Lublin"
          },
          "08": {
            "name": "Lubusz"
          },
          "10": {
            "name": "Łódź"
          },
          "12": {
            "name": "Lesser Poland"
          },
          "14": {
            "name": "Mazovia"
          },
          "16": {
            "name": "Opole"
          },
          "18": {
            "name": "Subcarpathia"
          },
          "20": {
            "name": "Podlachia"
          },
          "22": {
            "name": "Pomerania"
          },
          "24": {
            "name": "Silesia"
          },
          "26": {
            "name": "Holy Cross"
          },
          "28": {
            "name": "Warmia-Masuria"
          },
          "30": {
            "name": "Greater Poland"
          },
          "32": {
            "name": "West Pomerania"
          }
        }
      },
      "pm": {
        "name": "Saint Pierre and Miquelon",
        "calling_code": "+508",
        "region": {}
      },
      "pn": {
        "name": "Pitcairn",
        "calling_code": "+64",
        "region": {}
      },
      "pr": {
        "name": "Puerto Rico",
        "calling_code": "+1",
        "region": {}
      },
      "ps": {
        "name": "Palestine, State of",
        "calling_code": "+970",
        "region": {
          "bth": {
            "name": "Bethlehem"
          },
          "deb": {
            "name": "Deir al-Balah"
          },
          "gza": {
            "name": "Gaza"
          },
          "hbn": {
            "name": "Hebron"
          },
          "jem": {
            "name": "Jerusalem"
          },
          "jen": {
            "name": "Jenin"
          },
          "jrh": {
            "name": "Jericho"
          },
          "kys": {
            "name": "Khan Yunis"
          },
          "nbs": {
            "name": "Nablus"
          },
          "ngz": {
            "name": "North Gaza"
          },
          "qqa": {
            "name": "Qalqilya"
          },
          "rbh": {
            "name": "Ramallah and al-Bireh"
          },
          "rfh": {
            "name": "Rafah"
          },
          "slt": {
            "name": "Salfit"
          },
          "tbs": {
            "name": "Tubas"
          },
          "tkm": {
            "name": "Tulkarm"
          }
        }
      },
      "pt": {
        "name": "Portugal",
        "calling_code": "+351",
        "region": {
          "01": {
            "name": "Aveiro"
          },
          "02": {
            "name": "Beja"
          },
          "03": {
            "name": "Braga"
          },
          "04": {
            "name": "Bragança"
          },
          "05": {
            "name": "Castelo Branco"
          },
          "06": {
            "name": "Coimbra"
          },
          "07": {
            "name": "Évora"
          },
          "08": {
            "name": "Faro"
          },
          "09": {
            "name": "Guarda"
          },
          "10": {
            "name": "Leiria"
          },
          "11": {
            "name": "Lisbon"
          },
          "12": {
            "name": "Portalegre"
          },
          "13": {
            "name": "Porto"
          },
          "14": {
            "name": "Santarém"
          },
          "15": {
            "name": "Setúbal"
          },
          "16": {
            "name": "Viana do Castelo"
          },
          "17": {
            "name": "Vila Real"
          },
          "18": {
            "name": "Viseu"
          },
          "20": {
            "name": "Azores"
          },
          "30": {
            "name": "Madeira"
          }
        }
      },
      "pw": {
        "name": "Palau",
        "calling_code": "+680",
        "region": {
          "002": {
            "name": "Aimeliik"
          },
          "004": {
            "name": "Airai"
          },
          "010": {
            "name": "Angaur"
          },
          "050": {
            "name": "Hatohobei"
          },
          "100": {
            "name": "Kayangel"
          },
          "150": {
            "name": "Koror"
          },
          "212": {
            "name": "Melekeok"
          },
          "214": {
            "name": "Ngaraard"
          },
          "218": {
            "name": "Ngarchelong"
          },
          "222": {
            "name": "Ngardmau"
          },
          "224": {
            "name": "Ngatpang"
          },
          "226": {
            "name": "Ngchesar"
          },
          "227": {
            "name": "Ngeremlengui"
          },
          "228": {
            "name": "Ngiwal"
          },
          "350": {
            "name": "Peleliu"
          },
          "370": {
            "name": "Sonsorol"
          }
        }
      },
      "py": {
        "name": "Paraguay",
        "calling_code": "+595",
        "region": {
          "1": {
            "name": "Concepción"
          },
          "10": {
            "name": "Alto Paraná"
          },
          "11": {
            "name": "Central"
          },
          "12": {
            "name": "Ñeembucú"
          },
          "13": {
            "name": "Amambay"
          },
          "14": {
            "name": "Canindeyú"
          },
          "15": {
            "name": "Presidente Hayes"
          },
          "16": {
            "name": "Alto Paraguay"
          },
          "19": {
            "name": "Boquerón"
          },
          "2": {
            "name": "San Pedro"
          },
          "3": {
            "name": "Cordillera"
          },
          "4": {
            "name": "Guairá"
          },
          "5": {
            "name": "Caaguazú"
          },
          "6": {
            "name": "Caazapá"
          },
          "7": {
            "name": "Itapúa"
          },
          "8": {
            "name": "Misiones"
          },
          "9": {
            "name": "Paraguarí"
          },
          "asu": {
            "name": "Asunción"
          }
        }
      },
      "qa": {
        "name": "Qatar",
        "calling_code": "+974",
        "region": {
          "da": {
            "name": "Doha"
          },
          "kh": {
            "name": "Al Khor"
          },
          "ms": {
            "name": "Madinat ash Shamal"
          },
          "ra": {
            "name": "Al Rayyan"
          },
          "sh": {
            "name": "Ash Shīḩānīyah"
          },
          "us": {
            "name": "Umm Salal"
          },
          "wa": {
            "name": "Al Wakrah"
          },
          "za": {
            "name": "Al Daayen"
          }
        }
      },
      "re": {
        "name": "Réunion",
        "calling_code": "+262",
        "region": {}
      },
      "ro": {
        "name": "Romania",
        "calling_code": "+40",
        "region": {
          "ab": {
            "name": "Alba"
          },
          "ag": {
            "name": "Argeș"
          },
          "ar": {
            "name": "Arad"
          },
          "b": {
            "name": "Bucharest"
          },
          "bc": {
            "name": "Bacău"
          },
          "bh": {
            "name": "Bihor"
          },
          "bn": {
            "name": "Bistriţa-Năsăud"
          },
          "br": {
            "name": "Brăila"
          },
          "bt": {
            "name": "Botoşani"
          },
          "bv": {
            "name": "Braşov"
          },
          "bz": {
            "name": "Buzău"
          },
          "cj": {
            "name": "Cluj"
          },
          "cl": {
            "name": "Călărași"
          },
          "cs": {
            "name": "Caraș-Severin"
          },
          "ct": {
            "name": "Constanța"
          },
          "cv": {
            "name": "Covasna"
          },
          "db": {
            "name": "Dâmbovița"
          },
          "dj": {
            "name": "Dolj"
          },
          "gj": {
            "name": "Gorj"
          },
          "gl": {
            "name": "Galați"
          },
          "gr": {
            "name": "Giurgiu"
          },
          "hd": {
            "name": "Hunedoara"
          },
          "hr": {
            "name": "Harghita"
          },
          "if": {
            "name": "Ilfov"
          },
          "il": {
            "name": "Ialomița"
          },
          "is": {
            "name": "Iași"
          },
          "mh": {
            "name": "Mehedinți"
          },
          "mm": {
            "name": "Maramureş"
          },
          "ms": {
            "name": "Mureş"
          },
          "nt": {
            "name": "Neamţ"
          },
          "ot": {
            "name": "Olt"
          },
          "ph": {
            "name": "Prahova"
          },
          "sb": {
            "name": "Sibiu"
          },
          "sj": {
            "name": "Sălaj"
          },
          "sm": {
            "name": "Satu Mare"
          },
          "sv": {
            "name": "Suceava"
          },
          "tl": {
            "name": "Tulcea"
          },
          "tm": {
            "name": "Timiș"
          },
          "tr": {
            "name": "Teleorman"
          },
          "vl": {
            "name": "Vâlcea"
          },
          "vn": {
            "name": "Vrancea"
          },
          "vs": {
            "name": "Vaslui"
          }
        }
      },
      "rs": {
        "name": "Serbia",
        "calling_code": "+381",
        "region": {
          "00": {
            "name": "Beograd"
          },
          "01": {
            "name": "North Bačka"
          },
          "02": {
            "name": "Central Banat"
          },
          "03": {
            "name": "North Banat"
          },
          "04": {
            "name": "South Banat"
          },
          "05": {
            "name": "West Bačka"
          },
          "06": {
            "name": "South Bačka"
          },
          "07": {
            "name": "Srem"
          },
          "08": {
            "name": "Mačva"
          },
          "09": {
            "name": "Kolubara"
          },
          "10": {
            "name": "Podunavlje"
          },
          "11": {
            "name": "Braničevo"
          },
          "12": {
            "name": "Šumadija"
          },
          "13": {
            "name": "Pomoravlje"
          },
          "14": {
            "name": "Bor"
          },
          "15": {
            "name": "Zaječar"
          },
          "16": {
            "name": "Zlatibor"
          },
          "17": {
            "name": "Moravica"
          },
          "18": {
            "name": "Raška"
          },
          "19": {
            "name": "Rasina"
          },
          "20": {
            "name": "Nišava"
          },
          "21": {
            "name": "Toplica"
          },
          "22": {
            "name": "Pirot"
          },
          "23": {
            "name": "Jablanica"
          },
          "24": {
            "name": "Pčinja"
          },
          "25": {
            "name": "Kosovo"
          },
          "26": {
            "name": "Peć"
          },
          "27": {
            "name": "Prizren"
          },
          "28": {
            "name": "Kosovska Mitrovica"
          },
          "29": {
            "name": "Kosovo-Pomoravlje"
          },
          "km": {
            "name": "Kosovo-Metohija"
          },
          "vo": {
            "name": "Vojvodina"
          }
        }
      },
      "ru": {
        "name": "Russian Federation",
        "calling_code": "+7",
        "region": {
          "ad": {
            "name": "Adygea"
          },
          "al": {
            "name": "Altai"
          },
          "alt": {
            "name": "Altai Krai"
          },
          "amu": {
            "name": "Amur"
          },
          "ark": {
            "name": "Arkhangelsk"
          },
          "ast": {
            "name": "Astrakhan"
          },
          "ba": {
            "name": "Bashkortostan"
          },
          "bel": {
            "name": "Belgorod"
          },
          "bry": {
            "name": "Bryansk"
          },
          "bu": {
            "name": "Buryat"
          },
          "ce": {
            "name": "Chechen"
          },
          "che": {
            "name": "Chelyabinsk"
          },
          "chu": {
            "name": "Chukotka Okrug"
          },
          "cu": {
            "name": "Chuvash"
          },
          "da": {
            "name": "Dagestan"
          },
          "in": {
            "name": "Ingushetia"
          },
          "irk": {
            "name": "Irkutsk"
          },
          "iva": {
            "name": "Ivanovo"
          },
          "kam": {
            "name": "Kamchatka Krai"
          },
          "kb": {
            "name": "Kabardino-Balkar"
          },
          "kc": {
            "name": "Karachay-Cherkess"
          },
          "kda": {
            "name": "Krasnodar Krai"
          },
          "kem": {
            "name": "Kemerovo"
          },
          "kgd": {
            "name": "Kaliningrad"
          },
          "kgn": {
            "name": "Kurgan"
          },
          "kha": {
            "name": "Khabarovsk Krai"
          },
          "khm": {
            "name": "Khanty-Mansi"
          },
          "kir": {
            "name": "Kirov"
          },
          "kk": {
            "name": "Khakassia"
          },
          "kl": {
            "name": "Kalmykia"
          },
          "klu": {
            "name": "Kaluga"
          },
          "ko": {
            "name": "Komi"
          },
          "kos": {
            "name": "Kostroma"
          },
          "kr": {
            "name": "Karelia"
          },
          "krs": {
            "name": "Kursk"
          },
          "kya": {
            "name": "Krasnoyarsk Krai"
          },
          "len": {
            "name": "Leningrad"
          },
          "lip": {
            "name": "Lipetsk"
          },
          "mag": {
            "name": "Magadan"
          },
          "me": {
            "name": "Mari El"
          },
          "mo": {
            "name": "Mordovia"
          },
          "mos": {
            "name": "Moscow Province"
          },
          "mow": {
            "name": "Moscow"
          },
          "mur": {
            "name": "Murmansk"
          },
          "nen": {
            "name": "Nenets"
          },
          "ngr": {
            "name": "Novgorod"
          },
          "niz": {
            "name": "Nizhny Novgorod"
          },
          "nvs": {
            "name": "Novosibirsk"
          },
          "oms": {
            "name": "Omsk"
          },
          "ore": {
            "name": "Orenburg"
          },
          "orl": {
            "name": "Oryol"
          },
          "per": {
            "name": "Perm Krai"
          },
          "pnz": {
            "name": "Penza"
          },
          "pri": {
            "name": "Primorsky Krai"
          },
          "psk": {
            "name": "Pskov"
          },
          "ros": {
            "name": "Rostov"
          },
          "rya": {
            "name": "Ryazan"
          },
          "sa": {
            "name": "Sakha"
          },
          "sak": {
            "name": "Sakhalin"
          },
          "sam": {
            "name": "Samara"
          },
          "sar": {
            "name": "Saratov"
          },
          "se": {
            "name": "North Ossetia-Alania"
          },
          "smo": {
            "name": "Smolensk"
          },
          "spe": {
            "name": "Saint Petersburg"
          },
          "sta": {
            "name": "Stavropol Krai"
          },
          "sve": {
            "name": "Sverdlovsk"
          },
          "ta": {
            "name": "Tatarstan"
          },
          "tam": {
            "name": "Tambov"
          },
          "tom": {
            "name": "Tomsk"
          },
          "tul": {
            "name": "Tula"
          },
          "tve": {
            "name": "Tver"
          },
          "ty": {
            "name": "Tuva"
          },
          "tyu": {
            "name": "Tyumen"
          },
          "ud": {
            "name": "Udmurt"
          },
          "uly": {
            "name": "Ulyanovsk"
          },
          "vgg": {
            "name": "Volgograd"
          },
          "vla": {
            "name": "Vladimir"
          },
          "vlg": {
            "name": "Vologda"
          },
          "vor": {
            "name": "Voronezh"
          },
          "yan": {
            "name": "Yamalo-Nenets Okrug"
          },
          "yar": {
            "name": "Yaroslavl"
          },
          "yev": {
            "name": "Jewish"
          },
          "zab": {
            "name": "Zabaykalsky Krai"
          }
        }
      },
      "rw": {
        "name": "Rwanda",
        "calling_code": "+250",
        "region": {
          "01": {
            "name": "Kigali"
          },
          "02": {
            "name": "Eastern"
          },
          "03": {
            "name": "Northern"
          },
          "04": {
            "name": "Western"
          },
          "05": {
            "name": "Southern"
          }
        }
      },
      "sa": {
        "name": "Saudi Arabia",
        "calling_code": "+966",
        "region": {
          "01": {
            "name": "Riyadh"
          },
          "02": {
            "name": "Makkah"
          },
          "03": {
            "name": "Al Madinah"
          },
          "04": {
            "name": "Eastern"
          },
          "05": {
            "name": "Al-Qassim"
          },
          "06": {
            "name": "Ha’il"
          },
          "07": {
            "name": "Tabuk"
          },
          "08": {
            "name": "Northern Borders"
          },
          "09": {
            "name": "Jizan"
          },
          "10": {
            "name": "Najran"
          },
          "11": {
            "name": "Al Bahah"
          },
          "12": {
            "name": "Al Jawf"
          },
          "14": {
            "name": "Asir"
          }
        }
      },
      "sb": {
        "name": "Solomon Islands",
        "calling_code": "+677",
        "region": {
          "ce": {
            "name": "Central"
          },
          "ch": {
            "name": "Choiseul"
          },
          "ct": {
            "name": "Honiara"
          },
          "gu": {
            "name": "Guadalcanal"
          },
          "is": {
            "name": "Isabel"
          },
          "mk": {
            "name": "Makira-Ulawa"
          },
          "ml": {
            "name": "Malaita"
          },
          "rb": {
            "name": "Rennell and Bellona"
          },
          "te": {
            "name": "Temotu"
          },
          "we": {
            "name": "Western"
          }
        }
      },
      "sc": {
        "name": "Seychelles",
        "calling_code": "+248",
        "region": {
          "01": {
            "name": "Anse aux Pins"
          },
          "02": {
            "name": "Anse Boileau"
          },
          "03": {
            "name": "Anse Etoile"
          },
          "04": {
            "name": "Au Cap"
          },
          "05": {
            "name": "Anse Royale"
          },
          "06": {
            "name": "Baie Lazare"
          },
          "07": {
            "name": "Baie Sainte Anne"
          },
          "08": {
            "name": "Beau Vallon"
          },
          "09": {
            "name": "Bel Air"
          },
          "10": {
            "name": "Bel Ombre"
          },
          "11": {
            "name": "Cascade"
          },
          "12": {
            "name": "Glacis"
          },
          "13": {
            "name": "Grand’Anse Mahé"
          },
          "14": {
            "name": "Grand’Anse Praslin"
          },
          "15": {
            "name": "La Digue"
          },
          "16": {
            "name": "La Rivière Anglaise"
          },
          "17": {
            "name": "Mont Buxton"
          },
          "18": {
            "name": "Mont Fleuri"
          },
          "19": {
            "name": "Plaisance"
          },
          "20": {
            "name": "Pointe La Rue"
          },
          "21": {
            "name": "Port Glaud"
          },
          "22": {
            "name": "Saint Louis"
          },
          "23": {
            "name": "Takamaka"
          },
          "24": {
            "name": "Les Mamelles"
          },
          "25": {
            "name": "Roche Caiman"
          },
          "26": {
            "name": "Ile Perseverance I"
          },
          "27": {
            "name": "Ile Perseverance II"
          }
        }
      },
      "sd": {
        "name": "Sudan",
        "calling_code": "+249",
        "region": {
          "dc": {
            "name": "Central Darfur"
          },
          "de": {
            "name": "East Darfur"
          },
          "dn": {
            "name": "North Darfur"
          },
          "ds": {
            "name": "South Darfur"
          },
          "dw": {
            "name": "West Darfur"
          },
          "gd": {
            "name": "Al Qadarif"
          },
          "gk": {
            "name": "West Kurdufan"
          },
          "gz": {
            "name": "Al Jazirah"
          },
          "ka": {
            "name": "Kassala"
          },
          "kh": {
            "name": "Khartoum"
          },
          "kn": {
            "name": "North Kurdufan"
          },
          "ks": {
            "name": "South Kurdufan"
          },
          "nb": {
            "name": "Blue Nile"
          },
          "no": {
            "name": "Northern"
          },
          "nr": {
            "name": "River Nile"
          },
          "nw": {
            "name": "White Nile"
          },
          "rs": {
            "name": "Red Sea"
          },
          "si": {
            "name": "Sennar"
          }
        }
      },
      "se": {
        "name": "Sweden",
        "calling_code": "+46",
        "region": {
          "ab": {
            "name": "Stockholm"
          },
          "ac": {
            "name": "Västerbotten"
          },
          "bd": {
            "name": "Norrbotten"
          },
          "c": {
            "name": "Uppsala"
          },
          "d": {
            "name": "Södermanland"
          },
          "e": {
            "name": "Östergötland"
          },
          "f": {
            "name": "Jönköping"
          },
          "g": {
            "name": "Kronoberg"
          },
          "h": {
            "name": "Kalmar"
          },
          "i": {
            "name": "Gotland"
          },
          "k": {
            "name": "Blekinge"
          },
          "m": {
            "name": "Skåne"
          },
          "n": {
            "name": "Halland"
          },
          "o": {
            "name": "Västra Götaland"
          },
          "s": {
            "name": "Värmland"
          },
          "t": {
            "name": "Örebro"
          },
          "u": {
            "name": "Västmanland"
          },
          "w": {
            "name": "Dalarna"
          },
          "x": {
            "name": "Gävleborg"
          },
          "y": {
            "name": "Västernorrland"
          },
          "z": {
            "name": "Jämtland"
          }
        }
      },
      "sg": {
        "name": "Singapore",
        "calling_code": "+65",
        "region": {
          "01": {
            "name": "Central Singapore"
          },
          "02": {
            "name": "North East"
          },
          "03": {
            "name": "North West"
          },
          "04": {
            "name": "South East"
          },
          "05": {
            "name": "South West"
          }
        }
      },
      "sh": {
        "name": "Saint Helena, Ascension and Tristan da Cunha",
        "calling_code": "+290",
        "region": {
          "ac": {
            "name": "Ascension Island"
          },
          "hl": {
            "name": "Saint Helena"
          },
          "ta": {
            "name": "Tristan da Cunha"
          }
        }
      },
      "si": {
        "name": "Slovenia",
        "calling_code": "+386",
        "region": {
          "001": {
            "name": "Ajdovščina"
          },
          "002": {
            "name": "Beltinci"
          },
          "003": {
            "name": "Bled"
          },
          "004": {
            "name": "Bohinj"
          },
          "005": {
            "name": "Borovnica"
          },
          "006": {
            "name": "Bovec"
          },
          "007": {
            "name": "Brda"
          },
          "008": {
            "name": "Brezovica"
          },
          "009": {
            "name": "Brežice"
          },
          "010": {
            "name": "Tišina"
          },
          "011": {
            "name": "Celje"
          },
          "012": {
            "name": "Cerklje na Gorenjskem"
          },
          "013": {
            "name": "Cerknica"
          },
          "014": {
            "name": "Cerkno"
          },
          "015": {
            "name": "Črenšovci"
          },
          "016": {
            "name": "Črna na Koroškem"
          },
          "017": {
            "name": "Črnomelj"
          },
          "018": {
            "name": "Destrnik"
          },
          "019": {
            "name": "Divača"
          },
          "020": {
            "name": "Dobrepolje"
          },
          "021": {
            "name": "Dobrova–Polhov Gradec"
          },
          "022": {
            "name": "Dol pri Ljubljani"
          },
          "023": {
            "name": "Domžale"
          },
          "024": {
            "name": "Dornava"
          },
          "025": {
            "name": "Dravograd"
          },
          "026": {
            "name": "Duplek"
          },
          "027": {
            "name": "Gorenja Vas–Poljane"
          },
          "028": {
            "name": "Gorišnica"
          },
          "029": {
            "name": "Gornja Radgona"
          },
          "030": {
            "name": "Gornji Grad"
          },
          "031": {
            "name": "Gornji Petrovci"
          },
          "032": {
            "name": "Grosuplje"
          },
          "033": {
            "name": "Šalovci"
          },
          "034": {
            "name": "Hrastnik"
          },
          "035": {
            "name": "Hrpelje–Kozina"
          },
          "036": {
            "name": "Idrija"
          },
          "037": {
            "name": "Ig"
          },
          "038": {
            "name": "Ilirska Bistrica"
          },
          "039": {
            "name": "Ivančna Gorica"
          },
          "040": {
            "name": "Izola"
          },
          "041": {
            "name": "Jesenice"
          },
          "042": {
            "name": "Juršinci"
          },
          "043": {
            "name": "Kamnik"
          },
          "044": {
            "name": "Kanal"
          },
          "045": {
            "name": "Kidričevo"
          },
          "046": {
            "name": "Kobarid"
          },
          "047": {
            "name": "Kobilje"
          },
          "048": {
            "name": "Kočevje"
          },
          "049": {
            "name": "Komen"
          },
          "050": {
            "name": "Koper"
          },
          "051": {
            "name": "Kozje"
          },
          "052": {
            "name": "Kranj"
          },
          "053": {
            "name": "Kranjska Gora"
          },
          "054": {
            "name": "Krško"
          },
          "055": {
            "name": "Kungota"
          },
          "056": {
            "name": "Kuzma"
          },
          "057": {
            "name": "Laško"
          },
          "058": {
            "name": "Lenart"
          },
          "059": {
            "name": "Lendava"
          },
          "060": {
            "name": "Litija"
          },
          "061": {
            "name": "Ljubljana"
          },
          "062": {
            "name": "Ljubno"
          },
          "063": {
            "name": "Ljutomer"
          },
          "064": {
            "name": "Logatec"
          },
          "065": {
            "name": "Loška Dolina"
          },
          "066": {
            "name": "Loški Potok"
          },
          "067": {
            "name": "Luče"
          },
          "068": {
            "name": "Lukovica"
          },
          "069": {
            "name": "Majšperk"
          },
          "070": {
            "name": "Maribor"
          },
          "071": {
            "name": "Medvode"
          },
          "072": {
            "name": "Mengeš"
          },
          "073": {
            "name": "Metlika"
          },
          "074": {
            "name": "Mežica"
          },
          "075": {
            "name": "Miren–Kostanjevica"
          },
          "076": {
            "name": "Mislinja"
          },
          "077": {
            "name": "Moravče"
          },
          "078": {
            "name": "Moravske Toplice"
          },
          "079": {
            "name": "Mozirje"
          },
          "080": {
            "name": "Murska Sobota"
          },
          "081": {
            "name": "Muta"
          },
          "082": {
            "name": "Naklo"
          },
          "083": {
            "name": "Nazarje"
          },
          "084": {
            "name": "Nova Gorica"
          },
          "085": {
            "name": "Novo Mesto"
          },
          "086": {
            "name": "Odranci"
          },
          "087": {
            "name": "Ormož"
          },
          "088": {
            "name": "Osilnica"
          },
          "089": {
            "name": "Pesnica"
          },
          "090": {
            "name": "Piran"
          },
          "091": {
            "name": "Pivka"
          },
          "092": {
            "name": "Podčetrtek"
          },
          "093": {
            "name": "Podvelka"
          },
          "094": {
            "name": "Postojna"
          },
          "095": {
            "name": "Preddvor"
          },
          "096": {
            "name": "Ptuj"
          },
          "097": {
            "name": "Puconci"
          },
          "098": {
            "name": "Rače–Fram"
          },
          "099": {
            "name": "Radeče"
          },
          "100": {
            "name": "Radenci"
          },
          "101": {
            "name": "Radlje ob Dravi"
          },
          "102": {
            "name": "Radovljica"
          },
          "103": {
            "name": "Ravne na Koroškem"
          },
          "104": {
            "name": "Ribnica"
          },
          "105": {
            "name": "Rogašovci"
          },
          "106": {
            "name": "Rogaška Slatina"
          },
          "107": {
            "name": "Rogatec"
          },
          "108": {
            "name": "Ruše"
          },
          "109": {
            "name": "Semič"
          },
          "110": {
            "name": "Sevnica"
          },
          "111": {
            "name": "Sežana"
          },
          "112": {
            "name": "Slovenj Gradec"
          },
          "113": {
            "name": "Slovenska Bistrica"
          },
          "114": {
            "name": "Slovenske Konjice"
          },
          "115": {
            "name": "Starše"
          },
          "116": {
            "name": "Sveti Jurij"
          },
          "117": {
            "name": "Šenčur"
          },
          "118": {
            "name": "Šentilj"
          },
          "119": {
            "name": "Šentjernej"
          },
          "120": {
            "name": "Šentjur"
          },
          "121": {
            "name": "Škocjan"
          },
          "122": {
            "name": "Škofja Loka"
          },
          "123": {
            "name": "Škofljica"
          },
          "124": {
            "name": "Šmarje pri Jelšah"
          },
          "125": {
            "name": "Šmartno ob Paki"
          },
          "126": {
            "name": "Šoštanj"
          },
          "127": {
            "name": "Štore"
          },
          "128": {
            "name": "Tolmin"
          },
          "129": {
            "name": "Trbovlje"
          },
          "130": {
            "name": "Trebnje"
          },
          "131": {
            "name": "Tržič"
          },
          "132": {
            "name": "Turnišče"
          },
          "133": {
            "name": "Velenje"
          },
          "134": {
            "name": "Velike Lašče"
          },
          "135": {
            "name": "Videm"
          },
          "136": {
            "name": "Vipava"
          },
          "137": {
            "name": "Vitanje"
          },
          "138": {
            "name": "Vodice"
          },
          "139": {
            "name": "Vojnik"
          },
          "140": {
            "name": "Vrhnika"
          },
          "141": {
            "name": "Vuzenica"
          },
          "142": {
            "name": "Zagorje ob Savi"
          },
          "143": {
            "name": "Zavrč"
          },
          "144": {
            "name": "Zreče"
          },
          "146": {
            "name": "Železniki"
          },
          "147": {
            "name": "Žiri"
          },
          "148": {
            "name": "Benedikt"
          },
          "149": {
            "name": "Bistrica ob Sotli"
          },
          "150": {
            "name": "Bloke"
          },
          "151": {
            "name": "Braslovče"
          },
          "152": {
            "name": "Cankova"
          },
          "153": {
            "name": "Cerkvenjak"
          },
          "154": {
            "name": "Dobje"
          },
          "155": {
            "name": "Dobrna"
          },
          "156": {
            "name": "Dobrovnik"
          },
          "157": {
            "name": "Dolenjske Toplice"
          },
          "158": {
            "name": "Grad"
          },
          "159": {
            "name": "Hajdina"
          },
          "160": {
            "name": "Hoče–Slivnica"
          },
          "161": {
            "name": "Hodoš"
          },
          "162": {
            "name": "Horjul"
          },
          "163": {
            "name": "Jezersko"
          },
          "164": {
            "name": "Komenda"
          },
          "165": {
            "name": "Kostel"
          },
          "166": {
            "name": "Križevci"
          },
          "167": {
            "name": "Lovrenc na Pohorju"
          },
          "168": {
            "name": "Markovci"
          },
          "169": {
            "name": "Miklavž na Dravskem Polju"
          },
          "170": {
            "name": "Mirna Peč"
          },
          "171": {
            "name": "Oplotnica"
          },
          "172": {
            "name": "Podlehnik"
          },
          "173": {
            "name": "Polzela"
          },
          "174": {
            "name": "Prebold"
          },
          "175": {
            "name": "Prevalje"
          },
          "176": {
            "name": "Razkrižje"
          },
          "177": {
            "name": "Ribnica na Pohorju"
          },
          "178": {
            "name": "Selnica ob Dravi"
          },
          "179": {
            "name": "Sodražica"
          },
          "180": {
            "name": "Solčava"
          },
          "181": {
            "name": "Sveta Ana"
          },
          "182": {
            "name": "Sveti Andraž v Slovenskih Goricah"
          },
          "183": {
            "name": "Šempeter–Vrtojba"
          },
          "184": {
            "name": "Tabor"
          },
          "185": {
            "name": "Trnovska Vas"
          },
          "186": {
            "name": "Trzin"
          },
          "187": {
            "name": "Velika Polana"
          },
          "188": {
            "name": "Veržej"
          },
          "189": {
            "name": "Vransko"
          },
          "190": {
            "name": "Žalec"
          },
          "191": {
            "name": "Žetale"
          },
          "192": {
            "name": "Žirovnica"
          },
          "193": {
            "name": "Žužemberk"
          },
          "194": {
            "name": "Šmartno pri Litiji"
          },
          "195": {
            "name": "Apače"
          },
          "196": {
            "name": "Cirkulane"
          },
          "197": {
            "name": "Kostanjevica na Krki"
          },
          "198": {
            "name": "Makole"
          },
          "199": {
            "name": "Mokronog–Trebelno"
          },
          "200": {
            "name": "Poljčane"
          },
          "201": {
            "name": "Renče–Vogrsko"
          },
          "202": {
            "name": "Središče ob Dravi"
          },
          "203": {
            "name": "Straža"
          },
          "204": {
            "name": "Sveta Trojica v Slovenskih Goricah"
          },
          "205": {
            "name": "Sveti Tomaž"
          },
          "206": {
            "name": "Šmarješke Toplice"
          },
          "207": {
            "name": "Gorje"
          },
          "208": {
            "name": "Log–Dragomer"
          },
          "209": {
            "name": "Rečica ob Savinji"
          },
          "210": {
            "name": "Sveti Jurij v Slovenskih Goricah"
          },
          "211": {
            "name": "Šentrupert"
          },
          "212": {
            "name": "Mirna"
          },
          "213": {
            "name": "Ankaran"
          }
        }
      },
      "sj": {
        "name": "Svalbard and Jan Mayen",
        "calling_code": "+47",
        "region": {}
      },
      "sk": {
        "name": "Slovakia",
        "calling_code": "+421",
        "region": {
          "bc": {
            "name": "Banská Bystrica"
          },
          "bl": {
            "name": "Bratislava"
          },
          "ki": {
            "name": "Košice"
          },
          "ni": {
            "name": "Nitra"
          },
          "pv": {
            "name": "Prešov"
          },
          "ta": {
            "name": "Trnava"
          },
          "tc": {
            "name": "Trenčín"
          },
          "zi": {
            "name": "Žilina"
          }
        }
      },
      "sl": {
        "name": "Sierra Leone",
        "calling_code": "+232",
        "region": {
          "e": {
            "name": "Eastern"
          },
          "n": {
            "name": "Northern"
          },
          "nw": {
            "name": "North Western"
          },
          "s": {
            "name": "Southern"
          },
          "w": {
            "name": "Western Area"
          }
        }
      },
      "sm": {
        "name": "San Marino",
        "calling_code": "+378",
        "region": {
          "01": {
            "name": "Acquaviva"
          },
          "02": {
            "name": "Chiesanuova"
          },
          "03": {
            "name": "Domagnano"
          },
          "04": {
            "name": "Faetano"
          },
          "05": {
            "name": "Fiorentino"
          },
          "06": {
            "name": "Borgo Maggiore"
          },
          "07": {
            "name": "San Marino"
          },
          "08": {
            "name": "Montegiardino"
          },
          "09": {
            "name": "Serravalle"
          }
        }
      },
      "sn": {
        "name": "Senegal",
        "calling_code": "+221",
        "region": {
          "db": {
            "name": "Diourbel"
          },
          "dk": {
            "name": "Dakar"
          },
          "fk": {
            "name": "Fatick"
          },
          "ka": {
            "name": "Kaffrine"
          },
          "kd": {
            "name": "Kolda"
          },
          "ke": {
            "name": "Kédougou"
          },
          "kl": {
            "name": "Kaolack"
          },
          "lg": {
            "name": "Louga"
          },
          "mt": {
            "name": "Matam"
          },
          "se": {
            "name": "Sédhiou"
          },
          "sl": {
            "name": "Saint-Louis"
          },
          "tc": {
            "name": "Tambacounda"
          },
          "th": {
            "name": "Thiès"
          },
          "zg": {
            "name": "Ziguinchor"
          }
        }
      },
      "so": {
        "name": "Somalia",
        "calling_code": "+252",
        "region": {
          "aw": {
            "name": "Awdal"
          },
          "bk": {
            "name": "Bakool"
          },
          "bn": {
            "name": "Banaadir"
          },
          "br": {
            "name": "Bari"
          },
          "by": {
            "name": "Bay, Somalia"
          },
          "ga": {
            "name": "Galguduud"
          },
          "ge": {
            "name": "Gedo"
          },
          "hi": {
            "name": "Hiran"
          },
          "jd": {
            "name": "Middle Juba"
          },
          "jh": {
            "name": "Lower Juba"
          },
          "mu": {
            "name": "Mudug"
          },
          "nu": {
            "name": "Nugal"
          },
          "sa": {
            "name": "Sanaag"
          },
          "sd": {
            "name": "Middle Shebelle"
          },
          "sh": {
            "name": "Lower Shebelle"
          },
          "so": {
            "name": "Sool"
          },
          "to": {
            "name": "Togdheer"
          },
          "wo": {
            "name": "Woqooyi Galbeed"
          }
        }
      },
      "sr": {
        "name": "Suriname",
        "calling_code": "+597",
        "region": {
          "br": {
            "name": "Brokopondo"
          },
          "cm": {
            "name": "Commewijne"
          },
          "cr": {
            "name": "Coronie"
          },
          "ma": {
            "name": "Marowijne"
          },
          "ni": {
            "name": "Nickerie"
          },
          "pm": {
            "name": "Paramaribo"
          },
          "pr": {
            "name": "Para"
          },
          "sa": {
            "name": "Saramacca"
          },
          "si": {
            "name": "Sipaliwini"
          },
          "wa": {
            "name": "Wanica"
          }
        }
      },
      "ss": {
        "name": "South Sudan",
        "calling_code": "+211",
        "region": {
          "bn": {
            "name": "Northern Bahr el Ghazal"
          },
          "bw": {
            "name": "Western Bahr el Ghazal"
          },
          "ec": {
            "name": "Central Equatoria"
          },
          "ee": {
            "name": "Eastern Equatoria"
          },
          "ew": {
            "name": "Western Equatoria"
          },
          "jg": {
            "name": "Jonglei"
          },
          "lk": {
            "name": "Lakes"
          },
          "nu": {
            "name": "Upper Nile"
          },
          "uy": {
            "name": "Unity"
          },
          "wr": {
            "name": "Warrap"
          }
        }
      },
      "st": {
        "name": "Sao Tome and Principe",
        "calling_code": "+239",
        "region": {
          "01": {
            "name": "Água Grande"
          },
          "02": {
            "name": "Cantagalo"
          },
          "03": {
            "name": "Caué"
          },
          "04": {
            "name": "Lembá"
          },
          "05": {
            "name": "Lobata"
          },
          "06": {
            "name": "Mé-Zóchi"
          },
          "p": {
            "name": "Príncipe"
          }
        }
      },
      "sv": {
        "name": "El Salvador",
        "calling_code": "+503",
        "region": {
          "ah": {
            "name": "Ahuachapán"
          },
          "ca": {
            "name": "Cabañas"
          },
          "ch": {
            "name": "Chalatenango"
          },
          "cu": {
            "name": "Cuscatlán"
          },
          "li": {
            "name": "La Libertad"
          },
          "mo": {
            "name": "Morazán"
          },
          "pa": {
            "name": "La Paz"
          },
          "sa": {
            "name": "Santa Ana"
          },
          "sm": {
            "name": "San Miguel"
          },
          "so": {
            "name": "Sonsonate"
          },
          "ss": {
            "name": "San Salvador"
          },
          "sv": {
            "name": "San Vicente"
          },
          "un": {
            "name": "La Unión"
          },
          "us": {
            "name": "Usulután"
          }
        }
      },
      "sx": {
        "name": "Sint Maarten (Dutch part)",
        "calling_code": "+1",
        "region": {}
      },
      "sy": {
        "name": "Syrian Arab Republic",
        "calling_code": "+963",
        "region": {
          "di": {
            "name": "Damascus"
          },
          "dr": {
            "name": "Daraa"
          },
          "dy": {
            "name": "Deir ez-Zor"
          },
          "ha": {
            "name": "Al-Hasakah"
          },
          "hi": {
            "name": "Homs"
          },
          "hl": {
            "name": "Aleppo"
          },
          "hm": {
            "name": "Hama"
          },
          "id": {
            "name": "Idlib"
          },
          "la": {
            "name": "Latakia"
          },
          "qu": {
            "name": "Quneitra"
          },
          "ra": {
            "name": "Ar-Raqqah"
          },
          "rd": {
            "name": "Rif Dimashq"
          },
          "su": {
            "name": "As-Suwayda"
          },
          "ta": {
            "name": "Tartus"
          }
        }
      },
      "sz": {
        "name": "Eswatini",
        "calling_code": "+268",
        "region": {
          "hh": {
            "name": "Hhohho"
          },
          "lu": {
            "name": "Lubombo"
          },
          "ma": {
            "name": "Manzini"
          },
          "sh": {
            "name": "Shiselweni"
          }
        }
      },
      "tc": {
        "name": "Turks and Caicos Islands",
        "calling_code": "+1",
        "region": {}
      },
      "td": {
        "name": "Chad",
        "calling_code": "+235",
        "region": {
          "ba": {
            "name": "Batha"
          },
          "bg": {
            "name": "Bahr el Gazel"
          },
          "bo": {
            "name": "Borkou"
          },
          "cb": {
            "name": "Chari-Baguirmi"
          },
          "ee": {
            "name": "Ennedi-Est"
          },
          "eo": {
            "name": "Ennedi-Ouest"
          },
          "gr": {
            "name": "Guéra"
          },
          "hl": {
            "name": "Hadjer-Lamis"
          },
          "ka": {
            "name": "Kanem"
          },
          "lc": {
            "name": "Lac"
          },
          "lo": {
            "name": "Logone Occidental"
          },
          "lr": {
            "name": "Logone Oriental"
          },
          "ma": {
            "name": "Mandoul"
          },
          "mc": {
            "name": "Moyen-Chari"
          },
          "me": {
            "name": "Mayo-Kebbi Est"
          },
          "mo": {
            "name": "Mayo-Kebbi Ouest"
          },
          "nd": {
            "name": "N’Djamena"
          },
          "od": {
            "name": "Ouaddaï"
          },
          "sa": {
            "name": "Salamat"
          },
          "si": {
            "name": "Sila"
          },
          "ta": {
            "name": "Tandjilé"
          },
          "ti": {
            "name": "Tibesti"
          },
          "wf": {
            "name": "Wadi Fira"
          }
        }
      },
      "tf": {
        "name": "French Southern Territories",
        "calling_code": "+262",
        "region": {}
      },
      "tg": {
        "name": "Togo",
        "calling_code": "+228",
        "region": {
          "c": {
            "name": "Centrale"
          },
          "k": {
            "name": "Kara"
          },
          "m": {
            "name": "Maritime"
          },
          "p": {
            "name": "Plateaux"
          },
          "s": {
            "name": "Savanes"
          }
        }
      },
      "th": {
        "name": "Thailand",
        "calling_code": "+66",
        "region": {
          "10": {
            "name": "Bangkok"
          },
          "11": {
            "name": "Samut Prakan"
          },
          "12": {
            "name": "Nonthaburi"
          },
          "13": {
            "name": "Pathum Thani"
          },
          "14": {
            "name": "Phra Nakhon Si Ayutthaya"
          },
          "15": {
            "name": "Ang Thong"
          },
          "16": {
            "name": "Lopburi"
          },
          "17": {
            "name": "Sing Buri"
          },
          "18": {
            "name": "Chai Nat"
          },
          "19": {
            "name": "Saraburi"
          },
          "20": {
            "name": "Chon Buri"
          },
          "21": {
            "name": "Rayong"
          },
          "22": {
            "name": "Chanthaburi"
          },
          "23": {
            "name": "Trat"
          },
          "24": {
            "name": "Chachoengsao"
          },
          "25": {
            "name": "Prachin Buri"
          },
          "26": {
            "name": "Nakhon Nayok"
          },
          "27": {
            "name": "Sa Kaeo"
          },
          "30": {
            "name": "Nakhon Ratchasima"
          },
          "31": {
            "name": "Buri Ram"
          },
          "32": {
            "name": "Surin"
          },
          "33": {
            "name": "Si Sa Ket"
          },
          "34": {
            "name": "Ubon Ratchathani"
          },
          "35": {
            "name": "Yasothon"
          },
          "36": {
            "name": "Chaiyaphum"
          },
          "37": {
            "name": "Amnat Charoen"
          },
          "38": {
            "name": "Bueng Kan"
          },
          "39": {
            "name": "Nong Bua Lam Phu"
          },
          "40": {
            "name": "Khon Kaen"
          },
          "41": {
            "name": "Udon Thani"
          },
          "42": {
            "name": "Loei"
          },
          "43": {
            "name": "Nong Khai"
          },
          "44": {
            "name": "Maha Sarakham"
          },
          "45": {
            "name": "Roi Et"
          },
          "46": {
            "name": "Kalasin"
          },
          "47": {
            "name": "Sakon Nakhon"
          },
          "48": {
            "name": "Nakhon Phanom"
          },
          "49": {
            "name": "Mukdahan"
          },
          "50": {
            "name": "Chiang Mai"
          },
          "51": {
            "name": "Lamphun"
          },
          "52": {
            "name": "Lampang"
          },
          "53": {
            "name": "Uttaradit"
          },
          "54": {
            "name": "Phrae"
          },
          "55": {
            "name": "Nan"
          },
          "56": {
            "name": "Phayao"
          },
          "57": {
            "name": "Chiang Rai"
          },
          "58": {
            "name": "Mae Hong Son"
          },
          "60": {
            "name": "Nakhon Sawan"
          },
          "61": {
            "name": "Uthai Thani"
          },
          "62": {
            "name": "Kamphaeng Phet"
          },
          "63": {
            "name": "Tak"
          },
          "64": {
            "name": "Sukhothai"
          },
          "65": {
            "name": "Phitsanulok"
          },
          "66": {
            "name": "Phichit"
          },
          "67": {
            "name": "Phetchabun"
          },
          "70": {
            "name": "Ratchaburi"
          },
          "71": {
            "name": "Kanchanaburi"
          },
          "72": {
            "name": "Suphanburi"
          },
          "73": {
            "name": "Nakhon Pathom"
          },
          "74": {
            "name": "Samut Sakhon"
          },
          "75": {
            "name": "Samut Songkhram"
          },
          "76": {
            "name": "Phetchaburi"
          },
          "77": {
            "name": "Prachuap Khiri Khan"
          },
          "80": {
            "name": "Nakhon Si Thammarat"
          },
          "81": {
            "name": "Krabi"
          },
          "82": {
            "name": "Phang Nga"
          },
          "83": {
            "name": "Phuket"
          },
          "84": {
            "name": "Surat Thani"
          },
          "85": {
            "name": "Ranong"
          },
          "86": {
            "name": "Chumphon"
          },
          "90": {
            "name": "Songkhla"
          },
          "91": {
            "name": "Satun"
          },
          "92": {
            "name": "Trang"
          },
          "93": {
            "name": "Phatthalung"
          },
          "94": {
            "name": "Pattani"
          },
          "95": {
            "name": "Yala"
          },
          "96": {
            "name": "Narathiwat"
          },
          "s": {
            "name": "Pattaya"
          }
        }
      },
      "tj": {
        "name": "Tajikistan",
        "calling_code": "+992",
        "region": {
          "du": {
            "name": "Dushanbe"
          },
          "gb": {
            "name": "Gorno-Badakhshan"
          },
          "kt": {
            "name": "Khatlon"
          },
          "ra": {
            "name": "Nohiyahoi Tobei Jumhurí"
          },
          "su": {
            "name": "Sughd"
          }
        }
      },
      "tk": {
        "name": "Tokelau",
        "calling_code": "+690",
        "region": {}
      },
      "tl": {
        "name": "Timor-Leste",
        "calling_code": "+670",
        "region": {
          "al": {
            "name": "Aileu"
          },
          "an": {
            "name": "Ainaro"
          },
          "ba": {
            "name": "Baucau"
          },
          "bo": {
            "name": "Bobonaro"
          },
          "co": {
            "name": "Cova Lima"
          },
          "di": {
            "name": "Dili"
          },
          "er": {
            "name": "Ermera"
          },
          "la": {
            "name": "Lautém"
          },
          "li": {
            "name": "Liquiçá"
          },
          "mf": {
            "name": "Manufahi"
          },
          "mt": {
            "name": "Manatuto"
          },
          "oe": {
            "name": "Oecusse"
          },
          "vi": {
            "name": "Viqueque"
          }
        }
      },
      "tm": {
        "name": "Turkmenistan",
        "calling_code": "+993",
        "region": {
          "a": {
            "name": "Ahal"
          },
          "b": {
            "name": "Balkan"
          },
          "d": {
            "name": "Daşoguz"
          },
          "l": {
            "name": "Lebap"
          },
          "m": {
            "name": "Mary"
          },
          "s": {
            "name": "Aşgabat"
          }
        }
      },
      "tn": {
        "name": "Tunisia",
        "calling_code": "+216",
        "region": {
          "11": {
            "name": "Tunis"
          },
          "12": {
            "name": "Ariana"
          },
          "13": {
            "name": "Ben Arous"
          },
          "14": {
            "name": "Manouba"
          },
          "21": {
            "name": "Nabeul"
          },
          "22": {
            "name": "Zaghouan"
          },
          "23": {
            "name": "Bizerte"
          },
          "31": {
            "name": "Béja"
          },
          "32": {
            "name": "Jendouba"
          },
          "33": {
            "name": "Kef"
          },
          "34": {
            "name": "Siliana"
          },
          "41": {
            "name": "Kairouan"
          },
          "42": {
            "name": "Kasserine"
          },
          "43": {
            "name": "Sidi Bouzid"
          },
          "51": {
            "name": "Sousse"
          },
          "52": {
            "name": "Monastir"
          },
          "53": {
            "name": "Mahdia"
          },
          "61": {
            "name": "Sfax"
          },
          "71": {
            "name": "Gafsa"
          },
          "72": {
            "name": "Tozeur"
          },
          "73": {
            "name": "Kebili"
          },
          "81": {
            "name": "Gabès"
          },
          "82": {
            "name": "Medenine"
          },
          "83": {
            "name": "Tataouine"
          }
        }
      },
      "to": {
        "name": "Tonga",
        "calling_code": "+676",
        "region": {
          "01": {
            "name": "ʻEua"
          },
          "02": {
            "name": "Haʻapai"
          },
          "03": {
            "name": "Niuas"
          },
          "04": {
            "name": "Tongatapu"
          },
          "05": {
            "name": "Vavaʻu"
          }
        }
      },
      "tr": {
        "name": "Türkiye",
        "calling_code": "+90",
        "region": {
          "01": {
            "name": "Adana"
          },
          "02": {
            "name": "Adıyaman"
          },
          "03": {
            "name": "Afyonkarahisar"
          },
          "04": {
            "name": "Ağrı"
          },
          "05": {
            "name": "Amasya"
          },
          "06": {
            "name": "Ankara"
          },
          "07": {
            "name": "Antalya"
          },
          "08": {
            "name": "Artvin"
          },
          "09": {
            "name": "Aydın"
          },
          "10": {
            "name": "Balıkesir"
          },
          "11": {
            "name": "Bilecik"
          },
          "12": {
            "name": "Bingöl"
          },
          "13": {
            "name": "Bitlis"
          },
          "14": {
            "name": "Bolu"
          },
          "15": {
            "name": "Burdur"
          },
          "16": {
            "name": "Bursa"
          },
          "17": {
            "name": "Çanakkale"
          },
          "18": {
            "name": "Çankırı"
          },
          "19": {
            "name": "Çorum"
          },
          "20": {
            "name": "Denizli"
          },
          "21": {
            "name": "Diyarbakır"
          },
          "22": {
            "name": "Edirne"
          },
          "23": {
            "name": "Elazığ"
          },
          "24": {
            "name": "Erzincan"
          },
          "25": {
            "name": "Erzurum"
          },
          "26": {
            "name": "Eskişehir"
          },
          "27": {
            "name": "Gaziantep"
          },
          "28": {
            "name": "Giresun"
          },
          "29": {
            "name": "Gümüşhane"
          },
          "30": {
            "name": "Hakkâri"
          },
          "31": {
            "name": "Hatay"
          },
          "32": {
            "name": "Isparta"
          },
          "33": {
            "name": "Mersin"
          },
          "34": {
            "name": "Istanbul"
          },
          "35": {
            "name": "Izmir"
          },
          "36": {
            "name": "Kars"
          },
          "37": {
            "name": "Kastamonu"
          },
          "38": {
            "name": "Kayseri"
          },
          "39": {
            "name": "Kırklareli"
          },
          "40": {
            "name": "Kırşehir"
          },
          "41": {
            "name": "Kocaeli"
          },
          "42": {
            "name": "Konya"
          },
          "43": {
            "name": "Kütahya"
          },
          "44": {
            "name": "Malatya"
          },
          "45": {
            "name": "Manisa"
          },
          "46": {
            "name": "Kahramanmaraş"
          },
          "47": {
            "name": "Mardin"
          },
          "48": {
            "name": "Muğla"
          },
          "49": {
            "name": "Muş"
          },
          "50": {
            "name": "Nevşehir"
          },
          "51": {
            "name": "Niğde"
          },
          "52": {
            "name": "Ordu"
          },
          "53": {
            "name": "Rize"
          },
          "54": {
            "name": "Sakarya"
          },
          "55": {
            "name": "Samsun"
          },
          "56": {
            "name": "Siirt"
          },
          "57": {
            "name": "Sinop"
          },
          "58": {
            "name": "Sivas"
          },
          "59": {
            "name": "Tekirdağ"
          },
          "60": {
            "name": "Tokat"
          },
          "61": {
            "name": "Trabzon"
          },
          "62": {
            "name": "Tunceli"
          },
          "63": {
            "name": "Şanlıurfa"
          },
          "64": {
            "name": "Uşak"
          },
          "65": {
            "name": "Van"
          },
          "66": {
            "name": "Yozgat"
          },
          "67": {
            "name": "Zonguldak"
          },
          "68": {
            "name": "Aksaray"
          },
          "69": {
            "name": "Bayburt"
          },
          "70": {
            "name": "Karaman"
          },
          "71": {
            "name": "Kırıkkale"
          },
          "72": {
            "name": "Batman"
          },
          "73": {
            "name": "Şırnak"
          },
          "74": {
            "name": "Bartın"
          },
          "75": {
            "name": "Ardahan"
          },
          "76": {
            "name": "Iğdır"
          },
          "77": {
            "name": "Yalova"
          },
          "78": {
            "name": "Karabük"
          },
          "79": {
            "name": "Kilis"
          },
          "80": {
            "name": "Osmaniye"
          },
          "81": {
            "name": "Düzce"
          }
        }
      },
      "tt": {
        "name": "Trinidad and Tobago",
        "calling_code": "+1",
        "region": {
          "ari": {
            "name": "Arima"
          },
          "cha": {
            "name": "Chaguanas"
          },
          "ctt": {
            "name": "Couva-Tabaquite-Talparo"
          },
          "dmn": {
            "name": "Diego Martin"
          },
          "mrc": {
            "name": "Mayaro-Rio Claro"
          },
          "ped": {
            "name": "Penal-Debe"
          },
          "pos": {
            "name": "Port of Spain"
          },
          "prt": {
            "name": "Princes Town"
          },
          "ptf": {
            "name": "Point Fortin"
          },
          "sfo": {
            "name": "San Fernando"
          },
          "sge": {
            "name": "Sangre Grande"
          },
          "sip": {
            "name": "Siparia"
          },
          "sjl": {
            "name": "San Juan-Laventille"
          },
          "tob": {
            "name": "Tobago"
          },
          "tup": {
            "name": "Tunapuna-Piarco"
          }
        }
      },
      "tv": {
        "name": "Tuvalu",
        "calling_code": "+688",
        "region": {
          "fun": {
            "name": "Funafuti"
          },
          "nit": {
            "name": "Niutao"
          },
          "nkf": {
            "name": "Nukufetau"
          },
          "nkl": {
            "name": "Nukulaelae"
          },
          "nma": {
            "name": "Nanumea"
          },
          "nmg": {
            "name": "Nanumanga"
          },
          "nui": {
            "name": "Nui"
          },
          "vai": {
            "name": "Vaitupu"
          }
        }
      },
      "tw": {
        "name": "Taiwan",
        "calling_code": "+886",
        "region": {
          "cha": {
            "name": "Changhua"
          },
          "cyi": {
            "name": "Chiayi County"
          },
          "cyq": {
            "name": "Chiayi"
          },
          "hsq": {
            "name": "Hsinchu County"
          },
          "hsz": {
            "name": "Hsinchu"
          },
          "hua": {
            "name": "Hualien"
          },
          "ila": {
            "name": "Yilan"
          },
          "kee": {
            "name": "Keelung"
          },
          "khh": {
            "name": "Kaohsiung"
          },
          "kin": {
            "name": "Kinmen"
          },
          "lie": {
            "name": "Lienchiang"
          },
          "mia": {
            "name": "Miaoli"
          },
          "nan": {
            "name": "Nantou"
          },
          "nwt": {
            "name": "New Taipei"
          },
          "pen": {
            "name": "Penghu"
          },
          "pif": {
            "name": "Pingtung"
          },
          "tao": {
            "name": "Taoyuan"
          },
          "tnn": {
            "name": "Tainan"
          },
          "tpe": {
            "name": "Taipei"
          },
          "ttt": {
            "name": "Taitung"
          },
          "txg": {
            "name": "Taichung"
          },
          "yun": {
            "name": "Yunlin"
          }
        }
      },
      "tz": {
        "name": "Tanzania",
        "calling_code": "+255",
        "region": {
          "01": {
            "name": "Arusha"
          },
          "02": {
            "name": "Dar es Salaam"
          },
          "03": {
            "name": "Dodoma"
          },
          "04": {
            "name": "Iringa"
          },
          "05": {
            "name": "Kagera"
          },
          "06": {
            "name": "North Pemba"
          },
          "07": {
            "name": "Zanzibar North"
          },
          "08": {
            "name": "Kigoma"
          },
          "09": {
            "name": "Kilimanjaro"
          },
          "10": {
            "name": "South Pemba"
          },
          "11": {
            "name": "Zanzibar Central/South"
          },
          "12": {
            "name": "Lindi"
          },
          "13": {
            "name": "Mara"
          },
          "14": {
            "name": "Mbeya"
          },
          "15": {
            "name": "Zanzibar Urban/West"
          },
          "16": {
            "name": "Morogoro"
          },
          "17": {
            "name": "Mtwara"
          },
          "18": {
            "name": "Mwanza"
          },
          "19": {
            "name": "Pwani"
          },
          "20": {
            "name": "Rukwa"
          },
          "21": {
            "name": "Ruvuma"
          },
          "22": {
            "name": "Shinyanga"
          },
          "23": {
            "name": "Singida"
          },
          "24": {
            "name": "Tabora"
          },
          "25": {
            "name": "Tanga"
          },
          "26": {
            "name": "Manyara"
          },
          "27": {
            "name": "Geita"
          },
          "28": {
            "name": "Katavi"
          },
          "29": {
            "name": "Njombe"
          },
          "30": {
            "name": "Simiyu"
          },
          "31": {
            "name": "Songwe"
          }
        }
      },
      "ua": {
        "name": "Ukraine",
        "calling_code": "+380",
        "region": {
          "05": {
            "name": "Vinnychchyna"
          },
          "07": {
            "name": "Volyn"
          },
          "09": {
            "name": "Luhanshchyna"
          },
          "12": {
            "name": "Dnipropetrovshchyna"
          },
          "14": {
            "name": "Donechchyna"
          },
          "18": {
            "name": "Zhytomyrshchyna"
          },
          "21": {
            "name": "Zakarpattia"
          },
          "23": {
            "name": "Zaporizhzhya"
          },
          "26": {
            "name": "Prykarpattia"
          },
          "30": {
            "name": "Kyiv"
          },
          "32": {
            "name": "Kyivshchyna"
          },
          "35": {
            "name": "Kirovohradschyna"
          },
          "40": {
            "name": "Sevastopol"
          },
          "43": {
            "name": "Crimea"
          },
          "46": {
            "name": "Lvivshchyna"
          },
          "48": {
            "name": "Mykolayivschyna"
          },
          "51": {
            "name": "Odeshchyna"
          },
          "53": {
            "name": "Poltavshchyna"
          },
          "56": {
            "name": "Rivnenshchyna"
          },
          "59": {
            "name": "Sumshchyna"
          },
          "61": {
            "name": "Ternopilshchyna"
          },
          "63": {
            "name": "Kharkivshchyna"
          },
          "65": {
            "name": "Khersonshchyna"
          },
          "68": {
            "name": "Khmelnychchyna"
          },
          "71": {
            "name": "Cherkashchyna"
          },
          "74": {
            "name": "Chernihivshchyna"
          },
          "77": {
            "name": "Chernivtsi Oblast"
          }
        }
      },
      "ug": {
        "name": "Uganda",
        "calling_code": "+256",
        "region": {
          "101": {
            "name": "Kalangala"
          },
          "102": {
            "name": "Kampala"
          },
          "103": {
            "name": "Kiboga"
          },
          "104": {
            "name": "Luwero"
          },
          "105": {
            "name": "Masaka"
          },
          "106": {
            "name": "Mpigi"
          },
          "107": {
            "name": "Mubende"
          },
          "108": {
            "name": "Mukono"
          },
          "109": {
            "name": "Nakasongola"
          },
          "110": {
            "name": "Rakai"
          },
          "111": {
            "name": "Sembabule"
          },
          "112": {
            "name": "Kayunga"
          },
          "113": {
            "name": "Wakiso"
          },
          "114": {
            "name": "Lyantonde"
          },
          "115": {
            "name": "Mityana"
          },
          "116": {
            "name": "Nakaseke"
          },
          "117": {
            "name": "Buikwe"
          },
          "118": {
            "name": "Bukomansibi"
          },
          "119": {
            "name": "Butambala"
          },
          "120": {
            "name": "Buvuma"
          },
          "121": {
            "name": "Gomba"
          },
          "122": {
            "name": "Kalungu"
          },
          "123": {
            "name": "Kyankwanzi"
          },
          "124": {
            "name": "Lwengo"
          },
          "125": {
            "name": "Kyotera"
          },
          "126": {
            "name": "Kasanda"
          },
          "201": {
            "name": "Bugiri"
          },
          "202": {
            "name": "Busia"
          },
          "203": {
            "name": "Iganga"
          },
          "204": {
            "name": "Jinja"
          },
          "205": {
            "name": "Kamuli"
          },
          "206": {
            "name": "Kapchorwa"
          },
          "207": {
            "name": "Katakwi"
          },
          "208": {
            "name": "Kumi"
          },
          "209": {
            "name": "Mbale"
          },
          "210": {
            "name": "Pallisa"
          },
          "211": {
            "name": "Soroti"
          },
          "212": {
            "name": "Tororo"
          },
          "213": {
            "name": "Kaberamaido"
          },
          "214": {
            "name": "Mayuge"
          },
          "215": {
            "name": "Sironko"
          },
          "216": {
            "name": "Amuria"
          },
          "217": {
            "name": "Budaka"
          },
          "218": {
            "name": "Bududa"
          },
          "219": {
            "name": "Bukedea"
          },
          "220": {
            "name": "Bukwa"
          },
          "221": {
            "name": "Butaleja"
          },
          "222": {
            "name": "Kaliro"
          },
          "223": {
            "name": "Manafwa"
          },
          "224": {
            "name": "Namutumba"
          },
          "225": {
            "name": "Bulambuli"
          },
          "226": {
            "name": "Buyende"
          },
          "227": {
            "name": "Kibuku"
          },
          "228": {
            "name": "Kween"
          },
          "229": {
            "name": "Luuka"
          },
          "230": {
            "name": "Namayingo"
          },
          "231": {
            "name": "Ngora"
          },
          "232": {
            "name": "Serere"
          },
          "233": {
            "name": "Butebo"
          },
          "234": {
            "name": "Namisindwa"
          },
          "235": {
            "name": "Bugweri"
          },
          "236": {
            "name": "Kapelebyong"
          },
          "237": {
            "name": "Kalaki"
          },
          "301": {
            "name": "Adjumani"
          },
          "302": {
            "name": "Apac"
          },
          "303": {
            "name": "Arua"
          },
          "304": {
            "name": "Gulu"
          },
          "305": {
            "name": "Kitgum"
          },
          "306": {
            "name": "Kotido"
          },
          "307": {
            "name": "Lira"
          },
          "308": {
            "name": "Moroto"
          },
          "309": {
            "name": "Moyo"
          },
          "310": {
            "name": "Nebbi"
          },
          "311": {
            "name": "Nakapiripirit"
          },
          "312": {
            "name": "Pader"
          },
          "313": {
            "name": "Yumbe"
          },
          "314": {
            "name": "Abim"
          },
          "315": {
            "name": "Amolatar"
          },
          "316": {
            "name": "Amuru"
          },
          "317": {
            "name": "Dokolo"
          },
          "318": {
            "name": "Kaabong"
          },
          "319": {
            "name": "Koboko"
          },
          "320": {
            "name": "Maracha"
          },
          "321": {
            "name": "Oyam"
          },
          "322": {
            "name": "Agago"
          },
          "323": {
            "name": "Alebtong"
          },
          "324": {
            "name": "Amudat"
          },
          "325": {
            "name": "Kole"
          },
          "326": {
            "name": "Lamwo"
          },
          "327": {
            "name": "Napak"
          },
          "328": {
            "name": "Nwoya"
          },
          "329": {
            "name": "Otuke"
          },
          "330": {
            "name": "Zombo²"
          },
          "331": {
            "name": "Zombo"
          },
          "332": {
            "name": "Pakwach"
          },
          "333": {
            "name": "Kwania"
          },
          "334": {
            "name": "Nabilatuk"
          },
          "335": {
            "name": "Karenga"
          },
          "336": {
            "name": "Madi-Okollo"
          },
          "337": {
            "name": "Obongi"
          },
          "401": {
            "name": "Bundibugyo"
          },
          "402": {
            "name": "Bushenyi"
          },
          "403": {
            "name": "Hoima"
          },
          "404": {
            "name": "Kabale"
          },
          "405": {
            "name": "Kabarole"
          },
          "406": {
            "name": "Kasese"
          },
          "407": {
            "name": "Kibaale"
          },
          "408": {
            "name": "Kisoro"
          },
          "409": {
            "name": "Masindi"
          },
          "410": {
            "name": "Mbarara"
          },
          "411": {
            "name": "Ntungamo"
          },
          "412": {
            "name": "Rukungiri"
          },
          "413": {
            "name": "Kamwenge"
          },
          "414": {
            "name": "Kanungu"
          },
          "415": {
            "name": "Kyenjojo"
          },
          "416": {
            "name": "Buliisa"
          },
          "417": {
            "name": "Ibanda"
          },
          "418": {
            "name": "Isingiro"
          },
          "419": {
            "name": "Kiruhura"
          },
          "420": {
            "name": "Buhweju"
          },
          "421": {
            "name": "Kiryandongo"
          },
          "422": {
            "name": "Kyegegwa"
          },
          "423": {
            "name": "Mitooma"
          },
          "424": {
            "name": "Ntoroko"
          },
          "425": {
            "name": "Rubirizi"
          },
          "426": {
            "name": "Sheema"
          },
          "427": {
            "name": "Kagadi"
          },
          "428": {
            "name": "Kakumiro"
          },
          "429": {
            "name": "Rubanda"
          },
          "430": {
            "name": "Bunyangabu"
          },
          "431": {
            "name": "Rukiga"
          },
          "432": {
            "name": "Kikuube"
          },
          "433": {
            "name": "Kazo"
          },
          "434": {
            "name": "Kitagwenda"
          },
          "435": {
            "name": "Rwampara"
          },
          "c": {
            "name": "Central"
          },
          "e": {
            "name": "Eastern"
          },
          "n": {
            "name": "Northern"
          },
          "w": {
            "name": "Western"
          }
        }
      },
      "um": {
        "name": "United States Minor Outlying Islands",
        "calling_code": "+1",
        "region": {
          "67": {
            "name": "Johnston Atoll"
          },
          "71": {
            "name": "Midway Atoll"
          },
          "76": {
            "name": "Navassa Island"
          },
          "79": {
            "name": "Wake Island"
          },
          "81": {
            "name": "Baker Island"
          },
          "84": {
            "name": "Howland Island"
          },
          "86": {
            "name": "Jarvis Island"
          },
          "89": {
            "name": "Kingman Reef"
          },
          "95": {
            "name": "Palmyra Atoll"
          }
        }
      },
      "us": {
        "name": "United States",
        "calling_code": "+1",
        "region": {
          "ak": {
            "name": "Alaska"
          },
          "al": {
            "name": "Alabama"
          },
          "ar": {
            "name": "Arkansas"
          },
          "as": {
            "name": "American Samoa"
          },
          "az": {
            "name": "Arizona"
          },
          "ca": {
            "name": "California"
          },
          "co": {
            "name": "Colorado"
          },
          "ct": {
            "name": "Connecticut"
          },
          "dc": {
            "name": "Washington DC"
          },
          "de": {
            "name": "Delaware"
          },
          "fl": {
            "name": "Florida"
          },
          "ga": {
            "name": "Georgia"
          },
          "gu": {
            "name": "Guam"
          },
          "hi": {
            "name": "Hawaii"
          },
          "ia": {
            "name": "Iowa"
          },
          "id": {
            "name": "Idaho"
          },
          "il": {
            "name": "Illinois"
          },
          "in": {
            "name": "Indiana"
          },
          "ks": {
            "name": "Kansas"
          },
          "ky": {
            "name": "Kentucky"
          },
          "la": {
            "name": "Louisiana"
          },
          "ma": {
            "name": "Massachusetts"
          },
          "md": {
            "name": "Maryland"
          },
          "me": {
            "name": "Maine"
          },
          "mi": {
            "name": "Michigan"
          },
          "mn": {
            "name": "Minnesota"
          },
          "mo": {
            "name": "Missouri"
          },
          "mp": {
            "name": "Northern Mariana Islands"
          },
          "ms": {
            "name": "Mississippi"
          },
          "mt": {
            "name": "Montana"
          },
          "nc": {
            "name": "North Carolina"
          },
          "nd": {
            "name": "North Dakota"
          },
          "ne": {
            "name": "Nebraska"
          },
          "nh": {
            "name": "New Hampshire"
          },
          "nj": {
            "name": "New Jersey"
          },
          "nm": {
            "name": "New Mexico"
          },
          "nv": {
            "name": "Nevada"
          },
          "ny": {
            "name": "New York"
          },
          "oh": {
            "name": "Ohio"
          },
          "ok": {
            "name": "Oklahoma"
          },
          "or": {
            "name": "Oregon"
          },
          "pa": {
            "name": "Pennsylvania"
          },
          "pr": {
            "name": "Puerto Rico"
          },
          "ri": {
            "name": "Rhode Island"
          },
          "sc": {
            "name": "South Carolina"
          },
          "sd": {
            "name": "South Dakota"
          },
          "tn": {
            "name": "Tennessee"
          },
          "tx": {
            "name": "Texas"
          },
          "um": {
            "name": "U.S. Outlying Islands"
          },
          "ut": {
            "name": "Utah"
          },
          "va": {
            "name": "Virginia"
          },
          "vi": {
            "name": "U.S. Virgin Islands"
          },
          "vt": {
            "name": "Vermont"
          },
          "wa": {
            "name": "Washington"
          },
          "wi": {
            "name": "Wisconsin"
          },
          "wv": {
            "name": "West Virginia"
          },
          "wy": {
            "name": "Wyoming"
          }
        }
      },
      "uy": {
        "name": "Uruguay",
        "calling_code": "+598",
        "region": {
          "ar": {
            "name": "Artigas"
          },
          "ca": {
            "name": "Canelones"
          },
          "cl": {
            "name": "Cerro Largo"
          },
          "co": {
            "name": "Colonia"
          },
          "du": {
            "name": "Durazno"
          },
          "fd": {
            "name": "Florida"
          },
          "fs": {
            "name": "Flores"
          },
          "la": {
            "name": "Lavalleja"
          },
          "ma": {
            "name": "Maldonado"
          },
          "mo": {
            "name": "Montevideo"
          },
          "pa": {
            "name": "Paysandú"
          },
          "rn": {
            "name": "Río Negro"
          },
          "ro": {
            "name": "Rocha"
          },
          "rv": {
            "name": "Rivera"
          },
          "sa": {
            "name": "Salto"
          },
          "sj": {
            "name": "San José"
          },
          "so": {
            "name": "Soriano"
          },
          "ta": {
            "name": "Tacuarembó"
          },
          "tt": {
            "name": "Treinta y Tres"
          }
        }
      },
      "uz": {
        "name": "Uzbekistan",
        "calling_code": "+998",
        "region": {
          "an": {
            "name": "Andijan"
          },
          "bu": {
            "name": "Bukhara"
          },
          "fa": {
            "name": "Fergana"
          },
          "ji": {
            "name": "Jizzakh"
          },
          "ng": {
            "name": "Namangan"
          },
          "nw": {
            "name": "Navoiy"
          },
          "qa": {
            "name": "Qashqadaryo"
          },
          "qr": {
            "name": "Karakalpakstan"
          },
          "sa": {
            "name": "Samarqand"
          },
          "si": {
            "name": "Sirdaryo"
          },
          "su": {
            "name": "Surxondaryo"
          },
          "tk": {
            "name": "Tashkent"
          },
          "to": {
            "name": "Tashkent Province"
          },
          "xo": {
            "name": "Xorazm"
          }
        }
      },
      "va": {
        "name": "Holy See (Vatican City State)",
        "calling_code": "+39",
        "region": {}
      },
      "vc": {
        "name": "Saint Vincent and the Grenadines",
        "calling_code": "+1",
        "region": {
          "01": {
            "name": "Charlotte"
          },
          "02": {
            "name": "Saint Andrew"
          },
          "03": {
            "name": "Saint David"
          },
          "04": {
            "name": "Saint George"
          },
          "05": {
            "name": "Saint Patrick"
          },
          "06": {
            "name": "Grenadines"
          }
        }
      },
      "ve": {
        "name": "Venezuela",
        "calling_code": "+58",
        "region": {
          "a": {
            "name": "Capital"
          },
          "b": {
            "name": "Anzoátegui"
          },
          "c": {
            "name": "Apure"
          },
          "d": {
            "name": "Aragua"
          },
          "e": {
            "name": "Barinas"
          },
          "f": {
            "name": "Bolívar"
          },
          "g": {
            "name": "Carabobo"
          },
          "h": {
            "name": "Cojedes"
          },
          "i": {
            "name": "Falcón"
          },
          "j": {
            "name": "Guárico"
          },
          "k": {
            "name": "Lara"
          },
          "l": {
            "name": "Mérida"
          },
          "m": {
            "name": "Miranda"
          },
          "n": {
            "name": "Monagas"
          },
          "o": {
            "name": "Nueva Esparta"
          },
          "p": {
            "name": "Portuguesa"
          },
          "r": {
            "name": "Sucre"
          },
          "s": {
            "name": "Táchira"
          },
          "t": {
            "name": "Trujillo"
          },
          "u": {
            "name": "Yaracuy"
          },
          "v": {
            "name": "Zulia"
          },
          "w": {
            "name": "Federal Dependencies"
          },
          "x": {
            "name": "Vargas"
          },
          "y": {
            "name": "Delta Amacuro"
          },
          "z": {
            "name": "Amazonas"
          }
        }
      },
      "vg": {
        "name": "Virgin Islands, British",
        "calling_code": "+1",
        "region": {}
      },
      "vi": {
        "name": "Virgin Islands, U.S.",
        "calling_code": "+1",
        "region": {}
      },
      "vn": {
        "name": "Vietnam",
        "calling_code": "+84",
        "region": {
          "01": {
            "name": "Lai Châu"
          },
          "02": {
            "name": "Lào Cai"
          },
          "03": {
            "name": "Hà Giang"
          },
          "04": {
            "name": "Cao Bằng"
          },
          "05": {
            "name": "Sơn La"
          },
          "06": {
            "name": "Yên Bái"
          },
          "07": {
            "name": "Tuyên Quang"
          },
          "09": {
            "name": "Lạng Sơn"
          },
          "13": {
            "name": "Quảng Ninh"
          },
          "14": {
            "name": "Hòa Bình"
          },
          "18": {
            "name": "Ninh Bình"
          },
          "20": {
            "name": "Thái Bình"
          },
          "21": {
            "name": "Thanh Hóa"
          },
          "22": {
            "name": "Nghệ An"
          },
          "23": {
            "name": "Hà Tĩnh"
          },
          "24": {
            "name": "Quảng Bình"
          },
          "25": {
            "name": "Quảng Trị"
          },
          "26": {
            "name": "Thừa Thiên–Huế"
          },
          "27": {
            "name": "Quảng Nam"
          },
          "28": {
            "name": "Kon Tum"
          },
          "29": {
            "name": "Quảng Ngãi"
          },
          "30": {
            "name": "Gia Lai"
          },
          "31": {
            "name": "Bình Định"
          },
          "32": {
            "name": "Phú Yên"
          },
          "33": {
            "name": "Đắk Lắk"
          },
          "34": {
            "name": "Khánh Hòa"
          },
          "35": {
            "name": "Lâm Đồng"
          },
          "36": {
            "name": "Ninh Thuận"
          },
          "37": {
            "name": "Tây Ninh"
          },
          "39": {
            "name": "Đồng Nai"
          },
          "40": {
            "name": "Bình Thuận"
          },
          "41": {
            "name": "Long An"
          },
          "43": {
            "name": "Bà Rịa–Vũng Tàu"
          },
          "44": {
            "name": "An Giang"
          },
          "45": {
            "name": "Đồng Tháp"
          },
          "46": {
            "name": "Tiền Giang"
          },
          "47": {
            "name": "Kiên Giang"
          },
          "49": {
            "name": "Vĩnh Long"
          },
          "50": {
            "name": "Bến Tre"
          },
          "51": {
            "name": "Trà Vinh"
          },
          "52": {
            "name": "Sóc Trăng"
          },
          "53": {
            "name": "Bắc Kạn"
          },
          "54": {
            "name": "Bắc Giang"
          },
          "55": {
            "name": "Bạc Liêu"
          },
          "56": {
            "name": "Bắc Ninh"
          },
          "57": {
            "name": "Bình Dương"
          },
          "58": {
            "name": "Bình Phước"
          },
          "59": {
            "name": "Cà Mau"
          },
          "61": {
            "name": "Hải Dương"
          },
          "63": {
            "name": "Hà Nam"
          },
          "66": {
            "name": "Hưng Yên"
          },
          "67": {
            "name": "Nam Định"
          },
          "68": {
            "name": "Phú Thọ"
          },
          "69": {
            "name": "Thái Nguyên"
          },
          "70": {
            "name": "Vĩnh Phúc"
          },
          "71": {
            "name": "Điện Biên"
          },
          "72": {
            "name": "Đắk Nông"
          },
          "73": {
            "name": "Hậu Giang"
          },
          "ct": {
            "name": "Can Tho"
          },
          "dn": {
            "name": "Da Nang"
          },
          "hn": {
            "name": "Hanoi"
          },
          "hp": {
            "name": "Haiphong"
          },
          "sg": {
            "name": "Ho Chi Minh City"
          }
        }
      },
      "vu": {
        "name": "Vanuatu",
        "calling_code": "+678",
        "region": {
          "map": {
            "name": "Malampa"
          },
          "pam": {
            "name": "Penama"
          },
          "sam": {
            "name": "Sanma"
          },
          "see": {
            "name": "Shefa"
          },
          "tae": {
            "name": "Tafea"
          },
          "tob": {
            "name": "Torba"
          }
        }
      },
      "wf": {
        "name": "Wallis and Futuna",
        "calling_code": "+681",
        "region": {
          "al": {
            "name": "Alo"
          },
          "sg": {
            "name": "Sigave"
          },
          "uv": {
            "name": "Uvea"
          }
        }
      },
      "ws": {
        "name": "Samoa",
        "calling_code": "+685",
        "region": {
          "aa": {
            "name": "A’ana"
          },
          "al": {
            "name": "Aiga-i-le-Tai"
          },
          "at": {
            "name": "Atua"
          },
          "fa": {
            "name": "Fa’asaleleaga"
          },
          "ge": {
            "name": "Gaga’emauga"
          },
          "gi": {
            "name": "Gaga’ifomauga"
          },
          "pa": {
            "name": "Palauli"
          },
          "sa": {
            "name": "Satupa’itea"
          },
          "tu": {
            "name": "Tuamasaga"
          },
          "vf": {
            "name": "Va’a-o-Fonoti"
          },
          "vs": {
            "name": "Vaisigano"
          }
        }
      },
      "ye": {
        "name": "Yemen",
        "calling_code": "+967",
        "region": {
          "ab": {
            "name": "Abyan"
          },
          "ad": {
            "name": "’Adan"
          },
          "am": {
            "name": "Amran"
          },
          "ba": {
            "name": "Al Bayda"
          },
          "da": {
            "name": "Dhale"
          },
          "dh": {
            "name": "Dhamar"
          },
          "hd": {
            "name": "Hadramaut"
          },
          "hj": {
            "name": "Hajjah"
          },
          "hu": {
            "name": "Al Hudaydah"
          },
          "ib": {
            "name": "Ibb"
          },
          "ja": {
            "name": "Al Jawf"
          },
          "la": {
            "name": "Lahij"
          },
          "ma": {
            "name": "Ma’rib"
          },
          "mr": {
            "name": "Al Mahrah"
          },
          "mw": {
            "name": "Al Mahwit"
          },
          "ra": {
            "name": "Raymah"
          },
          "sa": {
            "name": "Amanat Al Asimah"
          },
          "sd": {
            "name": "Sa’dah"
          },
          "sh": {
            "name": "Shabwah"
          },
          "sn": {
            "name": "Sana’a"
          },
          "su": {
            "name": "Arkhabil Suqutra"
          },
          "ta": {
            "name": "Taiz"
          }
        }
      },
      "yt": {
        "name": "Mayotte",
        "calling_code": "+262",
        "region": {}
      },
      "za": {
        "name": "South Africa",
        "calling_code": "+27",
        "region": {
          "ec": {
            "name": "Eastern Cape"
          },
          "fs": {
            "name": "Free State"
          },
          "gp": {
            "name": "Gauteng"
          },
          "lp": {
            "name": "Limpopo"
          },
          "mp": {
            "name": "Mpumalanga"
          },
          "nc": {
            "name": "Northern Cape"
          },
          "nw": {
            "name": "North West"
          },
          "wc": {
            "name": "Western Cape"
          },
          "zn": {
            "name": "KwaZulu-Natal"
          }
        }
      },
      "zm": {
        "name": "Zambia",
        "calling_code": "+260",
        "region": {
          "01": {
            "name": "Western"
          },
          "02": {
            "name": "Central"
          },
          "03": {
            "name": "Eastern"
          },
          "04": {
            "name": "Luapula"
          },
          "05": {
            "name": "Northern"
          },
          "06": {
            "name": "North-Western"
          },
          "07": {
            "name": "Southern"
          },
          "08": {
            "name": "Copperbelt"
          },
          "09": {
            "name": "Lusaka"
          },
          "10": {
            "name": "Muchinga"
          }
        }
      },
      "zw": {
        "name": "Zimbabwe",
        "calling_code": "+263",
        "region": {
          "bu": {
            "name": "Bulawayo"
          },
          "ha": {
            "name": "Harare"
          },
          "ma": {
            "name": "Manicaland"
          },
          "mc": {
            "name": "Mashonaland Central"
          },
          "me": {
            "name": "Mashonaland East"
          },
          "mi": {
            "name": "Midlands"
          },
          "mn": {
            "name": "Matabeleland North"
          },
          "ms": {
            "name": "Matabeleland South"
          },
          "mv": {
            "name": "Masvingo"
          },
          "mw": {
            "name": "Mashonaland West"
          }
        }
      }
    }
  }
})
